{
  "menu": {
    "category": {
      "userManagement": "Gestión de Usuarios",
      "settings": "Configuración",
      "securityCompliance": "Seguridad y Cumplimiento",
      "adminTools": "Herramientas de Admin",
      "internalAdminTools": "Herramientas Internas",
      "system": "Sistema",
      "orgAdmin": "Administrador de la organización",
      "communication": "Comunicación",
      "widget": "Widget",
      "feature": "Funcionalidades",
      "admin": "Administración",
      "sidecar": "Móvil",
      "auth": "Autenticación",
      "sf": "Salesforce",
      "crm": "CRM",
      "tuvis-mobile": "Tuvis Remote Sync",
      "tuvis-desktop": "Tuvis Desktop App",
      "integrations": "Integraciones",
      "integrationsChannels": "Canales",
      "other": "Canales",
      "platforms": "Plataformas",
      "archive": "Archivo",
      "notifications": "Notificaciones",
      "tuvisAdmin": "Administración Tuvis"
    }
  },
  "bot_builder": {
    "title": "Constructor de Bots",
    "variable_name_required": "El nombre de la variable es obligatorio",
    "variable_name_reserved_prefix": "Los nombres de variables no pueden comenzar con $ (reservado para funciones integradas)",
    "variable_name_no_spaces": "Los nombres de variables no pueden contener espacios",
    "nav_flows": "Flujos",
    "nav_analytics": "Analítica",
    "nav_credentials": "Credenciales",
    "nav_sessions": "Sesiones",
    "nav_triggers": "Disparos",
    "nav_settings": "Configuración",
    "sessions": {
      "title": "Sesiones",
      "sender": "Remitente",
      "flow": "Flujo",
      "status": "Estado",
      "started_at": "Iniciado",
      "last_activity": "Última actividad",
      "duration": "Duración",
      "current_node": "Nodo actual",
      "flow_version": "Versión del flujo",
      "all_flows": "Todos los flujos",
      "all_statuses": "Todos los estados",
      "no_sessions": "No se encontraron sesiones",
      "event_timeline": "Línea de eventos",
      "event_type": "Evento",
      "event_node": "Nodo",
      "event_time": "Hora",
      "event_error": "Error",
      "no_events": "No hay eventos registrados para esta sesión",
      "debug_title": "Depuración de sesión",
      "back_to_sessions": "Volver a sesiones",
      "stop": "Detener",
      "stop_confirm_title": "¿Detener sesión?",
      "stop_confirm_body": "Esto finalizará la sesión inmediatamente. El próximo mensaje del usuario iniciará una nueva sesión.",
      "handoff": "Transferencia",
      "status_labels": {
        "active": "Activa",
        "waiting_input": "Esperando respuesta",
        "handoff": "Transferencia",
        "completed": "Completada",
        "expired": "Expirada",
        "error": "Error",
        "stopped": "Detenida",
        "replaced": "Reemplazada"
      },
      "refresh": "Actualizar",
      "back_to_session": "Volver a la sesión",
      "activity": {
        "title": "Actividad de la sesión en este nodo",
        "visits": "Visitas",
        "errors": "Errores",
        "no_activity": "Este nodo no se ha visitado en esta sesión"
      },
      "event_data": {
        "sender": "Remitente",
        "phone_id": "ID de teléfono",
        "type": "Tipo",
        "text": "Texto",
        "template": "Plantilla",
        "params": "Parámetros",
        "flow_id": "ID de flujo",
        "cta": "CTA",
        "input": "Entrada",
        "variable": "Variable",
        "request": "Solicitud",
        "status": "Estado",
        "duration": "Duración",
        "error": "Error",
        "response_body": "Cuerpo de respuesta",
        "model": "Modelo",
        "input_tokens": "Tokens de entrada",
        "output_tokens": "Tokens de salida",
        "response": "Respuesta",
        "reason": "Razón",
        "message": "Mensaje",
        "empty_value": "(vacío)"
      },
      "source": "Source",
      "triggered_by": "Triggered By",
      "trigger_batch": "Trigger Batch",
      "replaced_by": "Reemplazada por",
      "all_sources": "All Sources",
      "source_labels": {
        "message": "Message",
        "ui": "UI",
        "api": "API"
      }
    },
    "analytics": {
      "select_flow": "Seleccionar un flujo",
      "select_flow_hint": "Selecciona un flujo para ver analíticas",
      "date_range": "Rango de fechas",
      "total_sessions": "Sesiones Totales",
      "completed_sessions": "Sesiones Completadas",
      "completion_rate": "Tasa de Finalización",
      "handoffs": "Transferencias",
      "handoff_rate": "Tasa de Transferencia",
      "errors": "Errores",
      "expired_sessions": "Sesiones Expiradas",
      "active_sessions": "Sesiones Activas",
      "sessions_over_time": "Sesiones a lo Largo del Tiempo",
      "load_error": "Error al cargar"
    },
    "palette": {
      "title": "Bloques de Construcción",
      "ai_no_providers": "Conecta un proveedor de IA en integraciones para usar este nodo",
      "transcribe_no_providers": "Conecta un proveedor de transcripción de audio en integraciones para usar este nodo"
    },
    "create_flow": "+ Crear Flujo",
    "assign_to_phone": "Asignar a teléfono",
    "edit_flow": "Editar Flujo",
    "edit_flow_metadata": "Editar Nombre y Descripción",
    "update_flow_success": "Flujo actualizado correctamente",
    "update_flow_failure": "Error al actualizar el flujo",
    "delete_flow": "Eliminar Flujo",
    "publish_flow": "Publicar Flujo",
    "publish_latest_version": "Publicar Última Versión",
    "unpublish_flow": "Despublicar Flujo",
    "archive_flow": "Archivar Flujo",
    "name": "Nombre",
    "channel": "Canal",
    "description": "Descripción",
    "status": "Estado",
    "status_draft": "Borrador",
    "status_published": "Publicado",
    "status_archived": "Archivado",
    "version": "Última Versión",
    "published_version": "Versión Publicada",
    "published_at": "Publicado el",
    "updated_at": "Actualizado el",
    "created_at": "Creado el",
    "create_flow_success": "Flujo creado correctamente",
    "create_flow_failure": "Error al crear el flujo",
    "save_flow_success": "Flujo guardado correctamente",
    "save_flow_failure": "Error al guardar el flujo",
    "publish_flow_success": "Flujo publicado correctamente",
    "publish_flow_failure": "Error al publicar el flujo",
    "validation_errors": {
      "flow_missing_start_node": "El flujo debe tener un nodo de inicio",
      "start_node_no_outgoing": "El nodo de inicio debe tener al menos una conexión saliente",
      "edge_invalid_source": "Una conexión referencia un nodo de origen inexistente",
      "edge_invalid_target": "Una conexión referencia un nodo de destino inexistente",
      "wait_reply_missing_variable": "El nodo Esperar Respuesta debe tener un nombre de variable",
      "send_message_missing_content": "El nodo Enviar Mensaje debe tener contenido",
      "send_message_missing_text": "El nodo Enviar Mensaje debe tener un texto",
      "template_missing_name": "El nodo Enviar Mensaje debe tener una plantilla seleccionada",
      "interactive_flow_missing_flow": "El nodo Enviar Mensaje debe tener un WhatsApp Flow seleccionado",
      "api_call_missing_url": "El nodo Llamada API debe tener una URL",
      "api_call_missing_method": "El nodo Llamada API debe tener un método HTTP",
      "send_message_missing_message_type": "El nodo Enviar Mensaje debe tener un tipo de mensaje",
      "duplicate_variable_name": "El nombre de la variable ya está en uso por otro nodo",
      "interactive_flow_missing_body": "El nodo WhatsApp Flow debe tener un cuerpo de mensaje",
      "interactive_flow_missing_cta": "El nodo WhatsApp Flow debe tener un texto de botón",
      "interactive_flow_missing_screen": "El nodo WhatsApp Flow debe tener una pantalla inicial seleccionada",
      "ai_missing_prompt": "El nodo IA debe tener un prompt",
      "ai_missing_response_variable": "El nodo IA debe tener una variable de respuesta",
      "variable_name_reserved_prefix": "Los nombres de variables no pueden comenzar con $ (reservado para funciones integradas)",
      "variable_name_no_spaces": "Los nombres de variables no pueden contener espacios",
      "set_variable_missing_assignments": "El nodo Definir Variable debe tener al menos una asignación",
      "set_variable_missing_target": "La asignación debe tener un nombre de variable",
      "flow_variable_missing_name": "La variable del flujo debe tener un nombre",
      "transcribe_missing_source_variable": "Falta la variable de origen",
      "transcribe_missing_response_variable": "Falta la variable de respuesta"
    },
    "unpublish_flow_success": "Flujo revertido a borrador",
    "unpublish_flow_failure": "Error al despublicar el flujo",
    "delete_flow_success": "Flujo eliminado correctamente",
    "delete_flow_failure": "Error al eliminar el flujo",
    "clone_flow": "Clonar flujo",
    "clone_flow_success": "Flujo clonado",
    "clone_flow_failure": "Error al clonar el flujo",
    "clone_modal": {
      "title": "Clonar flujo de bot",
      "name_label": "Nombre del nuevo flujo",
      "scope_label": "Qué copiar",
      "scope_all": "Todas las versiones",
      "scope_latest": "Solo la última versión",
      "submit": "Clonar"
    },
    "compare": {
      "title": "Comparar v{{left}} vs v{{right}}",
      "version_x": "Versión {{version}}",
      "fields_diff": "Configuración y variables",
      "fields_no_changes": "Sin cambios en la configuración ni variables",
      "minutes_value": "{{count}} min",
      "variable_label_plural": "Variables",
      "variable_required": "requerida",
      "variable_field_required": "Requerida",
      "variable_field_defaultValue": "Valor por defecto",
      "variable_field_description": "Descripción",
      "select_two": "Selecciona exactamente dos versiones para comparar",
      "compare_button": "Comparar seleccionadas",
      "start_compare": "Comparar versiones",
      "cancel_compare": "Cancelar",
      "summary_modified": "{{count}} modificadas",
      "summary_added": "{{count}} añadidas",
      "summary_removed": "{{count}} eliminadas",
      "legend_added": "Añadido",
      "legend_removed": "Eliminado",
      "legend_modified": "Modificado",
      "legend_unchanged": "Sin cambios",
      "changes_panel_title": "Cambios",
      "changes_section_added": "Añadidas",
      "changes_section_modified": "Modificadas",
      "changes_section_removed": "Eliminadas",
      "changes_empty": "Sin cambios",
      "mode_side_by_side": "Lado a lado",
      "mode_overlay": "Superpuesto",
      "drilldown_title": "Cambios en campos",
      "drilldown_no_data_changes": "Solo cambió metadata (posición, etiqueta, etc.)",
      "page_title": "Comparar v{{left}} vs v{{right}}",
      "invalid_range": "Rango de versiones inválido",
      "back": "Volver al flujo"
    },
    "assign_phones_success": "Números de teléfono asignados correctamente",
    "assign_phones_failure": "Error al asignar los números de teléfono",
    "confirm_publish_title": "Publicar Flujo",
    "confirm_publish_body": "Este flujo se activará y comenzará a gestionar conversaciones. ¿Estás seguro?",
    "confirm_unpublish_title": "Despublicar Flujo",
    "confirm_unpublish_body": "Este flujo volverá a borrador y dejará de gestionar conversaciones. ¿Estás seguro?",
    "confirm_delete_title": "Eliminar Flujo",
    "confirm_delete_body": "Este flujo será eliminado permanentemente y no podrá recuperarse. ¿Estás seguro?",
    "unsaved_confirm_title": "Cambios sin guardar",
    "unsaved_confirm_body": "Tienes cambios sin guardar. ¿Seguro que quieres salir?",
    "settings": {
      "title": "Configuración del Bot",
      "session_history_retention": "Retención del historial de sesiones",
      "session_history_retention_description": "Cuánto tiempo conservar los datos de sesiones completadas para depuración y análisis.",
      "retention_days": "{{days}} días",
      "retention_saved": "Configuración de retención guardada",
      "retention_save_failed": "Error al guardar la configuración de retención",
      "save": "Guardar"
    },
    "test": "Probar",
    "save": "Guardar",
    "publish": "Publicar",
    "test_chat": {
      "title": "Chat de Prueba",
      "start": "Iniciar Prueba",
      "reset": "Reiniciar",
      "send": "Enviar",
      "empty_state": "Prueba tu flujo simulando una conversación. Los mensajes no se enviarán por WhatsApp.",
      "type_message": "Escribe un mensaje...",
      "waiting": "El bot está procesando...",
      "session_ended": "Sesión finalizada",
      "session_handoff": "Transferido a agente",
      "variables": "Variables",
      "text_mode": "Texto",
      "flow_reply_mode": "Respuesta Flow"
    },
    "unsaved": "Sin guardar",
    "unpublished_changes": "Cambios sin publicar",
    "versions": "Versiones",
    "version_history": "Historial de Versiones",
    "version_x": "Versión {{version}}",
    "current": "Actual",
    "no_versions": "Sin versiones publicadas",
    "viewing_version": "Viendo versión {{version}}",
    "back_to_draft": "Volver al borrador",
    "publish_this_version": "Publicar esta versión",
    "was_published": "Publicado anteriormente",
    "save_modal": {
      "title": "Guardar Cambios",
      "subtitle": "Esto creará una nueva versión de tu flujo.",
      "description_placeholder": "Describa qué cambió (opcional)"
    },
    "publish_modal": {
      "title": "Publicar Flujo",
      "body": "¿Está seguro de que desea publicar la versión {{version}}? Esto la activará para todos los números de teléfono asignados."
    },
    "flow_settings_title": "Configuración del Flujo",
    "session_duration_label": "Duración de la Sesión (minutos)",
    "session_duration_placeholder": "Sin tiempo límite",
    "session_duration_hint": "Deje vacío o 0 para sin tiempo límite de sesión.",
    "session_expired_message_label": "Mensaje de Sesión Expirada",
    "session_expired_message_placeholder": "Su sesión ha expirado. Envíe un mensaje para comenzar de nuevo.",
    "session_expired_message_hint": "Enviado cuando la sesión expira. Use {{variable}} para insertar valores, o {{variable|predeterminado}} para un valor alternativo si la variable no está definida.",
    "inactivity_timeout_label": "Tiempo Límite de Inactividad (minutos)",
    "inactivity_timeout_placeholder": "Sin tiempo límite",
    "inactivity_timeout_hint": "La sesión expira si el usuario no responde dentro de este tiempo. Se reinicia con cada mensaje.",
    "inactivity_timeout_message_label": "Mensaje de Tiempo Límite de Inactividad",
    "inactivity_timeout_message_placeholder": "No hemos recibido tu respuesta. Tu sesión ha finalizado.",
    "inactivity_timeout_message_hint": "Enviado cuando la sesión expira por inactividad. Use {{variable}} para insertar valores, o {{variable|predeterminado}} para un valor alternativo si la variable no está definida.",
    "unsaved_confirm_leave": "Salir",
    "unsaved_confirm_stay": "Quedarse",
    "modal": {
      "create_title": "Crear Flujo",
      "edit_title": "Editar Flujo",
      "edit_subtitle": "Actualiza el nombre y la descripción del flujo. Esto no afectará ninguna versión.",
      "name_label": "Nombre del Flujo",
      "name_placeholder": "Ingresa el nombre del flujo",
      "description_label": "Descripción",
      "description_placeholder": "Ingresa la descripción del flujo"
    },
    "flow_type_label": "Tipo de flujo",
    "flow_type_sms": "SMS",
    "flow_type_whatsapp": "WhatsApp",
    "flow_type_help": "Los flujos SMS solo pueden enviar texto libre. Los flujos WhatsApp pueden enviar texto libre o plantillas.",
    "flow_type_locked_template": "No se puede cambiar el tipo de flujo si algún nodo Enviar mensaje usa plantilla. Elimine o cambie esos nodos primero.",
    "filter_modal": {
      "title": "Configurar un filtro",
      "close": "Cerrar",
      "label": "Etiqueta",
      "label_placeholder": "ej. ruta de éxito",
      "label_max": "Máximo 120 caracteres.",
      "condition": "Condición",
      "no_condition_hint": "Sin condición = esta ruta se usa cuando no coincide ninguna otra (respaldo).",
      "all_rules_and": "Todas las reglas (Y)",
      "any_rule_or": "Cualquier regla (O)",
      "add_and_rule": "Añadir regla Y",
      "add_or_rule": "Añadir regla O",
      "add_rule": "Añadir regla",
      "value_placeholder": "Valor",
      "variables": "Variables",
      "flow_variables": "Variables del Flujo",
      "fallback_description": "Establecer la ruta como respaldo. Una ruta de respaldo se usa si los datos no pasaron por ninguna otra ruta. Un nodo solo puede tener una ruta de respaldo.",
      "fallback_confirm_title": "Reemplazar ruta de respaldo",
      "fallback_confirm_body": "Otra arista de este nodo ya está configurada como ruta de respaldo. Solo se permite una ruta de respaldo por nodo. ¿Desea reemplazarla?",
      "yes": "Sí",
      "no": "No",
      "order": "Orden",
      "order_of": "{{current}} de {{total}}",
      "move_up": "Subir",
      "move_down": "Bajar",
      "delete_edge": "Eliminar arista",
      "operator_equals": "Texto: Igual a",
      "operator_not_equals": "Texto: Distinto de",
      "operator_contains": "Texto: Contiene",
      "operator_not_contains": "Texto: No contiene",
      "operator_starts_with": "Texto: Comienza con",
      "operator_ends_with": "Texto: Termina con",
      "operator_regex": "Texto: Coincide con regex",
      "operator_greater_than": "Numérico: Mayor que",
      "operator_less_than": "Numérico: Menor que",
      "operator_is_empty": "Existencia: Está vacío",
      "operator_is_not_empty": "Existencia: No está vacío",
      "trigger_sources_label": "Active for trigger sources",
      "trigger_sources_hint": "This edge only fires if the session was triggered by one of the selected sources. Uncheck to restrict."
    },
    "assign_modal": {
      "title": "Asignar bot al número de teléfono",
      "phone_label": "Número de teléfono",
      "phone_placeholder": "Seleccionar teléfono WABA",
      "trigger_all_messages": "Activar en todos los mensajes",
      "trigger_new_conversations_only": "Solo en conversaciones nuevas",
      "trigger_keywords_label": "Palabras clave (separadas por comas)",
      "trigger_keywords_placeholder": "hola, inicio, menú",
      "current_assignments": "Asignaciones actuales",
      "remove": "Quitar",
      "assign_success": "Bot asignado al número",
      "assign_failure": "Error al asignar el bot",
      "fill_required": "Complete todos los campos obligatorios"
    },
    "node_config": {
      "configure_node": "Configurar Nodo",
      "close": "Cerrar",
      "label": "Etiqueta",
      "label_placeholder": "Etiqueta del nodo",
      "type_start": "Inicio",
      "type_send_message": "Enviar Mensaje",
      "type_wait_for_reply": "Esperar Respuesta",
      "type_api_call": "Llamada API",
      "type_human_handoff": "Transferir a Agente",
      "type_ai": "IA",
      "type_transcribe": "Transcribir",
      "type_set_variable": "Definir Variable",
      "set_variable_hint": "Asigna una o más variables. Cada valor puede combinar texto, variables existentes {{var}} y funciones {{$uuid}}, {{$sessionId}}, {{$random:1:100}}, {{$randomFloat:0:1}}, {{$timestamp}}, {{$now}}.",
      "set_variable_target": "Nombre de la variable",
      "set_variable_target_placeholder": "ej. orderId",
      "set_variable_value": "Valor",
      "set_variable_value_placeholder": "ej. order-{{$uuid}}",
      "set_variable_add_assignment": "+ Añadir asignación",
      "set_variable_functions_group": "Funciones",
      "delete_node": "Eliminar Nodo",
      "unknown_node_type": "Tipo de nodo desconocido",
      "captures": "Captura",
      "all_messages": "Todos los mensajes",
      "no_content": "Sin contenido",
      "trigger_keywords": "Palabras clave de activación (separadas por comas)",
      "text": "Texto",
      "free_text": "Texto",
      "template": "Plantilla",
      "message_type": "Tipo de Mensaje",
      "message_text": "Texto del Mensaje",
      "message_text_hint": "Use {{variable}} para insertar valores, o {{variable|predeterminado}} como alternativa. Ej: Hola {{userName|amigo}}!",
      "message_separator": "Separador de mensajes",
      "message_separator_hint": "Opcional, máximo 32 caracteres. Cuando se establece, el texto se divide en varios mensajes de WhatsApp donde esta cadena aparece en su propia línea (ej. ---). Déjelo vacío para enviar como un solo mensaje.",
      "media_url": "URL de Medios",
      "media_type": "Tipo de Medio",
      "image": "Imagen",
      "video": "Video",
      "audio": "Audio",
      "document": "Documento",
      "template_name": "Nombre de Plantilla",
      "language": "Idioma",
      "select_template": "Seleccionar plantilla",
      "no_templates_available": "No hay plantillas disponibles",
      "no_templates_hint": "Vaya a la configuración de WhatsApp Business para crear y publicar plantillas.",
      "header_params": "Parámetros de Encabezado",
      "body_params": "Parámetros del Cuerpo",
      "button_params": "Botón",
      "template_preview": "Vista Previa de Plantilla",
      "template_params_hint": "Usa {{variable}} para insertar valores de sesión. Ej: {{userReply.text}}",
      "offer_code": "Código de Oferta",
      "whatsapp_flow": "WhatsApp Flow",
      "flow_name": "Flujo",
      "flow_cta": "Texto del botón",
      "flow_cta_placeholder": "Continuar",
      "flow_body": "Cuerpo del mensaje",
      "flow_header": "Encabezado (opcional)",
      "flow_footer": "Pie de página (opcional)",
      "no_flows_available": "No hay flujos de WhatsApp disponibles",
      "select_flow": "Seleccionar un flujo",
      "flow_screen": "Pantalla inicial",
      "select_screen": "Seleccionar una pantalla",
      "no_screens_available": "No hay pantallas disponibles",
      "select_flow_first": "Seleccione un flujo primero",
      "refresh_templates": "Recargar plantillas",
      "refresh_flows": "Recargar flujos",
      "interactive_type": "Tipo Interactivo",
      "buttons_up_to_3": "Botones (hasta 3)",
      "list": "Lista",
      "body_text": "Texto del Cuerpo",
      "header_optional": "Encabezado (opcional)",
      "footer_optional": "Pie de página (opcional)",
      "buttons": "Botones",
      "add_button": "Agregar Botón",
      "list_button_text": "Texto del Botón de Lista",
      "list_rows": "Filas de Lista",
      "add_row": "Agregar Fila",
      "store_reply_variable": "Almacenar respuesta en variable",
      "expected_message_types": "Tipos de mensaje aceptados",
      "expected_message_types_hint": "Solo aceptar estos tipos de mensaje. Dejar vacío para aceptar todos los tipos. Si el usuario envía otro tipo, se envía el mensaje de error y el nodo sigue esperando.",
      "expected_types_placeholder": "Todos los tipos aceptados",
      "max_file_size_label": "Tamaño máximo de archivo (MB)",
      "max_file_size_hint": "Tamaño máximo de archivo en MB (1-16). Por defecto 16 MB.",
      "body_variable_hint": "Escribe {{ para insertar una variable",
      "expected_type_text": "Texto",
      "expected_type_interactive": "Interactivo (WhatsApp Flow)",
      "expected_type_button": "Botón",
      "expected_type_image": "Imagen",
      "expected_type_document": "Documento",
      "expected_type_audio": "Audio",
      "expected_type_video": "Video",
      "timeout_seconds": "Tiempo límite (segundos)",
      "on_timeout_go_to": "Al expirar ir a",
      "select_node": "Seleccionar nodo",
      "validation_regex": "Regex de Validación",
      "invalid_input_message": "Mensaje de Entrada Inválida",
      "invalid_input_message_placeholder": "Por favor proporciona una respuesta válida.",
      "authentication_type": "Tipo de autenticación *",
      "auth_none": "Ninguno",
      "auth_bearer": "Token Bearer",
      "auth_basic": "Autenticación Básica",
      "auth_api_key": "Clave de API",
      "auth_hint": "Seleccione el tipo de autenticación para una llamada de API o webhook autenticado.",
      "bearer_token_label": "Token Bearer",
      "username": "Usuario",
      "password": "Contraseña",
      "header_name": "Nombre del encabezado",
      "value": "Valor",
      "url_label": "URL *",
      "url_hint": "Ingrese la URL de un endpoint de API (incluyendo la URL base), comenzando con https://.",
      "method_label": "Método *",
      "method_hint": "Seleccione el método de solicitud HTTP.",
      "headers": "Encabezados",
      "headers_hint": "Agregue encabezados personalizados para la solicitud.",
      "name_placeholder": "Nombre",
      "value_placeholder": "Valor",
      "add_header": "+ Agregar encabezado",
      "query_parameters": "Parámetros de consulta",
      "query_parameters_hint": "Agregue parámetros para métodos GET y DELETE.",
      "add_parameter": "+ Agregar parámetro",
      "body_content": "Contenido del cuerpo",
      "body_content_hint": "Seleccione el formato del cuerpo. Usado principalmente para POST, PUT y PATCH.",
      "body_json": "JSON",
      "body_form_urlencoded": "application/x-www-form-urlencoded",
      "body_multipart": "multipart/form-data (soporta carga de archivos)",
      "body_raw": "Raw",
      "add_field": "+ Agregar campo",
      "parse_response": "Analizar respuesta",
      "yes": "Sí",
      "no": "No",
      "parse_response_hint": "Estructure la salida para usarla en variables. Ejecute el flujo una vez para mapear resultados.",
      "pagination_type": "Tipo de paginación",
      "pagination_offset": "Desplazamiento",
      "pagination_cursor": "Cursor",
      "pagination_page_number": "Número de página",
      "pagination_hint": "Use si la API devuelve resultados divididos en varias páginas.",
      "select_pagination_type": "Seleccionar tipo de paginación",
      "response_variable": "Variable de respuesta",
      "response_variable_hint": "Nombre de la variable para almacenar la respuesta (ej. para condiciones o mensajes).",
      "retry": "Reintentos",
      "retry_count": "Cantidad de reintentos",
      "retry_delay": "Demora entre reintentos (ms)",
      "retry_hint": "Reintenta solo en errores de red, timeouts o fallos de conexión. Las respuestas HTTP (incluyendo 4xx/5xx) no se reintentan - se almacenan en la variable de respuesta para evaluación de condiciones.",
      "request_timeout": "Tiempo de espera",
      "request_timeout_seconds": "Tiempo de espera (segundos)",
      "request_timeout_hint": "Tiempo máximo de espera para una respuesta. Por defecto 10 segundos, máximo 120 segundos.",
      "file_attachment": "Archivo adjunto",
      "file_variable": "Variable del archivo",
      "file_field_name": "Nombre del campo",
      "file_attachment_hint": "Variable que contiene el archivo (ej. userReply). El archivo de S3 se envía como multipart. Para cuerpo JSON, usa {{userReply.filePath}} - se resuelve automáticamente a una URL de descarga.",
      "debounce_label": "Espera de mensajes",
      "debounce_hint": "Esperar por mensajes adicionales antes de procesar. Útil cuando los usuarios dividen su entrada en varios mensajes.",
      "debounce_unit_ms": "ms",
      "debounce_unit_sec": "seg",
      "debounce_unit_min": "min",
      "handoff_reason": "Motivo de Transferencia",
      "handoff_reason_placeholder": "El usuario solicitó un agente",
      "handoff_message": "Mensaje de Transferencia",
      "handoff_message_placeholder": "Transfiriéndote a un agente...",
      "ai_model": "Modelo",
      "ai_model_default": "Predeterminado",
      "ai_system_prompt": "Prompt del Sistema",
      "ai_system_prompt_placeholder": "Configura el rol y comportamiento de la IA...",
      "ai_prompt": "Prompt",
      "ai_prompt_placeholder": "Ingresa el prompt para la IA...",
      "ai_response_variable": "Variable de Respuesta",
      "ai_temperature": "Temperatura",
      "ai_max_tokens": "Tokens Máximos de Salida",
      "ai_improve_prompt": "Mejorar prompt",
      "ai_context_instructions": "Instrucciones de Contexto",
      "ai_context_instructions_placeholder": "Define el rol, personalidad y conocimiento de la IA...",
      "ai_context_instructions_hint": "Establece el comportamiento y conocimiento de la IA para este nodo",
      "ai_include_history": "Incluir historial de conversación",
      "ai_max_history_turns": "Máximo de turnos de historial",
      "ai_max_history_turns_hint": "Número de pares de mensajes recientes a incluir (1-50)",
      "ai_history_enabled": "Historial habilitado",
      "ai_improving_prompt": "Mejorando...",
      "ai_prompt_strength_weak": "Prompt débil",
      "ai_prompt_strength_medium": "Prompt medio",
      "ai_prompt_strength_strong": "Prompt fuerte",
      "ai_advanced": "Configuración Avanzada",
      "target_agent_id": "ID del Agente Destino",
      "auth_oauth2_mtls": "OAuth2 mTLS",
      "credential_label": "Credencial de API",
      "select_credential": "Seleccionar credencial",
      "credential_hint": "Seleccione una credencial OAuth2 mTLS para autenticarse con el endpoint de la API.",
      "credential_hint_oauth2": "Seleccione una credencial OAuth2 para autenticarse con el endpoint de la API",
      "credential_hint_mtls": "Seleccione una credencial OAuth2 mTLS para autenticarse con el endpoint de la API",
      "auth_oauth2": "OAuth2",
      "transcribe_source_variable": "Variable de origen",
      "transcribe_source_variable_hint": "Variable de un paso anterior que capturó un mensaje de voz (p. ej. \"userReply\"). El nodo lee <variable>.filePath.",
      "transcribe_response_variable": "Variable de respuesta",
      "transcribe_response_variable_hint": "Guarda el texto transcrito en <variable>.text y el proveedor en <variable>.provider. Se establece en true en <variable>.skipped cuando el audio supera el límite de tamaño.",
      "transcribe_from": "desde",
      "transcribe_to": "a",
      "add_credential": "+ Agregar Credencial"
    },
    "credentials": {
      "title": "Credenciales de API",
      "manage": "Administrar Credenciales",
      "create": "Crear",
      "create_title": "Crear Credencial",
      "edit": "Editar",
      "edit_title": "Editar Credencial",
      "save": "Guardar",
      "cancel": "Cancelar",
      "delete": "Eliminar",
      "delete_confirm": "¿Está seguro de que desea eliminar esta credencial?",
      "name": "Nombre",
      "description": "Descripción",
      "token_endpoint": "Endpoint de Token",
      "client_id": "ID de Cliente",
      "client_secret": "Secreto de Cliente",
      "grant_type": "Tipo de Concesión",
      "scope": "Alcance",
      "client_cert": "Certificado de Cliente",
      "client_key": "Clave de Cliente",
      "actions": "Acciones",
      "create_success": "Credencial creada correctamente",
      "create_failure": "Error al crear la credencial",
      "save_success": "Credencial actualizada correctamente",
      "save_failure": "Error al actualizar la credencial",
      "delete_success": "Credencial eliminada correctamente",
      "delete_failure": "Error al eliminar la credencial",
      "delete_confirm_title": "Eliminar Credencial",
      "type": "Tipo",
      "verify": "Verificar",
      "verify_success": "Credencial verificada correctamente",
      "verify_failure": "Error al verificar la credencial"
    },
    "trigger": {
      "settings_title": "Configuración del disparador",
      "modes_label": "Modos de disparo",
      "modes_hint": "Selecciona cómo se puede disparar este flujo. Al menos un modo debe estar marcado.",
      "mode_message": "Mensaje",
      "mode_ui": "UI",
      "mode_api": "API",
      "collision_policy_label": "Política de colisión",
      "collision_reject": "Rechazar",
      "collision_reject_hint": "si el destinatario ya tiene una sesión activa para este flujo, rechaza el nuevo disparo y deja la sesión existente en ejecución.",
      "collision_replace": "Reemplazar",
      "collision_replace_hint": "si el destinatario ya tiene una sesión activa para este flujo, expírala e inicia una nueva sesión para el nuevo disparo.",
      "required_variables": "Variables requeridas",
      "curl_snippet_label": "Fragmento cURL (disparo por API)",
      "trigger_action": "Disparar",
      "modal_title": "Disparar flujo",
      "tab_single": "Destinatario único",
      "tab_csv": "Subir CSV",
      "phone_number": "Número de teléfono",
      "phone_number_placeholder": "Selecciona un número de teléfono",
      "recipient_phone": "Teléfono del destinatario",
      "collision_override": "Anular política de colisión",
      "collision_use_default": "Usar valor por defecto del flujo",
      "variable_placeholder": "Introducir valor",
      "variables_label": "Variables del Flujo",
      "variables_hint": "Declara las variables que este flujo acepta. Los disparadores (UI, CSV, API) proporcionan valores al activarlo. Las variables sin valor predeterminado son obligatorias.",
      "variable_default_title": "Variable {{idx}}",
      "variable_name_label": "Nombre",
      "variable_default_label": "Valor predeterminado",
      "variable_description_label": "Descripción",
      "variable_name_placeholder": "nombre",
      "variable_default_placeholder": "(opcional)",
      "variable_description_placeholder": "(opcional)",
      "variable_add": "+ Añadir variable",
      "variable_remove": "Quitar",
      "variable_required": "Obligatorio",
      "variable_optional": "Opcional",
      "variable_duplicate": "Nombre de variable duplicado.",
      "variable_node_conflict": "El nombre entra en conflicto con una variable declarada por un nodo de este flujo.",
      "send": "Enviar",
      "accepted": "Aceptado",
      "rejected": "Rechazado",
      "trigger_sent": "Disparador enviado.",
      "view_batch": "Ver lote",
      "errors": {
        "flow_not_found": "Flujo no encontrado.",
        "flow_not_published": "Este flujo no está publicado. Publica una versión antes de dispararlo.",
        "mode_not_allowed": "Este flujo no permite esta fuente de disparo. Abre la configuración del disparador del flujo para habilitarla.",
        "no_send_message_node": "Este flujo no tiene un nodo de envío de mensaje, así que no hay nada que enviar al dispararlo.",
        "first_send_must_be_template": "Los flujos salientes deben comenzar con una plantilla de WhatsApp. Configura el primer nodo de envío de mensaje para usar una plantilla aprobada antes de dispararlo.",
        "sessionBusy": "El destinatario ya tiene una sesión activa para este flujo.",
        "recipientInAttendance": "El destinatario está siendo atendido por un agente actualmente.",
        "duplicate_in_batch": "Destinatario duplicado en este lote - solo se procesó la primera fila.",
        "invalidPhone": "Número de teléfono inválido.",
        "missingVariables": "Faltan una o más variables obligatorias."
      },
      "list_title": "Lotes de disparo",
      "list_no_batches": "No se encontraron lotes de disparo.",
      "csv_modal_text": "Crea un archivo CSV: Asegúrate de que tu archivo CSV incluya las siguientes columnas:",
      "csv_template_button": "Descargar plantilla CSV",
      "required": "obligatorio",
      "csv_dragger": "Haz clic o arrastra un archivo .csv aquí para subir",
      "csv_format_hint": "La primera columna debe ser \"to\". Las demás columnas se asignan a variables del flujo.",
      "csv_missing_to": "El CSV debe tener una columna \"to\" como primera columna.",
      "csv_missing_vars": "Faltan columnas de variables requeridas en el CSV",
      "csv_row_count": "{{count}} filas",
      "csv_large_file": "{{count}} filas - este es un lote grande y puede tardar.",
      "batch_title": "Lote de disparo",
      "batch_id": "ID del lote",
      "batch_created_at": "Creado el",
      "batch_created_by": "Creado por",
      "batch_total": "Total",
      "batch_accepted": "Aceptados",
      "batch_rejected": "Rechazados",
      "batch_completed": "Completados",
      "batch_failed": "Fallidos",
      "batch_col_to": "Para",
      "batch_col_accepted": "Aceptado",
      "batch_col_session": "Sesión",
      "batch_col_session_status": "Estado de la sesión",
      "batch_col_variables": "Variables",
      "batch_col_rejection_reason": "Motivo del rechazo",
      "batch_col_error": "Error",
      "batch_col_updated_at": "Actualizado",
      "batch_filter_all": "Todos",
      "batch_filter_all_accepted": "Todos los aceptados",
      "batch_filter_all_statuses": "Todos los estados",
      "batch_filter_rejected": "Rechazados",
      "batch_search_phone": "Buscar teléfono...",
      "batch_yes": "Sí",
      "batch_no": "No",
      "batch_no_items": "No se encontraron elementos.",
      "batch_load_more": "Cargar más",
      "batch_loading": "Cargando..."
    }
  },
  "org_explorer": {
    "title": "Explorador de Organizaciones",
    "placeholder": "Selecciona o busca un flag",
    "flag_label": "Flag:",
    "results_count": "{{count}} organizaciones encontradas",
    "showing_count": "Mostrando {{shown}} de {{total}} organizaciones",
    "empty_state": "Selecciona un flag para ver qué organizaciones lo tienen habilitado.",
    "no_results": "No se encontraron organizaciones para este flag.",
    "no_flag_matches": "Ningún flag coincide con tu búsqueda",
    "copy_all": "Copiar todos los IDs",
    "export_csv": "Exportar CSV",
    "clear": "Limpiar",
    "run_query": "Ejecutar consulta",
    "filters_label": "Filtros",
    "helper_text": "Encuentra organizaciones que coincidan con las condiciones dadas.",
    "preview_label": "Vista previa:",
    "preview_placeholder": "Agrega condiciones para ver una vista previa de la consulta.",
    "clear_all": "Limpiar todo",
    "searching": "Buscando…",
    "conditions_label": "Condiciones:",
    "conditions_count": "{{count}} condiciones",
    "connector_and": "Y",
    "connector_or": "O",
    "add_condition": "Agregar condición",
    "remove_condition": "Quitar",
    "collapse_filters": "Contraer filtros",
    "expand_filters": "Expandir filtros",
    "condition_flag_placeholder": "Selecciona un flag",
    "condition_value_placeholder": "Ingresa un valor",
    "operator_is": "es",
    "operator_is_not": "no es",
    "operator_eq": "Igual a",
    "operator_ne": "Distinto de",
    "operator_gt": "Mayor que",
    "operator_gte": "Mayor o igual que",
    "operator_lt": "Menor que",
    "operator_lte": "Menor o igual que",
    "operator_contains": "Contiene",
    "operator_not_contains": "No contiene",
    "operator_starts_with": "Empieza con",
    "operator_between": "Entre",
    "operator_includes_all": "Incluye todos",
    "operator_includes_any": "Incluye alguno",
    "operator_excludes_all": "Excluye todos",
    "operator_greater_than": "Mayor que",
    "operator_less_than": "Menor que",
    "operator_is_exactly": "Es exactamente",
    "operator_before": "Antes de",
    "operator_after": "Después de",
    "operator_exactly": "Exactamente",
    "value_true": "Verdadero",
    "value_false": "Falso",
    "value_enabled": "Habilitado",
    "value_disabled": "Deshabilitado",
    "validation_value_required": "El valor es obligatorio",
    "type_label": "Tipo",
    "type_boolean": "Booleano",
    "type_number": "Número",
    "type_string": "Texto",
    "type_select": "Selección",
    "type_multi": "Multi-selección",
    "type_date": "Fecha",
    "copy_org_id": "Copiar ID de org",
    "toast_copied": "Copiado",
    "table": {
      "org_name": "Nombre de org",
      "org_id": "ID de org",
      "description": "Descripción",
      "actions": "Acciones",
      "open_org": "Abrir org",
      "integrations": "Integraciones"
    },
    "errors": {
      "failed_load": "No se pudieron cargar las organizaciones. Intenta de nuevo."
    },
    "source_config": "Flag de configuración",
    "source_computed": "Métrica de usuarios",
    "source_integration": "Integración",
    "condition_computed_placeholder": "Selecciona una métrica",
    "condition_integration_placeholder": "Selecciona una integración",
    "category_placeholder": "Selecciona una categoría...",
    "category_group_metrics": "Métricas",
    "category_group_configuration": "Configuración",
    "category_integrations": "Integraciones",
    "category_feature_flags": "Flags de configuración",
    "category_metrics": "Métricas",
    "no_category_matches": "Ninguna categoría coincide con tu búsqueda",
    "select_integrations_placeholder": "Selecciona integraciones...",
    "select_flag_placeholder": "Selecciona un flag...",
    "select_flag_first": "Selecciona un flag primero",
    "select_metric_placeholder": "Selecciona una métrica...",
    "select_metric_first": "Selecciona una métrica primero",
    "enter_number_placeholder": "Ingresa número",
    "min_placeholder": "Mín",
    "max_placeholder": "Máx",
    "and": "y",
    "has": "Tiene",
    "does_not_have": "No tiene",
    "has_integration": "Tiene integración",
    "does_not_have_integration": "No tiene integración",
    "computed_fields": {
      "total_users": "Total de usuarios",
      "total_users_help": "Cantidad total de usuarios en la organización",
      "active_users": "Usuarios activos",
      "active_users_help": "Cantidad de usuarios con estado activo",
      "sidecar_users": "Usuarios con sidecar",
      "sidecar_users_help": "Cantidad de usuarios con sidecar habilitado",
      "desktop_users": "Usuarios de escritorio",
      "desktop_users_help": "Cantidad de usuarios con app de escritorio",
      "last_activity": "Última actividad",
      "last_activity_help": "Último inicio de sesión de un usuario en la organización"
    }
  },
  "common": {
    "hide": "Ocultar",
    "show": "Mostrar",
    "copy": "Copiar",
    "copied_to_clipboard": "Copiado al portapapeles"
  },
  "chat_now_modal": {
    "search_no_resoults_found": "No se encontraron resultados. Por favor, intenta con otra búsqueda.",
    "start_chat": "Iniciar chat"
  },
  "settings": "Configuraciones",
  "back": "Volver",
  "next": "Siguiente",
  "save_changes": "Guardar Cambios",
  "support": "Soporte",
  "tuvis_platform": "Plataforma Tuvis",
  "error_try_again": "Por favor intente nuevamente en unos minutos",
  "login": {
    "login_failed": "Inicio de sesión fallido",
    "no_sufficient_permissions": "No tiene los permisos suficientes para acceder a Tuvis"
  },
  "coming_soon": "Próximamente",
  "status": "Estado",
  "home": {
    "title": "Inicio",
    "banner": {
      "title": "Actualización!",
      "learn_more": "Más información"
    },
    "welcome": {
      "title": "Bienvenido a la Plataforma Tuvis",
      "description": "Tu viaje seguro, compatible y productivo comienza aquí. Gestiona comunicaciones, usuarios, canales y sistemas en un solo lugar. Experimenta una integración perfecta en tu flujo de trabajo mientras mantienes los más altos estándares de protección de datos y eficiencia del equipo.",
      "greeting": "Bienvenido de nuevo, <bold>{{name}}</bold>!"
    },
    "quick_actions": {
      "title": "Acciones Rápidas",
      "edit": "Editar",
      "done": "Listo",
      "drag_to_reorder": "Arrastra para reordenar",
      "click_to_hide": "Clic para eliminar",
      "add_action": "Agregar acción rápida",
      "add_action_desc": "Fijar cualquier página para acceso rápido",
      "add_action_modal_title": "Agregar acción rápida",
      "search_pages": "Buscar páginas...",
      "no_pages_found": "No se encontraron páginas"
    }
  },
  "auto_sync": {
    "on": "Activado",
    "off": "Desactivado",
    "inherent": "Global"
  },
  "org_overview": {
    "title": "Org Overview"
  },
  "analytics": {
    "title": "Analytics"
  },
  "analytics_dashboard": {
    "title": "Dashboard"
  },
  "cyber_insights": {
    "title": "Seguridad e Incidentes",
    "total_incidents": "Total de incidentes",
    "count": "Cantidad",
    "violated_dlp": "Políticas DLP violadas",
    "min": "Minutos",
    "time_to_resolve": "Tiempo promedio para resolver un incidente en minutos",
    "time_to_resolve_chart_label": "Tiempo de resolución",
    "daily_incidents": "Incidentes diarios",
    "daily_incidents_chart_label": "Incidentes",
    "incidents_per_user": "Incidentes por usuario",
    "incidents_per_severity": "Incidentes por severidad",
    "export_incidents": "Incidentes",
    "export_average_time_to_resolve": "Tiempo promedio de resolución",
    "day": "Día",
    "time_to_response": "Promedio de minutos para responder",
    "number_of_incidents": "Número de incidentes",
    "created_by": "Creado por"
  },
  "compliance_insights": {
    "title": "Cumplimiento"
  },
  "surveillance_insights": {
    "title": "Vigilancia e Incidentes",
    "total_incidents": "Total de incidentes",
    "violated_policies": "Principales políticas de vigilancia infringidas",
    "daily_incidents": "Incidentes diarios",
    "incidents_per_user": "Incidentes por usuario",
    "incidents_per_severity": "Incidentes por gravedad",
    "export_incidents": "Incidentes",
    "export_violated_policies": "Políticas de vigilancia infringidas",
    "export_daily_incidents": "Incidentes diarios",
    "export_incidents_per_user": "Incidentes por usuario"
  },
  "call_recordings_insights": {
    "title": "Insights de grabaciones de llamadas",
    "export_call_recordings": "Grabaciones de llamadas",
    "total_call_recordings": "Total de grabaciones de llamadas",
    "outgoing": "Salientes",
    "incoming": "Entrantes",
    "count": "Cantidad",
    "call_recordings_per_user": "Grabaciones de llamadas por usuario",
    "number_of_call_recordings": "Número de grabaciones de llamadas"
  },
  "user_analytics": {
    "title": "Análisis de Usuarios",
    "subtitle": "Análisis detallado de tiempo de respuesta para cada usuario en su organización (Últimos 3 meses)",
    "search_placeholder": "Buscar por ID de usuario...",
    "search_name_placeholder": "Buscar por nombre de usuario...",
    "edit_columns": "Editar Columnas",
    "no_data": "No hay datos de análisis de usuarios disponibles",
    "edit_columns_modal": {
      "title": "Personalizar Columnas de Tabla",
      "description": "Elija qué métricas mostrar en la tabla de análisis de usuarios. Puede mostrar u ocultar columnas según sus necesidades de análisis."
    },
    "column_groups": {
      "basic": "Información Básica",
      "response_times": "Métricas de Tiempo de Respuesta",
      "time_distribution": "Análisis de Distribución de Tiempo"
    },
    "columns": {
      "user_id": "ID de Usuario",
      "engagement_user_id": "ID de usuario CRM / analytics",
      "user_name": "Nombre de Usuario",
      "isOnline": "Estado Online",
      "online_source": "Fuente en línea",
      "total_responses": "Total de Respuestas",
      "total_duration": "Duración en Línea",
      "median_response_minutes": "Tiempo de Respuesta Mediano",
      "average_response_minutes": "Tiempo de Respuesta Promedio",
      "min_response_minutes": "Tiempo de Respuesta Mínimo",
      "max_response_minutes": "Tiempo de Respuesta Máximo",
      "p90_response_minutes": "Respuesta Percentil 90",
      "p95_response_minutes": "Respuesta Percentil 95",
      "stddev_response_minutes": "Desviación Estándar de Tiempo de Respuesta",
      "responses_within_5min": "Respuestas Dentro de 5 Min",
      "responses_within_15min": "Respuestas Dentro de 15 Min",
      "responses_within_1hour": "Respuestas Dentro de 1 Hora",
      "responses_over_1hour": "Respuestas Más de 1 Hora",
      "business_hours_responses": "Respuestas Horario Comercial",
      "after_hours_responses": "Respuestas Fuera de Horario",
      "weekend_responses": "Respuestas Fin de Semana",
      "weekday_responses": "Respuestas Días Laborables",
      "pct_within_5min": "% Dentro de 5 Min",
      "pct_within_15min": "% Dentro de 15 Min",
      "pct_within_1hour": "% Dentro de 1 Hora",
      "pct_over_1hour": "% Más de 1 Hora",
      "pct_business_hours": "% Horario Comercial",
      "pct_after_hours": "% Fuera de Horario",
      "pct_weekend": "% Fin de Semana",
      "pct_weekday": "% Días Laborables"
    },
    "date_filter": "FILTRAR FECHA"
  },
  "custom_filters": {
    "title": "Filtros personalizados",
    "create_new": "Nuevo filtro",
    "create_first": "Crea tu primer filtro",
    "empty_state": "Aún no hay filtros personalizados. Crea uno para filtrar conversaciones por resultados de informes de Salesforce.",
    "no_assignments": "Sin asignar",
    "users": "usuarios",
    "groups": "grupos",
    "columns": {
      "name": "Nombre",
      "description": "Descripción",
      "reports": "Informes",
      "assigned": "Asignado a",
      "last_updated": "Última actualización",
      "actions": "Acciones"
    },
    "actions": {
      "settings": "Configuración",
      "delete": "Eliminar"
    },
    "deleteModal": {
      "title": "Eliminar filtro personalizado",
      "description": "¿Seguro que quieres eliminar \"{{name}}\"?",
      "submit": "Eliminar"
    },
    "errors": {
      "failedDelete": "Error al eliminar el filtro personalizado",
      "loadFailed": "No se pudieron cargar los filtros personalizados"
    },
    "modal": {
      "title": "Crear filtro personalizado",
      "edit_title": "Editar filtro personalizado",
      "name_label": "Nombre del filtro",
      "description_label": "Descripción",
      "users_label": "Usuarios",
      "groups_label": "Grupos",
      "reports_placeholder": "Selecciona informes de Salesforce...",
      "submit_create": "Crear",
      "submit_save": "Guardar",
      "errors": {
        "name_required": "El nombre del filtro es obligatorio",
        "name_too_short": "El nombre del filtro debe tener al menos 3 caracteres",
        "create_failed": "Error al crear el filtro. Inténtalo de nuevo.",
        "update_failed": "Error al actualizar el filtro. Inténtalo de nuevo."
      }
    }
  },
  "dashboards": {
    "title": "Vista personalizada",
    "subtitle": "Crea y gestiona vistas personalizadas con datos del CRM para tu equipo",
    "create_new": "Nueva vista personalizada",
    "create_first": "Crea tu primera vista personalizada",
    "empty_state": "Aún no hay vistas personalizadas. ¡Crea la primera para comenzar!",
    "home_badge": "Inicio",
    "no_assignments": "Sin asignar",
    "users": "usuarios",
    "groups": "grupos",
    "confirm_delete": "¿Seguro que quieres eliminar \"{{name}}\"? Todos los widgets se eliminarán permanentemente.",
    "addWidget": "Añadir widget",
    "addFirstWidgetButton": "+ Añadir el primer widget",
    "editWidget": "Editar widget",
    "widgetTitle": "Título del widget",
    "widgetTitlePlaceholder": "ej., Ventas totales, Casos abiertos",
    "widgetDescription": "Descripción del widget",
    "widgetDescriptionPlaceholder": "ej., Muestra las ventas totales de este trimestre",
    "report": "Informe",
    "displayAs": "Mostrar como",
    "yAxis": "Eje Y",
    "xAxis": "Eje X",
    "measure": "Medida",
    "selectGroupingField": "Selecciona campo de agrupación...",
    "selectMeasure": "Selecciona medida...",
    "preview": "Vista previa",
    "selectReportToPreview": "Selecciona un informe para previsualizar el widget",
    "selectDisplayTypeToPreview": "Selecciona un tipo de visualización para ver la vista previa",
    "recordCount": "Número de registros",
    "add": "Añadir",
    "update": "Actualizar",
    "widgets": {
      "loading": "Cargando...",
      "noDataAvailable": "No hay datos disponibles",
      "noReportConfigured": "No hay informe de Salesforce configurado",
      "failedLoadReportData": "Error al cargar los datos del informe",
      "failedLoadWidgetData": "Error al cargar los datos del widget",
      "unsupportedWidgetType": "Tipo de widget no soportado: {{type}}",
      "item": "Elemento",
      "noGroupedDataAvailable": "No hay datos agrupados disponibles",
      "noNumericValuesFound": "No se encontraron valores numéricos en el informe",
      "tryDifferentReport": "Este informe puede no tener valores agregados. Prueba otro informe o tipo de widget.",
      "reportMayNotHaveAggregates": "Este informe puede no tener valores agregados.",
      "values": "Valores",
      "noDetailDataAvailable": "No hay datos de detalle disponibles",
      "showingRowsOfTotal": "Mostrando {{shown}} de {{total}} filas",
      "noDataToDisplay": "No hay datos para mostrar",
      "viewReport": "Ver informe"
    },
    "widgetTypes": {
      "kpiCard": "Tarjeta KPI",
      "barChart": "Gráfico de barras",
      "pieChart": "Gráfico circular",
      "lineChart": "Gráfico de líneas"
    },
    "validation": {
      "selectReport": "Selecciona un informe de Salesforce",
      "selectWidgetType": "Selecciona un tipo de widget",
      "widgetTitleRequired": "El título del widget es obligatorio"
    },
    "errors": {
      "failedCreateWidget": "Error al crear el widget",
      "failedUpdateWidget": "Error al actualizar el widget",
      "failedReorderWidgets": "Error al reordenar los widgets",
      "failedDeleteWidget": "Error al eliminar el widget"
    },
    "deleteWidget": "Eliminar widget",
    "confirmDeleteWidget": "¿Seguro que quieres eliminar \"{{title}}\"?",
    "deleteWidgetModal": {
      "title": "Eliminar widget",
      "description": "¿Seguro que quieres eliminar \"{{title}}\"? Esta acción no se puede deshacer.",
      "submit": "Eliminar"
    },
    "columns": {
      "name": "Nombre",
      "description": "Descripción",
      "widgets": "Widgets",
      "assigned_users": "Asignado a",
      "last_updated": "Última actualización",
      "actions": "Acciones"
    },
    "actions": {
      "edit": "Editar",
      "settings": "Configuración",
      "builder": "Editar widgets",
      "preview": "Vista previa",
      "delete": "Eliminar"
    },
    "deleteDashboardModal": {
      "title": "Eliminar vista personalizada",
      "description": "¿Seguro que quieres eliminar \"{{name}}\"? Todos los widgets se eliminarán permanentemente.",
      "submit": "Eliminar"
    },
    "modal": {
      "title": "Crear nueva vista personalizada",
      "edit_title": "Editar configuración de la vista personalizada",
      "name_label": "Nombre de la vista personalizada",
      "name_placeholder": "ej., Resumen de ventas, Vista del gestor",
      "description_label": "Descripción",
      "description_placeholder": "Breve descripción de lo que muestra esta vista personalizada",
      "assign_to": "Asignar vista personalizada a",
      "users_label": "Usuarios",
      "users_placeholder": "Selecciona los usuarios que pueden ver esta vista personalizada",
      "groups_label": "Grupos",
      "groups_placeholder": "Selecciona los grupos que pueden ver esta vista personalizada",
      "is_home_default_label": "Establecer como vista personalizada de inicio",
      "is_home_default_help": "Si está activado, esta vista personalizada sustituirá la pantalla de inicio de WhatsApp para los usuarios asignados",
      "create_button": "Crear vista personalizada",
      "errors": {
        "name_required": "El nombre de la vista personalizada es obligatorio",
        "name_too_short": "El nombre de la vista personalizada debe tener al menos 3 caracteres",
        "create_failed": "Error al crear la vista personalizada. Inténtalo de nuevo.",
        "update_failed": "Error al actualizar la vista personalizada. Inténtalo de nuevo."
      }
    }
  },
  "users_conversations_status": {
    "title": "Estado de Conversaciones de Usuarios",
    "subtitle": "Estado de conversaciones de WhatsApp en tiempo real para cada usuario - mensajes no leídos, esperando respuestas y mensajes que necesitan respuesta.",
    "empty_state": "No hay datos disponibles todavía. Los datos aparecerán una vez que los usuarios con la función de seguimiento habilitada utilicen la aplicación de escritorio.",
    "columns": {
      "user_name": "Nombre de Usuario",
      "unread": "No leídos",
      "awaiting_reply": "Esperando Respuesta",
      "need_reply": "Necesitan Respuesta",
      "last_updated": "Última Actualización"
    }
  },
  "user_management": {
    "cols": {
      "avatar": "Avatar",
      "online_tooltip": "Usuario está en línea",
      "offline_tooltip": "Usuario está desconectado",
      "name": "Nombre",
      "orgId": "ID de Organización",
      "orgName": "Nombre de la organización",
      "status": "Estado",
      "paidLicences": "Licencias Pagadas",
      "auto_sync_person": "Sincronización automática (Persona)",
      "auto_sync_group": "Sincronización automática (Grupo)",
      "sync_back_days": "Días de sincronización retroactiva",
      "active_tuvis": "Activo en Tuvis",
      "groups": "Grupos",
      "last_login": "Último inicio de sesión",
      "last_login_platform": "Último inicio de sesión (Plataforma)",
      "last_login_desktop": "Último inicio de sesión (Escritorio)",
      "last_login_extension": "Último inicio de sesión (Extensión)",
      "last_login_mobile": "Último inicio de sesión (Móvil)",
      "last_login_tooltip": "Este muestra la última vez que el usuario inició sesión correctamente o fue actualizado durante la actualización automática - no cuando fueron activos/en línea.",
      "desktop_version": "Versión de escritorio",
      "extension_version": "Versión de extensión",
      "mobile_version": "Versión móvil",
      "linked_identities": "Identidades vinculadas",
      "online_source": {
        "desktop": "Tuvis Desktop App",
        "extension": "Tuvis Extension",
        "tuvisBrowser": "Tuvis Browser",
        "unknown": "Unknown"
      }
    },
    "status": {
      "active": "Activo",
      "inactive": "Inactivo",
      "disabled": "Desactivado"
    },
    "sync_back_days_inherit": "Heredar de la organización ({{days}} días)",
    "sync_back_days_tooltip_user": "Configura cuántos días de mensajes históricos se sincronizarán. Dejar vacío para heredar del nivel de organización o grupo.",
    "sync_back_days_tooltip_group": "Configura cuántos días de mensajes históricos se sincronizarán. Dejar vacío para heredar del nivel de organización.",
    "sync_back_days_helper_user": "Dejar vacío para heredar de la organización o grupo. Esta configuración controla cuánto tiempo atrás se sincronizan los mensajes cuando la sincronización automática está habilitada.",
    "sync_back_days_helper_group": "Dejar vacío para heredar de la organización. Esta configuración controla cuánto tiempo atrás se sincronizan los mensajes cuando la sincronización automática está habilitada.",
    "reset_to_default": "Restablecer a valores predeterminados",
    "invite_user_modal": {
      "new_org": "Nueva Organización",
      "org_name": "Nombre de la Organización",
      "server_location": "Ubicación del Servidor",
      "org_language": "Idioma de la Organización",
      "org_type": "Tipo de Organización",
      "available_crm": "CRM Disponible",
      "comment": "Comentario",
      "comment_placeholder": "Comentario opcional sobre esta organización..."
    },
    "merge": {
      "modal_title": "Combinar usuarios duplicados",
      "modal_body": "Elige la cuenta que se conservará. Las identidades de inicio de sesión y los sidecars de las demás cuentas se trasladan a ella y los duplicados se desactivan. Los mensajes y el historial no se trasladan.",
      "primary_label": "Cuenta principal (conservada)",
      "duplicates_label": "Duplicados (desactivados)",
      "mismatch_warning": "Las cuentas seleccionadas no comparten el mismo {{key}} - combina solo si estás seguro de que son la misma persona.",
      "confirm": "Combinar",
      "cluster_progress": "Duplicado {{current}} de {{total}}",
      "skip": "Omitir",
      "success": "Usuarios combinados",
      "failure": "No se pudo combinar los usuarios",
      "view_duplicates": "Buscar usuarios duplicados",
      "searching_duplicates": "Buscando usuarios duplicados...",
      "no_duplicates": "No se encontraron usuarios duplicados"
    },
    "merged_into": "Fusionado en {{label}}",
    "merged_cannot_activate": "Fusionado - no se puede reactivar"
  },
  "engagement": {
    "select": "Seleccionar",
    "select_columns": "Seleccionar columnas",
    "export_pdf": "Exportar PDF",
    "analytics_counters": "Contadores de análisis",
    "email": "Correo electrónico",
    "name": "Nombre",
    "date": "Fecha",
    "sent_messages": "Mensajes enviados",
    "received_messages": "Mensajes recibidos",
    "export": "Exportar",
    "title": "Conversaciones",
    "total_messages": "Total de mensajes",
    "total_messages_tooltip": "Cantidad total de mensajes procesados por Tuvis",
    "messages_over_time": "Mensajes intercambiados por día",
    "messages_over_time_per_user": "Mensajes intercambiados por día por usuario",
    "messages_over_time_chart_label": "Mensajes",
    "messages_over_time_tooltip": "Mensajes intercambiados entre usuarios a lo largo del tiempo",
    "direction": "Dirección",
    "top_engaged": "Prospectos / Contactos / Person account con más interacción",
    "files_exchanged": "Archivos intercambiados",
    "files_exchanged_tooltip": "Archivos intercambiados entre usuarios",
    "engaged_by_type": "Interacción por tipo",
    "unknown_engaged": "Personas desconocidas",
    "leads": "Interacción",
    "contacts": "Contactos",
    "person_accounts": "Person accounts",
    "accounts": "Cuentas",
    "engaged_people": "Personas con interacciones",
    "sent": "Enviados",
    "received": "Recibidos",
    "count": "Cantidad",
    "response_time": "Tiempo de Respuesta (Mediana)",
    "file_types": {
      "image_one": "Una Imagen",
      "image_other": "{{amount}} Imagenes",
      "audio_one": "Un archivo de audio",
      "audio_other": "{{amount}} Archivos de audio",
      "video_one": "Una Video",
      "video_other": "{{amount}} Videos",
      "pdf_one": "Un archivo PDF",
      "pdf_other": "{{amount}} Archivos PDF",
      "spreadsheet_one": "Una hoja de Excel",
      "spreadsheet_other": "{{amount}} Hojas de excel",
      "document_one": "Un Documento",
      "document_other": "{{amount}} Documentos",
      "presentation_one": "Una presentación",
      "presentation_other": "{{amount}} Presentaciones",
      "other_one": "Un archivo diferente",
      "other_other": "{{amount}} archivos diferentes "
    },
    "minutes": "Minutos"
  },
  "revenue": {
    "title": "Análisis de Interacciones",
    "top_engaging_users": "Usuarios con más interacción",
    "top_engaging_groups": "Grupos más participativos",
    "record_created": "Registros creados",
    "activities": "Actividades",
    "leads": "Prospectos",
    "contacts": "Contactos",
    "tasks": "Tareas",
    "cases": "Casos",
    "emails": "Correos",
    "events": "Eventos",
    "person_accounts": "Person accounts",
    "accounts": "Cuentas",
    "minutes": "Minutos",
    "unknown_engagement": "Personas desconocidas",
    "total_engaging_people": "Personas con interacciones",
    "messages": "Mensajes",
    "others": "Otros",
    "record_created_tooltip": "Nuevos registros creados desde Tuvis",
    "top_engaging_users_tooltip": "Usuarios interactuando con personas a través de mensajería instantánea",
    "top_engaging_groups_tooltip": "Mostrando los grupos de usuarios más activos",
    "opportunities_analyzer": {
      "title": "Análisis de oportunidades",
      "account": "Cuenta",
      "opportunity": "Oportunidad",
      "stage": "Etapa",
      "amount": "Monto",
      "users": "Usuarios",
      "persons": "Personas",
      "messages": "Mensajes",
      "files": "Archivos"
    },
    "break_down": "Desglose"
  },
  "adoption": {
    "title": "Adopción de Tuvis",
    "most_active_users": "Usuarios mas activos",
    "total_users": "Total de usuarios",
    "adoption_over_time": "Adopción por día",
    "time_spent_on_engagement": "Tiempo dedicado a interacciones",
    "chat_now": "Chatea ahora",
    "use_template": "Plantillas utilizadas",
    "currently_active": "Activo actualmente",
    "active_users": "Usuarios activos",
    "actions_used": "Acciones más utilizadas",
    "most_active_users_tooltip": "Cantidad de veces que Tuvis fue usado proactivamente",
    "adoption_over_time_tooltip": "Cantidad de usuarios de Tuvis en su cuenta y usabilidad por día.",
    "time_spent_on_engagement_tooltip": "Tiempo en WhatsApp vs Salesforce. Con Tuvis, sus equipos dedican mas tiempo a interactuar con clientes por WhatsApp, en vez de realizar acciones manuales y repetitivas",
    "chat_now_tooltip": "Cuantas veces los usuarios hicieron click en el botón “Chatea ahora”, en Salesforce o en la barra de búsqueda global.",
    "use_template_tooltip": "Cuantas veces los usuarios utilizaron las plantillas dinámicas",
    "time_spent_month": "Mes",
    "time_spent_active_users": "Usuarios",
    "time_spent_active_users_usage": "Todos los usuarios activos",
    "time_spent_new_users_breakdown": "nuevos usuarios",
    "time_spent_avrage": "Promedio",
    "time_spent_new_users": "usuarios",
    "time_spent_month_avg": "Promedio mensual",
    "time_spent_tooltip_header": "Tiempo dedicado a WhatsApp",
    "time_spent_tooltip_content": "En promedio, de estos {{users}} usuarios, aproximadamente {{percent}}% de su tiempo lo dedicaron a WhatsApp.",
    "actions": {
      "show_more": "Mostrar más",
      "show_less": "Mostrar menos",
      "chat_now": "Chatea ahora",
      "use-template": "Plantillas utilizadas",
      "create-activity-task-case": "Crear Actividad/Tarea/Caso",
      "create-task": "Crear Tarea",
      "create-lead-contact": "Crear Prospecto/Contacto",
      "create-activity": "Crear Actividad",
      "create-contact": "Crear Contacto",
      "create-lead": "Crear Prospecto",
      "create-case": "Crear Caso",
      "create-custom-object": "Crear Custom object",
      "view-in-crm": "Ver en CRM",
      "add_to_phone": "Agregar al teléfono",
      "schedule-event": "Agendar Evento",
      "send-email": "Enviar Email",
      "add-mobile-contact": "Agregar a Contactos de su Móvil",
      "call-contact": "Llamar",
      "start_meeting": "Lanzar reunión",
      "find-on-linkedin": "Encontrar en LinkedIn",
      "find-on-facebook": "Encontrar en Facebook",
      "find-on-google": "Buscar en Google",
      "chat-on-messenger": "Habla en Messenger",
      "chat-on-messanger": "Habla en Messenger"
    }
  },
  "sidecars": {
    "disconnections_over_time": {
      "title": "Usuarios desconectados en el tiempo",
      "date": "Fecha",
      "channel": "Canal",
      "unique_users": "Usuarios desconectados",
      "events": "Eventos de desconexión"
    },
    "email": "Email",
    "no_sidecars_desc": "Actualmente, no tienes ningún dispositivos, pero este es el momento ideal para crear tu primer modelo.",
    "manual": "Ingresar manualmente",
    "upload_csv": "Cargar CSV",
    "scan_qr": "<0>No</0> escanees el código QR con la app de cámara, <1>escanéalo a través de {{channelName}}</1>",
    "scan_qr_instructions": {
      "whatsapp": {
        "android": "<0>Para escanear:</0> Abre WhatsApp → Menú de tres puntos → Dispositivos vinculados → Vincular un dispositivo",
        "ios": "<0>Para escanear:</0> Abre WhatsApp → Ajustes → Dispositivos vinculados → Vincular un dispositivo"
      },
      "telegram": "<0>Para escanear:</0> Abre Telegram → Configuración → Dispositivos → Vincular dispositivo → Escanear código QR",
      "line": "<0>Para escanear:</0> Abre LINE → Configuración → Dispositivos → Escanear código QR",
      "signal": "<0>Para escanear:</0> Abre Signal → Configuración → Dispositivos vinculados → Escanear código QR"
    },
    "pairing_timeout": "Se alcanzó el límite de tiempo del código QR o ocurrió un error durante el emparejamiento.",
    "pairing_phone_mismatch": "El número de WhatsApp que intentó conectar no está registrado en su dispositivo.",
    "pairing_error_generic": "Algo salió mal durante el emparejamiento. Por favor, inténtelo de nuevo más tarde.",
    "pairing_error_title": "Conexión fallida",
    "what_to_do_now": "¿Qué hacer ahora?",
    "generate_new_qr_code": "Generar nuevo código QR",
    "pairing_timeout_step_1_title": "Compruebe la versión de WhatsApp",
    "pairing_timeout_step_1_body": "Vaya a la tienda de aplicaciones de su teléfono y compruebe si hay actualizaciones disponibles para WhatsApp. Si las hay, actualice la aplicación.",
    "pairing_timeout_step_2_title": "Elimine los dispositivos desconectados",
    "pairing_timeout_step_2_body": "Antes de intentar conectarse de nuevo, elimine todas las conexiones antiguas del menú \"Dispositivos desconectados\" en WhatsApp.",
    "pairing_timeout_step_3_title": "Pruebe la copia de seguridad de WhatsApp",
    "pairing_timeout_step_3_body": "Compruebe si puede realizar una copia de seguridad. Si no puede por falta de espacio, esa podría ser la causa de la desconexión. Libere espacio de almacenamiento antes de intentarlo de nuevo.",
    "pairing_phone_mismatch_step_1_title": "Verifique la invitación:",
    "pairing_phone_mismatch_step_1_body": "El correo electrónico que recibió para vincular el dispositivo muestra el número de WhatsApp esperado.",
    "pairing_phone_mismatch_step_2_title": "Corrija su registro:",
    "pairing_phone_mismatch_step_2_body": "Si el número de la invitación es incorrecto, contacte al administrador de Tuvis de su empresa para actualizarlo.",
    "invite_user": "Invitar usuario",
    "invite_phone": "Número de teléfono esperado",
    "user_inactive_cannot_add": "No se puede agregar Remote Sync. Este usuario está inactivo actualmente.",
    "should_notify": "Notifíqueme cuando el dispositivo esté emparejado o desconectado",
    "auto_reinvite": "Reinvitación automática al conectarse",
    "periodic_reinvite": "Reinvitación automática cada día hasta que se empareje",
    "sidecar_created": "Se ha creado un nuevo dispositivo",
    "invitation_sent": "Invitación enviada",
    "share_invite_link": "Compartir enlace de invitación:",
    "next": "Siguiente",
    "invite": "Invitar",
    "pair": "Conectar con Tuvis",
    "pair_description_1": "Te han invitado a vincular tu cuenta de {{channelName}} con Tuvis",
    "pair_description_2": "Haga clic en el botón de abajo para iniciar el proceso de emparejamiento.",
    "pair_button": "Conectar con Tuvis",
    "pairing_success": "Conexión exitosa",
    "pairing_success_description_1": "Su cuenta de {{channelName}} ahora está conectada a TUVIS.",
    "pairing_success_description_2": "Ahora puede comenzar a usar TUVIS para interactuar con sus clientes sobre {{channelName}}.",
    "pairing_boot_sentences_length": "7",
    "pairing_boot_sentences_0": "Tuvis está lanzando un código QR para usted",
    "pairing_boot_sentences_1": "Configurar su código QR puede tardar unos minutos",
    "pairing_boot_sentences_2": "Por favor espera. El código QR se está creando",
    "pairing_boot_sentences_3": "Una vez que el código QR esté listo, podrás vincular tu cuenta de {{channelName}} con Tuvis",
    "pairing_boot_sentences_4": "Oh, esto está tomando más tiempo de lo esperado.",
    "pairing_boot_sentences_5": "Estamos casi allí, solo unos segundos más",
    "pairing_boot_sentences_6": "Pedimos disculpas por la demora. Estamos trabajando para poner todo en marcha",
    "pairing_boot_sentences_connect_phone_number_0": "Tuvis está configurando una conexión en la nube para ti…",
    "pairing_boot_sentences_connect_phone_number_1": "La configuración de tu conexión podría tardar unos minutos…",
    "pairing_boot_sentences_connect_phone_number_2": "Por favor, espera mientras se crea tu conexión…",
    "pairing_boot_sentences_connect_phone_number_3": "Una vez que la conexión esté lista, podrás vincular tu cuenta de {{channelName}} con Tuvis…",
    "pairing_boot_sentences_connect_phone_number_4": "Oh, esto está tardando más de lo esperado.",
    "pairing_boot_sentences_connect_phone_number_5": "Ya casi llegamos, solo unos segundos más",
    "pairing_boot_sentences_connect_phone_number_6": "Pedimos disculpas por la demora. Estamos trabajando arduamente para que estés en funcionamiento",
    "link_is_invalid": "Este enlace ya no es válido.",
    "contact_admin": "Póngase en contacto con su administrador para obtener ayuda.",
    "create_sidecar": "Agregar dispositivo",
    "phone": "Teléfono",
    "user": "Usuario",
    "manager": "Gerente",
    "paired_devices": "Dispositivos Conectados",
    "counters": {
      "total": "Usuarios de Remote Sync",
      "connected": "Conectados",
      "disconnected": "Desconectados",
      "new": "Invitaciones pendientes",
      "licenses": "Máximo de dispositivos"
    },
    "runner": "Ejecutor",
    "runnerChannel": "Canal",
    "statuses": {
      "invited": "Invitado",
      "booting": "Iniciando",
      "running": "Sincronizando ahora",
      "idle": "Sincronización pendiente",
      "pairing": "Emparejamiento",
      "error": "Error",
      "not_paired": "Desconectado",
      "connected": "Conectado",
      "new": "Nuevo",
      "disconnected_by_user": "Desconectado por el usuario"
    },
    "status": "Status",
    "created_at": "Creado el",
    "last_update": "Última actualización",
    "start_sidecar": "Conectar dispositivo",
    "debug_sidecar": "Ajustar dispositivo",
    "clear_query_cache": "Limpiar Caché de Consulta",
    "reload_sidecars": "Recargar dispositivos",
    "filter_sidecars": "Filtrar dispositivos",
    "sidecar_messages": "Mensajes del Dispositivo",
    "send_invitation": "Enviar invitacion",
    "sidecar_settings": "Configuración del dispositivo",
    "delete_sidecar": "Eliminar dispositivo",
    "delete_sidecar_modal_message": "¿Está seguro de que desea eliminar este dispositivo?",
    "pair_sidecar": "Enlazar dispositivo",
    "frequency": "Frecuencia",
    "log": "Registro",
    "alt_login": {
      "invalid_code": "Código inválido",
      "verify_phone_code": "Verificar",
      "send_login_code": "Hemos enviado el código a la aplicación {{channelName}} en tu otro dispositivo.",
      "link_phone": "Vincular teléfono de {{channelName}}",
      "link_with_qr": "Enlazar con código QR",
      "link_with_phone": "Conecte com seu número de {{channelName}}",
      "get_code": "Obtener código",
      "edit_phone": "Editar teléfono",
      "enter_phone_number": "Introduce el número de teléfono con el código de país",
      "enter_code": "Introduce el código en el teléfono"
    },
    "pairing_steps": {
      "first": "1. Abre WhatsApp en tu teléfono.",
      "second": {
        "on_android": "2. En Android, toca en Menú",
        "on_iphone": "o en iPhone, toca en Configuración"
      },
      "third": "3. Selecciona \"Dispositivos vinculados\" y luego \"Vincular un dispositivo.'",
      "fourth": "4. Haz clic en \"Conectar con número de teléfono.\"",
      "fifth": "5. Algunos dispositivos pueden requerir escribir manualmente el código necesario"
    },
    "addSidecar": "Asignar dispositivo remoto",
    "maxSidecarsReached": "Has alcanzado el máximo número de dispositivos remotos",
    "disconnected_at": "Desconectado el",
    "send_invites": "Enviar Invitaciones",
    "sidecars": "Dispositivos",
    "bulk_reinvite": {
      "success": "Se enviaron invitaciones exitosamente a {{count}} dispositivos",
      "partial_failure": "No se pudieron enviar invitaciones a {{count}} dispositivos",
      "failed": "Error al enviar invitaciones masivas"
    },
    "bulk_delete": {
      "action_label": "Eliminar Seleccionados",
      "confirm_title": "Eliminar Dispositivos",
      "confirm_message": "¿Está seguro de que desea eliminar {{count}} dispositivo(s)? Esta acción no se puede deshacer.",
      "progress": "Eliminando {{current}} de {{total}}...",
      "success": "{{count}} dispositivo(s) eliminado(s) con éxito",
      "partial_success": "Se eliminaron {{successCount}} dispositivo(s). No se pudieron eliminar {{failCount}} dispositivo(s).",
      "failed": "Error al eliminar dispositivos"
    },
    "scan_qr_auth_code": "Introduce este código en la aplicación {{channelName}} para conectar con Tuvis"
  },
  "filters": {
    "timeComparisonDays": "de los últimos {{count}} días",
    "timeComparisonMonths": "de los últimos {{count}} meses",
    "filters": "Filtros",
    "last_month": "Filtro último mes",
    "last_60_days": "Filtro últimos 60 días",
    "last_90_days": "Filtro últimos 90 días",
    "last_year": "Filtros últimos año",
    "users": "Usuarios",
    "assignee": "Responsable designado",
    "created_by": "Creado por",
    "no_assignee": "Sin responsable designado",
    "groups": "Grupos",
    "reset_filters": "Restablecer filtros",
    "phones": "Teléfonos del Usuario",
    "error_no_phones": "No se encontraron teléfonos",
    "apply_filters": "Aplicar filtros",
    "clear_all": "Limpiar filtros",
    "filter_analytics": "Filtrar datos",
    "search": "Búsqueda",
    "search_no_results_title": "No se encontró nada",
    "search_no_results_description": "Prueba otras palabras clave o asegúrese que todo está escrito correctamente",
    "error_no_users": "No se encontraron usuarios",
    "error_no_users_description": "Por favor intente nuevamente en unos minutos",
    "show": "Mostrar",
    "top": "Primeros",
    "filter_audit_logs": "filtros de registro de auditoría",
    "sent_or_received_by": "Enviado o recibido por",
    "severity": "Gravedad",
    "policy": "Política",
    "table": "Filtrar Tabla"
  },
  "edit_columns": {
    "edit_columns": "Editar columnas",
    "select_all": "Seleccionar todo",
    "deselect_all": "Deseleccionar todo",
    "search_columns": "Buscar columnas",
    "reset_to_default": "Restablecer a valores predeterminados",
    "no_columns_found": "No se encontraron columnas",
    "selected": "Seleccionado",
    "select": "Seleccionar"
  },
  "footer": {
    "rights_reserved": "© 2026 Tuvis Todos los derechos reservados.",
    "privacy_policy": "Política de privacidad",
    "terms_conditions": "Términos y condiciones"
  },
  "search_orgs": {
    "invite_to_platform": "Provisión nueva organización",
    "search_orgs": "Buscar organizaciones",
    "change_organization_name": "Cambiar el nombre de la organización",
    "would_you_like_to_change_organization_name": "¿Desea cambiar el nombre de la organización?",
    "edit_organization_identity_section": "Identidad de la organización",
    "organization_name": "Nombre de la organización",
    "change": "Cambiar",
    "cancel": "Cancelar",
    "organization_name_updated": "Nombre de la organización actualizado",
    "failed_to_update_organization_name": "Error al actualizar el nombre de la organización",
    "organization_description": "Descripción de la organización",
    "organization_description_updated": "Descripción de la organización actualizada",
    "failed_to_update_organization_description": "Error al actualizar la descripción de la organización"
  },
  "chat_groups": {
    "title": "Chats de grupo"
  },
  "users_page": {
    "user_not_found": "Usuario no encontrado",
    "title": "Usuarios",
    "add_phone": "Añadir Teléfono",
    "actions": {
      "name": "Usuarios",
      "resend_invite": "Reenviar invitación",
      "enable_desktop": "Habilitar WhatsApp (Aplicación de escritorio Tuvis)",
      "disable_desktop": "Deshabilitar WhatsApp (Aplicación de escritorio Tuvis)",
      "disable": "Deshabilitar usuario",
      "reactive": "Reactivar usuario",
      "sidecar_settings": "Cambiar la configuración del dispositivo",
      "merge_users": "Combinar usuarios"
    },
    "toasts": {
      "invite_failed_user_exists": "La dirección de correo ya existe; reenvía la invitación en su lugar"
    }
  },
  "notifications_settings_page": {
    "title": "Notificaciones"
  },
  "super_admin_page": {
    "title": "Super Admin",
    "subHeader": "Manage Organization Settings",
    "saved_successfully": "Organization settings were successfully saved",
    "saved_failed": "Organization settings failed to save"
  },
  "whatsapp_business_api_agent_page": {
    "title": "Agente",
    "react": "Reaccionar",
    "reply": "Responder"
  },
  "channels": {
    "title": "Sincronización remota",
    "all_remote_devices": "Todos los Dispositivos Remotos",
    "enable": "Habilitar",
    "disable": "Deshabilitar",
    "confirm_disable_modal_text": "¿Estás seguro/a de que deseas deshabilitar el canal de {{channel}}?",
    "confirm_enable_modal_text": "¿Estás seguro/a de que deseas habilitar el canal de {{channel}}?",
    "confirm_button": "Confirmar",
    "desktop": "WhatsApp (App desktop Tuvis)",
    "tuvis_desktop_app": "Tuvis Desktop App",
    "whatsapp": "WhatsApp",
    "mobile_call_recording": "Grabación de llamadas móviles",
    "imessage": "iMessage",
    "telegram": "Telegram",
    "unavailable": {
      "title": "Canal no disponible",
      "message": "{{channel}} no está incluido en tu plan actual. Contacta a nuestro equipo de Ventas para habilitarlo."
    },
    "analytics": {
      "device_connected_rate": "Tasa de dispositivos conectados",
      "device_connected_rate_tooltip": "Porcentaje de dispositivos de Remote Sync invitados y conectados en este momento.",
      "device_connected_rate_subtext": "{{connected}} / {{total}} dispositivos",
      "average_time_to_pair": "Tiempo promedio de emparejamiento",
      "average_time_to_pair_tooltip": "Promedio de horas desde la última invitación hasta el primer emparejamiento exitoso. Basado en dispositivos emparejados en el rango de fechas seleccionado.",
      "average_time_to_pair_value": "{{hours}} hrs",
      "average_time_to_pair_subtext": "{{count}} dispositivos emparejados"
    }
  },
  "twilio_settings_page": {
    "title": "Grabación de llamadas de Tuvis",
    "add_account": "Añadir cuenta",
    "add_phone": "Comprar número de teléfono",
    "reload": "Recargar",
    "connect_button": "Conectar",
    "need_to_connect": "Para mejorar tu experiencia y desbloquear funciones avanzadas, necesitas conectarte a Grabación de llamadas de Tuvis",
    "empty_state_no_phones_text": "Aún no se han agregado números de teléfono.",
    "no_address_error_message": "Para el país seleccionado, debes tener una dirección para completar esta compra",
    "close_account": "Cerrar cuenta",
    "create_account_loading": "Creando cuenta...",
    "create_account_error": "Error al crear la cuenta",
    "close_account_loading": "Cerrando cuenta...",
    "close_account_error": "Error al cerrar la cuenta",
    "close_account_modal": {
      "title": "Cerrar cuenta",
      "description": "¿Estás seguro de que quieres cerrar esta cuenta?",
      "may_result_1": "Cerrar la cuenta la eliminará de la cuenta de grabación de llamadas de Tuvis.",
      "may_result_2": "- La grabación de llamadas de Tuvis liberará todos los números de teléfono de la subcuenta.",
      "may_result_3": "- La cuenta de grabación de llamadas de Tuvis no podrá realizar ni recibir llamadas telefónicas ni enviar ni recibir mensajes SMS",
      "may_result_4": "- La cuenta de grabación de llamadas de Tuvis no se puede volver a abrir",
      "may_result_5": "- La grabación de llamadas de Tuvis eliminará todos los datos 30 días después del cierre"
    },
    "tabs": {
      "phones": "TELÉFONOS",
      "settings": "CONFIGURACIÓN"
    },
    "cols": {
      "account_sid": "SID DE LA CUENTA",
      "api_sid": "SID DE LA API",
      "api_secret": "SECRETO DE LA API",
      "auth_token": "TOKEN DE AUTENTICACIÓN",
      "sms": "SMS",
      "voice": "Voz",
      "capabilities": "Capacidades",
      "name": "Nombre",
      "status": "Estado",
      "phone": "Teléfono",
      "accountName": "Nombre de la cuenta",
      "accountSid": "SID de la cuenta",
      "type": "Tipo",
      "price": "Precio"
    },
    "status": {
      "connected": "Conectado",
      "pending_connection": "Conexión pendiente"
    },
    "actions_phone_table": {
      "assign_users": "Asignar usuarios",
      "rename_phone": "Renombrar teléfono",
      "connect_phone": "Conectar teléfono",
      "assign_phone": "Asignar teléfono",
      "release_phone": "Liberar teléfono"
    },
    "purchase_phone": {
      "country": "País:",
      "account": "Cuenta:",
      "purchase": "Comprar",
      "confirm_purchase": "¿Estás seguro?",
      "confirm_purchase_body": "¿Estás seguro de que quieres comprar un nuevo número de teléfono?",
      "phone_purchased_successfully": "Número de teléfono comprado exitosamente",
      "phone_purchased_failed": "Error al comprar número de teléfono: {{error}}",
      "confirm_release": "¿Estás seguro?",
      "confirm_release_body": "¿Estás seguro de que quieres liberar este número de teléfono? El número de teléfono se liberará de tu cuenta de Twilio y ya no estará disponible para su uso. Esta acción no se puede deshacer sin la ayuda del soporte de Twilio."
    },
    "connect_to_tuvis_call_recording_modal": {
      "title": "Conectar con Tuvis Call Recording",
      "description": "Ponte en contacto con tu gestor de cuenta de Tuvis para conectar con Tuvis Call Recording"
    }
  },
  "slack_settings_page": {
    "title": "Integración de Slack de Tuvis",
    "fleet": {
      "title": "Aplicaciones de Slack adicionales",
      "description": "Instala aplicaciones de trabajo de Tuvis adicionales para aumentar la capacidad de mensajería de Slack. Cada aplicación añade su propio presupuesto de límite de frecuencia.",
      "install": "Instalar",
      "uninstall": "Desinstalar",
      "installed": "Instalada"
    },
    "need_to_connect": "Instala la aplicación de Slack de Tuvis para comenzar. Haz clic en el botón a continuación para instalar la aplicación y conectar tu espacio de trabajo de Slack para una mensajería instantánea sin problemas.",
    "connect_button": "Instalar Aplicación de Slack",
    "disconnect_button": "Desinstalar Aplicación de Slack",
    "configure_shortcuts_button": "Configurar Atajos",
    "connecting": "Instalando...",
    "connection_failed": "Error al instalar la aplicación de Slack",
    "connected_success": "Aplicación de Slack instalada exitosamente",
    "popup_blocked": "Popup bloqueado por el navegador",
    "oauth_cancelled": "OAuth cancelado por el usuario",
    "installed": {
      "title": "La aplicación de Slack de Tuvis está instalada en {{workspaceName}} ({{workspaceId}})",
      "description": "Ahora puedes comenzar a chatear con tu espacio de trabajo de Slack."
    },
    "shortcut_trigger_missing_banner": {
      "title": "Por favor, note:",
      "description": "Necesitas configurar el atajo de plantilla de WhatsApp."
    },
    "configure_shortcut_modal": {
      "title": "Configurar Atajo de Plantilla de WhatsApp",
      "shortcut_url_label": "URL del Atajo de Slack",
      "invalid_url": "Formato de URL inválido. Formato esperado: https://slack.com/shortcuts/{ID}/{KEY}",
      "save": "Guardar Configuración",
      "success": "Atajo configurado exitosamente",
      "error": "Error al configurar el atajo"
    },
    "uninstall_modal": {
      "title": "Desinstalar Aplicación de Slack de Tuvis",
      "description": "¿Estás seguro de que quieres desinstalar la aplicación de Slack de Tuvis?",
      "description_with_workspace": "¿Estás seguro de que quieres desinstalar la aplicación de Slack de Tuvis de {{workspaceName}}?",
      "warning": "Esta acción no se puede deshacer. Todas las configuraciones de integración de Slack serán eliminadas.",
      "confirm": "Desinstalar Aplicación",
      "cancel": "Cancelar",
      "success": "Aplicación de Slack desinstalada exitosamente",
      "error": "Error al desinstalar la aplicación de Slack"
    },
    "workflow_api_key": {
      "title": "Clave de API del flujo de trabajo",
      "description": "Usa esta clave para configurar la aplicación Tuvis Slack Workflow. Mantenla segura y no la compartas públicamente."
    }
  },
  "teams_settings_page": {
    "title": "Integración de Teams de Tuvis",
    "need_to_connect": "Instala la aplicación de Teams de Tuvis para comenzar. Haz clic en el botón a continuación para instalar la aplicación y conectar tu espacio de trabajo de Teams para una mensajería instantánea sin problemas.",
    "connect_button": "Conectar Teams",
    "disconnect_button": "Desinstalar Aplicación de Teams",
    "configure_shortcuts_button": "Configurar Atajos",
    "connecting": "Conectando...",
    "connection_failed": "Error al conectar la aplicación de Teams",
    "connected_success": "Aplicación de Teams conectada exitosamente",
    "popup_blocked": "Popup bloqueado por el navegador",
    "oauth_cancelled": "OAuth cancelado por el usuario",
    "certificate_auth_description": "Conecta tu tenant de Microsoft Teams usando autenticación basada en certificados para una comunicación segura entre servidores.",
    "step1_certificate": "Paso 1: Descargar Certificado",
    "step1_description": "Descarga un certificado que se utilizará para autenticarse con Microsoft Azure. Cárgalo en el registro de tu aplicación de Azure.",
    "download_certificate": "Descargar Certificado",
    "download_certificate_failed": "Error al descargar el certificado",
    "step2_azure_config": "Paso 2: Configuración de Azure",
    "step2_description": "Ingresa los detalles del registro de tu aplicación de Azure. Puedes encontrarlos en el Portal de Azure en Registros de aplicaciones.",
    "client_id": "ID de Aplicación (Cliente)",
    "client_id_placeholder": "Ingresa tu ID de Aplicación (Cliente) de Azure",
    "tenant_id": "ID de Directorio (Tenant)",
    "tenant_id_placeholder": "Ingresa tu ID de Directorio (Tenant) de Azure",
    "dummy_user_id": "ID de la Cuenta de Servicio",
    "dummy_user_id_placeholder": "Ingresa el ID del objeto de Azure AD de la cuenta de servicio",
    "certificate_required": "Por favor, genera un certificado primero",
    "test_connection_failed": "Error al probar la conexión con Azure",
    "installed": {
      "title": "La aplicación de Teams de Tuvis está instalada en {{workspaceName}} ({{workspaceId}})",
      "description": "Ahora puedes comenzar a chatear con tu espacio de trabajo de Teams."
    },
    "shortcut_trigger_missing_banner": {
      "title": "Por favor, note:",
      "description": "Necesitas configurar el atajo de plantilla de WhatsApp."
    },
    "configure_shortcut_modal": {
      "title": "Configurar Atajo de Plantilla de WhatsApp",
      "guide_title": "Cómo Obtener la URL de Tu Atajo:",
      "step_1": "En el menú lateral izquierdo, haz clic en \"Más\" y luego en \"Herramientas\". Dentro de herramientas, selecciona \"Flujos de trabajo\", haz clic en el botón \"Nuevo\" a la derecha y selecciona \"Crear flujo de trabajo\"",
      "step_2": "Serás redirigido a la nueva página de flujo de trabajo. Haz clic en \"Elegir un evento\", selecciona \"Desde un enlace en Teams\" y finalmente haz clic en \"Continuar\"",
      "step_3": "Haz clic en \"Agregar pasos\". En el cuadro de diálogo abierto, usa el campo \"Buscar pasos\" en la parte superior izquierda y busca \"Send Template\" de Tuvis. Luego, en el campo \"ID de canal\" selecciona la primera opción: \"Canal donde se usó el flujo de trabajo\" y haz clic en \"Guardar\"",
      "step_4": "Haz clic en el botón \"Finalizar\" en la parte superior derecha de la página. Se te pedirá que establezcas un nombre para el flujo de trabajo - recomendamos establecer \"Plantillas de Whatsapp\" como nombre. Después de hacer eso, haz clic en el botón \"Publicar\"",
      "step_5": "¡Excelente! Todo lo que necesitas hacer ahora es copiar el enlace \"Comienza desde un enlace en Teams\" que se muestra en el modal y pegarlo aquí abajo",
      "shortcut_url_label": "URL del Atajo de Teams",
      "invalid_url": "Formato de URL inválido. Formato esperado: https://teams.com/shortcuts/{ID}/{KEY}",
      "save": "Guardar Configuración",
      "success": "Atajo configurado exitosamente",
      "error": "Error al configurar el atajo"
    },
    "uninstall_modal": {
      "title": "Desinstalar Aplicación de Teams de Tuvis",
      "description": "¿Estás seguro de que quieres desinstalar la aplicación de Teams de Tuvis?",
      "description_with_workspace": "¿Estás seguro de que quieres desinstalar la aplicación de Teams de Tuvis de {{workspaceName}}?",
      "warning": "Esta acción no se puede deshacer. Todas las configuraciones de integración de Teams serán eliminadas.",
      "confirm": "Desinstalar Aplicación",
      "cancel": "Cancelar",
      "success": "Aplicación de Teams desinstalada exitosamente",
      "error": "Error al desinstalar la aplicación de Teams"
    }
  },
  "archive_discord_settings_page": {
    "title": "Archivar mensajes de Discord",
    "description": "Conecta tu aplicación de Discord para archivar mensajes de servidores y canales mediante eventos del bot de Discord.",
    "connect_button": "Habilitar archivo",
    "disconnect_button": "Deshabilitar archivo",
    "select_servers_button": "Seleccionar servidores para archivar",
    "add_server_button": "Agregar servidor",
    "connecting": "Conectando...",
    "connection_failed": "Error al habilitar el archivado de Discord",
    "connected_success": "Archivado de Discord habilitado correctamente",
    "step1_discord_config": "Paso 1: Configuración del bot de Discord",
    "step1_description": "Ingresa el ID de aplicación y el token del bot de Discord. Asegúrate de que el bot esté instalado en tu servidor con permisos de lectura de mensajes y con el intent MESSAGE CONTENT habilitado.",
    "application_id": "ID de aplicación",
    "application_id_placeholder": "Ingresa el ID de aplicación de Discord",
    "bot_token": "Token del bot",
    "bot_token_placeholder": "Ingresa el token del bot de Discord",
    "installed": {
      "title": "El archivo de Discord está activo",
      "description": "Tus mensajes de Discord se están archivando en tiempo real."
    },
    "uninstall_modal": {
      "title": "Deshabilitar archivo de Discord",
      "description": "¿Seguro que deseas deshabilitar el archivado de mensajes de Discord? Esto detendrá la captura de nuevos mensajes de Discord.",
      "warning": "Los mensajes ya archivados se conservarán, pero no se capturarán nuevos mensajes.",
      "confirm": "Deshabilitar archivo",
      "cancel": "Cancelar",
      "success": "Archivado de Discord deshabilitado correctamente",
      "error": "Error al deshabilitar el archivado de Discord"
    }
  },
  "elite_token_page": {
    "title": "Token de Seguridad Elite",
    "disclaimer": "Este token es un dato de seguridad sensible. Una vez generado, usted es el único responsable de almacenarlo y gestionarlo de forma segura. Tuvis no conserva una copia de este token.",
    "token_label": "Token de Seguridad",
    "token_subtitle": "Una credencial por organización. Puedes rotarla cuando quieras.",
    "status_active": "Activo",
    "status_not_set": "Sin configurar",
    "user_agent_header_description": "Incluye el token de seguridad en el encabezado del user-agent que envían las apps cliente de Tuvis para que tu sistema de seguridad pueda identificar el tráfico autorizado.",
    "no_token_placeholder": "Aún no se ha generado ningún token",
    "generate_button": "Generar Token",
    "show": "Mostrar token",
    "hide": "Ocultar token",
    "copy": "Copiar token",
    "user_agent_header": "Agregar token elite al agente de usuario",
    "generate_error": "Error al generar el token",
    "update_error": "Error al actualizar la configuración",
    "save_button": "Guardar token",
    "save_success": "Token guardado exitosamente",
    "save_error": "Error al guardar el token",
    "generate_confirm_title": "Advertencia: Acción Crítica",
    "generate_confirm_body": "Generar un nuevo token de seguridad invalidará inmediatamente el actual. Esto interrumpirá la conexión de la aplicación con su servidor hasta que actualice el nuevo token en su stack de seguridad. ¿Está seguro de que desea continuar?",
    "generate_confirm_ok": "Confirmar y Generar",
    "generate_confirm_cancel": "Cancelar",
    "save_confirm_title": "Advertencia: Acción Crítica",
    "save_confirm_body": "Guardar este token reemplazará inmediatamente el actual. Esto interrumpirá la conexión de la aplicación con su servidor hasta que actualice su stack de seguridad con el nuevo token. ¿Está seguro de que desea continuar?",
    "save_confirm_ok": "Confirmar y Guardar",
    "save_confirm_cancel": "Cancelar"
  },
  "api_docs_settings_page": {
    "title": "Documentación de la API"
  },
  "api_keys_settings_page": {
    "title": "Claves API",
    "reload": "Recargar",
    "revoke": "Revocar",
    "close": "Cerrar",
    "base_url": "Base Url",
    "never_access": "Nunca Accedido",
    "create_api_key_desc": "Asegúrate de copiar tu nuevo secreto API ahora. No podrás ver este secreto API de nuevo",
    "add_api_key": "Agregar Clave API",
    "api_key": "Clave API",
    "api_key_name": "Nombre de la Clave API",
    "api_secret": "Secreto API",
    "scopes": "Alcances",
    "name": "Nombre",
    "cols": {
      "name": "NOMBRE",
      "api_key": "CLAVE API",
      "last_accessed": "Último Acceso",
      "type": "TIPO",
      "identifier": "ID"
    },
    "oauth_clients_title": "Clientes OAuth",
    "oauth_client_id": "ID de Cliente",
    "oauth_client_secret": "Secreto de Cliente",
    "oauth_auth_method": "Método de Autenticación",
    "oauth_clients_cert_registered": "Su certificado de cliente TLS ha sido registrado exitosamente.",
    "drop_client_cert": "Suelte su certificado .pem aquí o haga clic para cargar",
    "create_credential": "Crear credencial",
    "add_credential": "Agregar",
    "view_docs": "Documentación de la API",
    "credential_type": "Tipo",
    "type_api_key": "API Key",
    "type_oauth_client": "Cliente OAuth",
    "auth_method_client_secret": "Secreto de cliente",
    "auth_method_tls": "Certificado de cliente (mTLS)",
    "edit_scopes": "Editar alcances",
    "all_scopes": "Todos",
    "revoke_confirm_title": "Revocar credencial",
    "revoke_confirm_body": "Esto revoca la credencial de forma permanente y cualquier aplicación que la use dejará de funcionar. Esta acción no se puede deshacer."
  },
  "add_oauth_client": "Agregar Cliente OAuth",
  "phone_blocklist_settings_page": {
    "title": "Números de teléfono privados",
    "search": "Buscar números de teléfono",
    "add_phones_modal": {
      "trigger": "Agregar números de teléfono",
      "title": "Agregar números a la lista de teléfonos privados",
      "description": "Use el área de texto para agregar números a la lista de teléfonos privados. Puede agregar varios números separándolos por líneas.",
      "placeholder": "Ingrese números de teléfono separados por línea",
      "submit": "Agregar"
    },
    "cols": {
      "phone": "Número de Teléfono"
    },
    "import_phones_modal": {
      "trigger": "Importar",
      "title": "Importar números de teléfono",
      "description": "Elija un archivo CSV con una columna \"Phone\" para importar números de teléfono privados.",
      "confirm": "{{fileName}} fue procesado. Encontramos {{count}} números. ¿Desea agregarlos a la lista de teléfonos privados?",
      "submit": "Importar",
      "loading_message": "Importando números...",
      "success_message": "{{count}} números importados correctamente",
      "failed_message": "Error al importar números"
    },
    "delete_phone_modal": {
      "trigger": "Eliminar Teléfono",
      "title": "Eliminar teléfono de la lista de teléfonos privados",
      "description": "¿Está seguro de eliminar este teléfono de la lista de teléfonos privados?",
      "description_multiple": "¿Está seguro de eliminar {{count}} teléfonos de la lista de teléfonos privados?",
      "submit": "Eliminar",
      "loading_message": "Eliminando teléfono de la lista de teléfonos privados...",
      "success_message": "Teléfono eliminado correctamente",
      "failed_message": "Error al eliminar teléfono"
    }
  },
  "blocked_phones_settings_page": {
    "title": "Números de teléfono bloqueados",
    "search": "Buscar números de teléfono",
    "add_phones_modal": {
      "trigger": "Agregar números",
      "title": "Agregar números a la lista de bloqueados",
      "description": "Use el área de texto a continuación para agregar números a bloquear. Agregue varios separándolos con una nueva línea.",
      "placeholder": "Ingrese números separados por una nueva línea",
      "submit": "Agregar"
    },
    "cols": {
      "phone": "Número de teléfono"
    },
    "import_phones_modal": {
      "trigger": "Importar",
      "title": "Importar números de teléfono",
      "description": "Elija un archivo CSV para importar números bloqueados. Asegúrese de que el CSV tenga una sola columna \"Phone\".",
      "confirm": "{{fileName}} se procesó correctamente. Encontramos {{count}} números. ¿Desea agregarlos a la lista de bloqueados?",
      "submit": "Importar",
      "loading_message": "Importando números de teléfono...",
      "success_message": "{{count}} números importados correctamente",
      "failed_message": "Error al importar números"
    },
    "delete_phone_modal": {
      "trigger": "Eliminar teléfono",
      "title": "Eliminar teléfono de la lista de bloqueados",
      "description": "¿Seguro que desea eliminar este teléfono de la lista de bloqueados?",
      "description_multiple": "¿Seguro que desea eliminar {{count}} teléfonos de la lista de bloqueados?",
      "submit": "Eliminar",
      "loading_message": "Eliminando teléfono de la lista de bloqueados...",
      "success_message": "Teléfono eliminado correctamente",
      "failed_message": "Error al eliminar el teléfono"
    }
  },
  "fraud_detection_page": {
    "title": "Detección de Fraude",
    "description": "Administrar listas de bloqueo de hashes de archivos maliciosos y URLs para protección contra amenazas conocidas",
    "search": "Buscar",
    "tabs": {
      "hashes": "Hashes de Archivos",
      "urls": "URLs Bloqueadas",
      "incidents": "Incidentes"
    },
    "add_hash_modal": {
      "trigger": "Agregar Hash",
      "title": "Agregar hash de archivo malicioso",
      "description": "Ingrese un hash SHA256/MD5 para agregar a la lista de bloqueo. Los mensajes que contengan archivos con hashes coincidentes serán bloqueados.",
      "hash_label": "Hash SHA256/MD5",
      "hash_placeholder": "Ingrese el hash SHA256/MD5",
      "description_label": "Descripción (opcional)",
      "description_placeholder": "Ingrese una descripción para este hash",
      "submit": "Agregar",
      "invalid_hash": "Formato de hash SHA256/MD5 inválido.",
      "loading_message": "Agregando hash...",
      "success_message": "Hash agregado correctamente",
      "failed_message": "Error al agregar hash"
    },
    "add_url_modal": {
      "trigger": "Agregar URL",
      "title": "Agregar URL maliciosa",
      "description": "Ingrese una URL para agregar a la lista de bloqueo. Los mensajes que contengan esta URL serán bloqueados.",
      "url_label": "URL",
      "url_placeholder": "Ingrese la URL (ej: https://sitio-malicioso.com)",
      "description_label": "Descripción (opcional)",
      "description_placeholder": "Ingrese una descripción para esta URL",
      "submit": "Agregar",
      "invalid_url": "Formato de URL inválido.",
      "loading_message": "Agregando URL...",
      "success_message": "URL agregada correctamente",
      "failed_message": "Error al agregar URL"
    },
    "cols": {
      "hash": "Hash",
      "hash_type": "Tipo",
      "url": "URL",
      "description": "Descripción",
      "created_at": "Creado En"
    },
    "import_hashes_modal": {
      "trigger": "Importar CSV",
      "title": "Importar hashes de archivos maliciosos",
      "description": "Elija un archivo CSV para importar hashes de archivos maliciosos. El CSV debe tener las columnas: 'hash' (requerido) y 'description' (opcional).",
      "download_template": "Descargar plantilla CSV",
      "confirm": "{{fileName}} fue procesado correctamente. Encontramos {{count}} hashes. ¿Desea agregarlos a la lista de bloqueo?",
      "submit": "Importar",
      "loading_message": "Importando hashes...",
      "success_message": "{{count}} hashes importados correctamente",
      "failed_message": "Error al importar hashes",
      "csv_errors": {
        "empty_file": "El archivo CSV está vacío",
        "missing_hash_column": "Falta la columna requerida 'hash'",
        "invalid_headers": "Encabezados inválidos encontrados: {{invalidHeaders}}"
      }
    },
    "import_urls_modal": {
      "trigger": "Importar CSV",
      "title": "Importar URLs maliciosas",
      "description": "Elija un archivo CSV para importar URLs maliciosas. El CSV debe tener las columnas: 'url' (requerido) y 'description' (opcional).",
      "download_template": "Descargar plantilla CSV",
      "confirm": "{{fileName}} fue procesado correctamente. Encontramos {{count}} URLs. ¿Desea agregarlas a la lista de bloqueo?",
      "submit": "Importar",
      "loading_message": "Importando URLs...",
      "success_message": "{{count}} URLs importadas correctamente",
      "failed_message": "Error al importar URLs",
      "csv_errors": {
        "empty_file": "El archivo CSV está vacío",
        "missing_url_column": "Falta la columna requerida 'url'",
        "invalid_headers": "Encabezados inválidos encontrados: {{invalidHeaders}}"
      }
    },
    "delete_hash_modal": {
      "trigger": "Eliminar Hash",
      "title": "Eliminar hash de la lista de bloqueo",
      "description": "¿Está seguro de eliminar este hash de la lista de bloqueo?",
      "description_multiple": "¿Está seguro de eliminar {{count}} hashes de la lista de bloqueo?",
      "submit": "Eliminar",
      "loading_message": "Eliminando hash de la lista de bloqueo...",
      "success_message": "Hash eliminado correctamente",
      "failed_message": "Error al eliminar hash"
    },
    "delete_url_modal": {
      "trigger": "Eliminar URL",
      "title": "Eliminar URL de la lista de bloqueo",
      "description": "¿Está seguro de eliminar esta URL de la lista de bloqueo?",
      "description_multiple": "¿Está seguro de eliminar {{count}} URLs de la lista de bloqueo?",
      "submit": "Eliminar",
      "loading_message": "Eliminando URL de la lista de bloqueo...",
      "success_message": "URL eliminada correctamente",
      "failed_message": "Error al eliminar URL"
    },
    "incidents": {
      "columns": {
        "created_at": "Creado En",
        "threat_type": "Tipo de Amenaza",
        "matches": "Coincidencias",
        "attachments": "Adjuntos",
        "sender": "Remitente",
        "recipient": "Destinatario",
        "channel": "Canal",
        "is_group": "Grupo",
        "status": "Estado"
      },
      "threat_types": {
        "all": "Todos los tipos",
        "url": "URL",
        "file_hash": "Hash de Archivo",
        "phone_number": "Número de Teléfono"
      },
      "statuses": {
        "new": "Nuevo",
        "resolved": "Resuelto",
        "dismissed": "Descartado"
      },
      "filters": {
        "title": "Filtrar Incidentes",
        "all_statuses": "Todos los estados",
        "all_types": "Todos los tipos"
      },
      "detail": {
        "header": "Detalles del Incidente",
        "back_to_list": "Volver a incidentes",
        "threat_type": "Tipo de Amenaza",
        "content": "Contenido",
        "matches": "Coincidencias",
        "attachments": "Adjuntos",
        "hash_type": "Tipo de Hash",
        "sender": "Remitente",
        "recipient": "Destinatario",
        "channel": "Canal",
        "is_group": "Chat Grupal",
        "status": "Estado",
        "created_at": "Creado En",
        "incident_id": "ID del Incidente"
      },
      "yes": "Sí",
      "no": "No",
      "more_matches": "y {{count}} más"
    },
    "create_incident": "Crear un incidente",
    "notification_recipients": "Destinatarios de notificaciones personalizados",
    "notification_recipients_placeholder": "Buscar usuarios..."
  },
  "phone_whitelist_settings_page": {
    "title": "Números de Teléfono Permitidos",
    "search": "Buscar números de teléfono",
    "add_phones_modal": {
      "trigger": "Agregar números de teléfono",
      "title": "Agregar números de teléfono a la lista permitida",
      "description": "Utilice el área de texto a continuación para agregar números de teléfono a la lista permitida. Puede agregar varios números separándolos con un salto de línea.",
      "placeholder": "Ingrese números de teléfono separados por línea",
      "submit": "Agregar",
      "loading_message": "Agregando números de teléfono...",
      "success_message": "{{count}} números de teléfono agregados exitosamente",
      "failed_message": "Error al agregar números de teléfono"
    },
    "cols": {
      "phone": "Número de Teléfono"
    },
    "import_phones_modal": {
      "trigger": "Importar",
      "title": "Importar números de teléfono",
      "description": "Elija un archivo CSV para importar números de teléfono permitidos. Asegúrese de que su archivo CSV solo tenga una columna \"Phone\" con números de teléfono.",
      "confirm": "{{fileName}} fue procesado exitosamente. Encontramos {{count}} números de teléfono. ¿Desea agregarlos a la lista permitida?",
      "submit": "Importar",
      "loading_message": "Importando números de teléfono...",
      "success_message": "{{count}} números de teléfono importados exitosamente",
      "failed_message": "Error al importar números de teléfono"
    },
    "delete_phone_modal": {
      "trigger": "Eliminar Teléfono",
      "title": "Eliminar número de teléfono",
      "description": "¿Está seguro de que desea eliminar este número de teléfono de la lista permitida?",
      "description_multiple": "¿Estás seguro de que deseas eliminar {{count}} números de teléfono de la lista permitida?",
      "submit": "Sí, Eliminar",
      "loading_message": "Eliminando...",
      "success_message": "Número de teléfono eliminado exitosamente",
      "failed_message": "Error al eliminar número de teléfono"
    }
  },
  "whatsapp_business_api_settings_page": {
    "add_phone_successfully_toast": "Nuevo teléfono agregado con éxito",
    "add_phone_failed_toast": "Error al agregar el número de teléfono",
    "code_sent_successfully_toast": "Código enviado correctamente",
    "code_sent_failed_toast": "Error al solicitar el código",
    "phone_verified_successfully_toast": "Teléfono verificado correctamente",
    "phone_verified_failed_toast": "No se pudo verificar el número, por favor inténtalo de nuevo",
    "verifyMethodModal": {
      "title": "Elegir método de verificación",
      "submit_button": "Siguiente",
      "text": "Elija cómo desea verificar su número:",
      "desc": "Si está utilizando un número de teléfono fijo, elija la llamada telefónica."
    },
    "verifyModal": {
      "title": "Verificar número de teléfono",
      "text": "Hemos enviado un código de verificación a {{phone}}. Para verificar su número, ingrese el código de 6 dígitos."
    },
    "verifyMethod": {
      "sms": "Mensaje de texto",
      "voice": "Llamada telefónica"
    },
    "addPhoneNumberModal": {
      "title": "Agregar un número de teléfono para WhatsApp",
      "phone_number_field_title": "Número de teléfono",
      "phone_number_field_sub_title": "Este es el número que la gente verá cuando chatee contigo.",
      "phone_number_field_sub_title_link": "Aprende cómo usar un número que ya está en WhatsApp.",
      "name_field_title": "Nombre de visualización de WhatsApp Business",
      "name_field_sub_title": "Tu nombre de visualización debe coincidir con el nombre de tu negocio y adherirse a las pautas de nombres de visualización de WhatsApp Business.",
      "name_field_sub_title_link": "Aprende más sobre las pautas de nombres de visualización.",
      "select_account_placeholder": "Por favor, selecciona una cuenta de WhatsApp"
    },
    "title": "WhatsApp Business API",
    "need_to_connect": "Para mejorar su experiencia y desbloquear funciones avanzadas, necesita conectarse a la API de WhatsApp Business",
    "connect_button": "Conectar",
    "disconnect_button": "Desconectar",
    "disconnect_modal_title": "Desconectar WhatsApp Business API",
    "disconnect_modal_message": "¿Estás seguro de que quieres desconectar '{{wabaName}}'?",
    "reload": "Recargar",
    "settings_saved_successfully": "La configuración se guardó correctamente",
    "settings_saved_failed": "Error al guardar la configuración",
    "code_status": {
      "NOT_VERIFIED": "No verificado",
      "VERIFIED": "Verificado",
      "NONE": "Ninguno",
      "EXPIRED": "Caducado"
    },
    "name_status": {
      "APPROVED": "Aprobado",
      "AVAILABLE_WITHOUT_REVIEW": "Disponible",
      "DECLINED": "Rechazado",
      "EXPIRED": "Caducado",
      "PENDING_REVIEW": "Pendiente de revisión",
      "NONE": "Ninguno"
    },
    "template_status": {
      "APPROVED": "Aprobado",
      "REJECTED": "Rechazado",
      "PENDING": "Pendiente",
      "NONE": "Ninguno"
    },
    "cols": {
      "phone": "Teléfono",
      "phone_id": "ID del teléfono",
      "display_name": "Nombre de pantalla",
      "name_status": "Status nombre de pantalla",
      "code_status": "Status código",
      "businessName": "Nombre del negocio",
      "wabaName": "Cuenta WhatsApp Business",
      "businessStatus": "Estado del negocio",
      "smartersStatus": "Estado de Smarters",
      "templateName": "Nombre de la plantilla",
      "languages": "Idiomas",
      "status": "Estado",
      "template_available": "Plantilla disponible",
      "user_groups": "Grupos de usuarios",
      "purpose": "Propósito"
    },
    "purpose": {
      "all": "Todos",
      "opt-in": "Opt-In",
      "campaign": "Campaña"
    },
    "preview_template": {
      "title": "{{name}}",
      "action": "Vista previa"
    },
    "edit_template": {
      "title": "Editar grupos de plantilla",
      "user_groups_label": "Grupos de usuarios",
      "all_users": "Todos los usuarios",
      "save_success": "Plantilla actualizada correctamente",
      "save_error": "Error al actualizar la plantilla",
      "purpose_title": "Editar propósito de plantilla",
      "purpose_label": "Propósito",
      "purpose_opt_in": "Opt-In",
      "purpose_campaign": "Campaña"
    },
    "actions_phone_table": {
      "set_smarters_token": "Establecer token de Smarters",
      "delete_smarters_token": "Eliminar token de Smarters",
      "update_smarters_token": "Actualizar token de Smarters",
      "assign_users": "Asignar usuarios",
      "verify_number": "Verificar número"
    },
    "smarters_modal": {
      "placeholder": "Ingrese el token de Smarters",
      "delete_token_message": "¿Estás seguro de que deseas eliminar el token de Smarters del número de teléfono: {{phoneNumber}}"
    },
    "empty_state_no_phones_text": "Aún no se han agregado números de teléfono.",
    "empty_state_no_phones_button": "Agregar nuevo número",
    "empty_state_no_template_message": "Para comenzar, crea tu primer plantilla de WhatsApp Business API",
    "empty_state_no_template_button": "Agregar plantilla",
    "failed_to_disconnect": "No se pudo desconectar de la API de WhatsApp Business. Por favor, inténtalo de nuevo.",
    "failed_to_connect": "No se pudo conectar a la API de WhatsApp Business. Por favor, inténtalo de nuevo.",
    "tabs": {
      "phones": "TELÉFONOS",
      "settings": "CONFIGURACIÓN",
      "templates": "PLANTILLAS"
    },
    "create_template": "Crear plantilla",
    "create_template_loading_toast": "Creando plantilla...",
    "create_template_success_toast": "Plantilla enviada para aprobación",
    "create_template_failed_toast": "Error al crear la plantilla",
    "createTemplateModal": {
      "title": "Crear Plantilla de WhatsApp",
      "template_name": "Nombre de la Plantilla",
      "template_name_tooltip": "El nombre debe ser en minúsculas, sin espacios ni caracteres especiales (use guiones bajos).",
      "template_name_placeholder": "ej: confirmacion_pedido",
      "waba_account": "Cuenta WhatsApp Business",
      "category": "Categoría",
      "language": "Idioma",
      "header_type": "Encabezado",
      "header_text_placeholder": "Texto del encabezado (máx. 60 caracteres)",
      "body": "Cuerpo",
      "body_placeholder": "Ingrese el cuerpo del mensaje. Use {{1}}, {{2}} para parámetros dinámicos.",
      "body_helper": "Para agregar una variable, use {{#}} donde # es el índice de la variable comenzando desde 1.",
      "parameter_sample": "Ejemplo para {{param}}",
      "parameter_sample_placeholder": "Ingrese el valor de ejemplo",
      "footer": "Pie de página",
      "footer_placeholder": "Texto del pie de página (máx. 60 caracteres)",
      "buttons": "Botones",
      "add_button": "+ Agregar Botón",
      "button_text_placeholder": "Texto del botón",
      "button_text_too_long": "El texto del botón no puede tener más de {{max}} caracteres",
      "button_url_placeholder": "https://ejemplo.com",
      "max_buttons_reached": "Máximo 3 botones",
      "submit": "Crear Plantilla",
      "category_utility": "Utilidad",
      "category_marketing": "Marketing",
      "header_none": "Ninguno",
      "header_text": "Texto",
      "button_quick_reply": "Respuesta Rápida",
      "button_url": "URL",
      "template_preview_placeholder": "La vista previa de la plantilla aparecerá aquí",
      "no_buttons_text": "No se han agregado botones. Haga clic en + para agregar hasta 3 botones.",
      "header_image": "Imagen",
      "header_video": "Video",
      "header_document": "Documento",
      "header_media_upload": "Subir medios de ejemplo",
      "header_media_uploading": "Subiendo...",
      "header_media_uploaded": "Medios subidos",
      "header_media_upload_failed": "Error al subir medios"
    },
    "add_waba_account": "Agregar cuenta",
    "add_waba_phone": "Agregar número de teléfono",
    "business_status_tag": {
      "rejected": "Rechazado",
      "verified": "Verificado",
      "pending": "Pendiente",
      "not_verified": "No Verificado",
      "pending_submission": "Pendiente de Envío",
      "auth_error": "Reconexión requerida"
    }
  },
  "sidecars_page": {
    "title_short": "Remote Sync",
    "title": "Tuvis Remote Sync"
  },
  "all_users": {
    "title": "Todos los usuarios"
  },
  "internal_admin_tools": {
    "global_user_search": "Todos los usuarios",
    "org_explorer": "Explorador de Orgs"
  },
  "user_groups": {
    "headers": {
      "group_details": "Detalles del Grupo"
    },
    "remove_user_from_group": "Eliminar usuario del grupo",
    "disabled_edit_name_tooltip": "Este nombre de grupo no se puede editar ya que\nestá sincronizado desde un sistema externo",
    "disabled_add_user_tooltip": "No puedes añadir usuarios a este grupo porque está sincronizado desde un sistema externo",
    "title": "Grupos de usuarios",
    "add_group": "Agregar grupo",
    "add_user": "Agregar usuario",
    "remove_user": "Eliminar usuario {{userName}}",
    "remove_group": "Eliminar grupo",
    "update_group": "Actualizar grupo",
    "name": "Nombre",
    "type": "Tipo",
    "users": "Usuarios",
    "external_scim": "SSO",
    "external_sfdc": "Salesforce Profile",
    "confirm_delete_group": "¿Estás seguro de que deseas eliminar este grupo?",
    "confirm_remove_user": "¿Estás seguro de que deseas eliminar este usuario?",
    "errors": {
      "default": "Ocurrió un error al procesar tu solicitud",
      "duplicate_key": "Ya existe un grupo con este nombre",
      "license_limit_reached": "Límite de licencias alcanzado. Habilitar este canal excedería los puestos disponibles.",
      "load_failed": "Error al cargar los grupos de usuarios"
    },
    "configs": {
      "activities_create": "Crear Actividades",
      "activities_display": "Mostrar Actividades",
      "show_chat_now_action": "Mostrar Acción Chat Ahora",
      "cases_create": "Crear Casos",
      "cases_display": "Mostrar Casos",
      "auto_sync_activities_limit": "Límite Auto Sync Actividades",
      "contacts_create": "Crear Contactos",
      "contacts_display": "Mostrar Contactos",
      "create_person_account": "Crear cuentas personales",
      "auto_sync_cases_limit": "Límite Auto Sync Casos",
      "leads_create": "Crear Leads",
      "leads_display": "Mostrar Leads",
      "opps_display": "Mostrar Oportunidades",
      "show_person_account": "Mostrar cuentas personales",
      "tasks_create": "Crear Tareas",
      "tasks_display": "Mostrar Tareas",
      "filter_analytics_by_profile": "Filtrar Analíticas por Perfil",
      "show_edit_layout": "Mostrar Editar Diseño",
      "block_unknown_person": "Bloquear Persona Desconocida",
      "show_auto_sync_button": "Mostrar Botón Auto Sync",
      "show_global_search": "Mostrar Búsqueda Global",
      "show_new_event_action": "Mostrar Acción Nuevo Evento",
      "show_add_to_phone_action": "Mostrar Acción Añadir a Teléfono",
      "show_calendar": "Mostrar Calendario",
      "hide_all_create_actions": "Ocultar Todas las Acciones Crear",
      "periodic_auto_sync": "Sincronizar periódicamente todos los mensajes",
      "show_whatsapp_calls": "Mostrar Llamadas de WhatsApp"
    }
  },
  "users_lists": {
    "load_failed": "Error al cargar la lista de usuarios"
  },
  "group_metadata": {
    "title": "Grupos de WhatsApp",
    "details_title": "Detalles del Grupo de WhatsApp",
    "subject": "Nombre del Grupo",
    "no_subject": "N/A",
    "group_id": "ID del Grupo",
    "source_phone": "Teléfono de Origen",
    "participants": "Participantes",
    "participants_count": "{{count}} participantes",
    "creation_date": "Fecha de Creación",
    "last_message_date": "Último Mensaje",
    "member_add_mode": "Modo de Agregar Miembros",
    "restrict": "Restringido",
    "participant_name": "Nombre",
    "participant_phone": "Número de Teléfono",
    "is_admin": "Administrador",
    "no_name": "N/A",
    "no_participants": "Sin participantes",
    "not_found": "Grupo no encontrado",
    "filter_by_user_placeholder": "Filtrar por usuario",
    "show_only_disabled_users": "Mostrar solo usuarios deshabilitados",
    "participant_type": "Tipo de usuario",
    "org_user": "Usuario org",
    "external_user": "Externo",
    "member_add_mode_all_members": "Todos los miembros",
    "member_add_mode_only_admin": "Solo admin",
    "search_empty": {
      "no_results": "Aún no se han sincronizado grupos de WhatsApp"
    },
    "search_placeholder": "Buscar grupos por nombre...",
    "view_logs": "Ver registros",
    "logs_modal": {
      "title": "Registros de actividad del grupo",
      "event_type": "Tipo de evento",
      "performed_by": "Realizado por",
      "affected": "Afectado",
      "date_time": "Fecha y hora",
      "no_events": "No se encontraron registros de actividad"
    },
    "event_type": {
      "subject": "Nombre cambiado",
      "add": "Usuario añadido",
      "remove": "Usuario eliminado",
      "leave": "Usuario salió",
      "create": "Grupo creado",
      "restrict": "Permiso de edición cambiado",
      "restrict_on": "Edición: Solo administradores",
      "restrict_off": "Edición: Todos los miembros",
      "announce": "Permiso de mensajes cambiado",
      "announce_on": "Mensajes: Solo administradores",
      "announce_off": "Mensajes: Todos los miembros",
      "member_add_mode": "Modo de adición cambiado",
      "member_add_mode_on": "Adición: Solo administradores",
      "member_add_mode_off": "Adición: Todos los miembros"
    }
  },
  "audit_log": {
    "filters": "Filtros",
    "title": "Registro de auditoría",
    "unknown_user": "Usuario desconocido",
    "reason": "razón",
    "from": "de",
    "to": "a",
    "header": {
      "type": "Tipo",
      "event": "Evento",
      "time": "Tiempo",
      "description": "Descripción"
    },
    "namespaces": {
      "sidecars": "Tuvis Remote Sync",
      "integrations": "Integraciones",
      "users": "Usuarios",
      "userGroups": "Grupos",
      "settings": "Configuraciones",
      "waba": "WhatsApp Business API",
      "twilio": "Grabación de llamadas da Tuvis",
      "auth": "Autenticación",
      "dlp": "Data Loss Protection",
      "surveillance": "Vigilancia",
      "incident": "Incidentes",
      "urlPolicies": "Políticas de acceso",
      "browserControls": "Controles del navegador",
      "email": "Correo electrónico",
      "keywordInsights": "Información de Palabras Clave",
      "phonesWhitelist": "Lista de teléfonos permitidos",
      "phonesBlocklist": "Números de teléfono privados",
      "blockedPhones": "Teléfonos Bloqueados (chat)",
      "tuvisContacts": "Contactos de Tuvis",
      "fraudDetection": "Detección de Fraude",
      "dashboards": "Vista personalizada",
      "customFilters": "Filtros personalizados",
      "accounts": "Cuentas",
      "archive": "Archivo",
      "platforms": "Plataformas",
      "saml": "SAML",
      "botFlows": "Flujos de bot"
    },
    "descriptions": {
      "dashboard_created": {
        "event_name": "Panel Creado",
        "description": "El panel \"{{metadata.name}}\" fue creado por {{metadata.userName}}"
      },
      "dashboard_updated": {
        "event_name": "Panel Actualizado",
        "description": "El panel \"{{metadata.name}}\" fue actualizado por {{metadata.userName}}"
      },
      "dashboard_deleted": {
        "event_name": "Panel Eliminado",
        "description": "El panel \"{{metadata.name}}\" fue eliminado por {{metadata.userName}}"
      },
      "widget_created": {
        "event_name": "Widget Creado",
        "description": "El widget \"{{metadata.title}}\" fue añadido al panel por {{metadata.userName}}"
      },
      "widget_deleted": {
        "event_name": "Widget Eliminado",
        "description": "El widget \"{{metadata.title}}\" fue eliminado del panel por {{metadata.userName}}"
      },
      "incident_summary_reported": {
        "event_name": "Resumen Reportado",
        "description": "Informe de Resumen del Incidente Enviado por Correo Electrónico"
      },
      "incident_reported": {
        "event_name": "Incidente Reportado",
        "description": "Incidente creado por '{{metadata.userName}}'"
      },
      "new_url_policy": {
        "event_name": "Nueva Política de URL Creada",
        "description": "Política de URL creada por '{{metadata.userName}}'"
      },
      "update_url_policy": {
        "event_name": "Política de URL Actualizada",
        "description": "Política de URL actualizada por '{{metadata.userName}}'"
      },
      "delete_url_policy": {
        "event_name": "Política de URL Eliminada",
        "description": "Política de URL eliminada por '{{metadata.userName}}'"
      },
      "new_surveillance_policy": {
        "event_name": "Nueva Política de Vigilancia Creada",
        "description": "Política de vigilancia creada por '{{metadata.userName}}'"
      },
      "update_surveillance_policy": {
        "event_name": "Política de vigilancia actualizada",
        "description": "Política de vigilancia actualizada por '{{metadata.userName}}'"
      },
      "delete_surveillance_policy": {
        "event_name": "Política de vigilancia eliminada",
        "description": "Política de vigilancia eliminada por '{{metadata.userName}}'"
      },
      "new_surveillance_rule": {
        "event_name": "Nueva Regla de Vigilancia Creada",
        "description": "Regla de vigilancia creada por '{{metadata.userName}}'"
      },
      "update_surveillance_rule": {
        "event_name": "Regla de vigilancia actualizada",
        "description": "Regla de vigilancia actualizada por '{{metadata.userName}}'"
      },
      "delete_surveillance_rule": {
        "event_name": "Regla de vigilancia eliminada",
        "description": "Regla de vigilancia eliminada por '{{metadata.userName}}'"
      },
      "new_incident": {
        "event_name": "Nuevo Incidente Creado",
        "description": "Incidente creado por '{{metadata.userName}}'"
      },
      "update_incident_status": {
        "event_name": "Estado del Incidente Actualizado",
        "description": "Estado del incidente cambiado a '{{metadata.status}}' por '{{metadata.userName}}'"
      },
      "update_surveillance_incident_status": {
        "event_name": "Estado del Incidente de Vigilancia Actualizado",
        "description": "Estado del incidente de vigilancia cambiado a '{{metadata.status}}' por '{{metadata.userName}}'"
      },
      "surveillance_incident_reported": {
        "event_name": "Incidente de Vigilancia Reportado",
        "description": "Incidente de vigilancia reportado por '{{metadata.userName}}'"
      },
      "update_incident_assignee": {
        "event_name": "Asignado del Incidente Actualizado",
        "description": "Asignado del incidente actualizado a '{{metadata.assigneeName}}' por '{{metadata.userName}}'"
      },
      "create_policy": {
        "event_name": "Usuario Creó Política",
        "description": "Usuario {{metadata.userName}} creó política - {{metadata.policy.name}}"
      },
      "update_policy": {
        "event_name": "Política Actualizada",
        "description": "Usuario {{metadata.userName}} actualizó política - {{metadata.policy.name}}"
      },
      "delete_policy": {
        "event_name": "Política Eliminada",
        "description": "Usuario {{metadata.userName}} eliminó política - {{metadata.policyName}}"
      },
      "create_rule": {
        "event_name": "Usuario Creó Regla DLP",
        "description": "Usuario {{metadata.userName}} creó regla - {{metadata.rule.name}}"
      },
      "update_rule": {
        "event_name": "Regla DLP Actualizada",
        "description": "Usuario {{metadata.userName}} actualizó regla - {{metadata.rule.name}}"
      },
      "delete_rule": {
        "event_name": "Regla DLP Eliminada",
        "description": "Usuario {{metadata.userName}} eliminó regla - {{metadata.ruleName}}"
      },
      "disconnected": {
        "event_name": "Dispositivo Desconectado",
        "description": "Dispositivo de {{channel}} desconectado - {{sidecarName}}"
      },
      "run_completed": {
        "event_name": "Sincronización Mobile Concluida",
        "description": "Sincronización de dispositivo completada - {{sidecarName}}"
      },
      "run_failed": {
        "event_name": "Fallo en la Ejecución Mobile",
        "description": "Error en la sincronización de dispositivo - {{sidecarName}}"
      },
      "pairing_phone_mismatch": {
        "event_name": "Incompatibilidad Número Mobile",
        "description": "Error al emparejar el dispositivo {{channel}} por discrepancia de número de teléfono - {{sidecarName}}"
      },
      "pairing_success": {
        "event_name": "Usuario Emparejado Mobile",
        "description": "Dispositivo de {{channel}} emparejado exitosamente - {{sidecarName}}"
      },
      "pairing_failed": {
        "event_name": "Fallo al Vincular Dispositivo",
        "description": "Error al vincular el dispositivo {{channel}} - {{sidecarName}}"
      },
      "created": {
        "event_name": "Conexión Mobile Creada",
        "description": "Dispositivo creado por {{metadata.inviter}} - {{sidecarName}}"
      },
      "invited": {
        "event_name": "Usuario Invitado Mobile",
        "description": "{{metadata.senderUserName}} invitó a {{metadata.recipientName}} ({{metadata.email}}) a emparejar con Tuvis"
      },
      "auto_invited": {
        "event_name": "Usuario Auto-Invitado a Emparejar",
        "description": "Automáticamente invitado {{metadata.email}} a emparejar con Tuvis"
      },
      "update_settings": {
        "event_name": "Configuraciones Mobile Actualizadas",
        "description": "Configuración de dispositivo actualizada por {{userName}}{{sidecarName}}"
      },
      "started": {
        "event_name": "Sincronización Mobile Iniciada",
        "description": "Sincronización de dispositivo iniciada - {{sidecarName}}"
      },
      "started_pairing": {
        "event_name": "Inicio de Emparejamiento Mobile",
        "description": "Emparejamiento de dispositivo iniciado - {{sidecarName}}"
      },
      "deleted": {
        "event_name": "Mobile Eliminado con Éxito",
        "description": "Dispositivo{{sidecarName}} eliminado por {{userName}}"
      },
      "connect": {
        "event_name": "Usuario Conectó Integración",
        "description": "Integración {{metadata.type}} conectada"
      },
      "disconnect": {
        "event_name": "Integración Desconectada",
        "description": "Integración {{metadata.type}} desconectada"
      },
      "update": {
        "event_name": "Integración Actualizada",
        "description": "Integración {{metadata.type}} actualizada"
      },
      "clear_query_cache": {
        "event_name": "Caché de Consulta SFDC Borrada",
        "description": "Caché de consulta SFDC borrada"
      },
      "login": {
        "event_name": "Usuario Conectado",
        "description": "Usuario {{name}} ha iniciado sesión exitosamente en {{platform}} con {{crmAuthProvider}}"
      },
      "update_permissions": {
        "event_name": "Permisos del Usuario Actualizados",
        "description": "Permisos de usuario actualizados - {{userName}} cambió los permisos de {{whatsllyUserName}}"
      },
      "edit_user": {
        "event_name": "Usuario Editó Valor",
        "description": "Usuario actualizado - {{userName}} editó a {{whatsllyUserName}}"
      },
      "disabled_user": {
        "event_name": "Cuenta Desactivada",
        "description": "Usuario Deshabilitado - {{userName}} deshabilitó a {{whatsllyUserName}}"
      },
      "activate_user": {
        "event_name": "Cuenta Activada",
        "description": "Usuario Activado - {{userName}} activó a {{whatsllyUserName}}"
      },
      "users_invited": {
        "event_name": "Varios Usuarios Invitados",
        "description": "Usuarios invitados - {{userName}} invitó a {{emails}}"
      },
      "user_invited": {
        "event_name": "Usuario Invitado",
        "description": "{{inviterName}} invitó a {{recipientName}} a conectarse con Tuvis"
      },
      "user_was_invited": {
        "event_name": "Invitado a Conectar",
        "description": "{{recipientName}} fue invitado por {{inviterName}} a conectarse con Tuvis"
      },
      "invite_deleted": {
        "event_name": "Invitación de Usuario Eliminada",
        "description": "Invitación de usuario eliminada - {{userName}} eliminó la invitación de {{emails}}"
      },
      "download_csv": {
        "event_name": "CSV de Usuarios Descargado",
        "description": "CSV de Usuarios Descargado - {{userName}} descargó el csv de usuarios"
      },
      "new_user": {
        "event_name": "Nuevo Usuario Agregado",
        "description": "Nuevo usuario creado - {{userName}} ({{emails}})"
      },
      "merge_users": {
        "event_name": "Usuarios fusionados",
        "description": "Se fusionaron {{metadata.movedIdentities}} identidades vinculadas en el usuario resultante"
      },
      "read_messages": {
        "event_name": "Usuario Leyó Mensajes",
        "description": "Usuario '{{userName}}' ha leído los mensajes de '{{viewedUserName}}'"
      },
      "assign_user": {
        "event_name": "Usuarios Asignados al Grupo",
        "description": "{{userName}} añadió {{count}} usuarios al grupo {{groupName}}"
      },
      "unassign_user": {
        "event_name": "Usuarios Removidos del Grupo",
        "description": "{{userName}} removió {{count}} usuarios del grupo {{groupName}}"
      },
      "create_group": {
        "event_name": "Grupo Creado",
        "description": "Grupo creado - {{userName}} creó {{groupName}}"
      },
      "update_group": {
        "event_name": "Grupo Actualizado",
        "description": "Grupo actualizado - {{userName}} actualizó {{groupName}}"
      },
      "remove_group": {
        "event_name": "Grupo Eliminado",
        "description": "Grupo eliminado - {{userName}} eliminó {{groupName}}"
      },
      "set_global_layout": {
        "event_name": "Diseño Global Actualizado",
        "description": "Diseño Global actualizado"
      },
      "set_hide_edit_layout": {
        "event_name": "Ocultar Diseño de Edición Actualizado",
        "description": "Ocultar Diseño de Edición actualizado - {{configValue}}"
      },
      "reset_user_layouts": {
        "event_name": "Diseños de Usuario Restablecidos",
        "description": "Diseños de Usuario Restablecidos"
      },
      "org_configs_updated": {
        "event_name": "Configuración de la Org Actualizada",
        "description": "{{userName}} cambió la configuración de la organización {{orgConfigsUpdateds}} {{reason}}"
      },
      "elite_token_generated": {
        "event_name": "Token de Seguridad Elite Generado",
        "description": "{{userName}} generó un nuevo token de seguridad elite"
      },
      "elite_token_updated": {
        "event_name": "Token de Seguridad Elite Actualizado",
        "description": "{{userName}} actualizó el token de seguridad elite"
      },
      "change_org_name": {
        "event_name": "Perfil de la organización actualizado",
        "description": "{{userName}} actualizó el perfil de la organización {{orgConfigsUpdateds}}"
      },
      "create_api_key": {
        "event_name": "Clave API Pública Creada",
        "description": "Clave API pública creada con id {{entityId}}"
      },
      "revoke_api_key": {
        "event_name": "Clave API Pública Revocada",
        "description": "Clave API pública revocada con id {{entityId}}"
      },
      "connected_to_waba": {
        "event_name": "API de WhatsApp Business Conectada",
        "description": "API de WhatsApp Business conectada - {{metadata.userName}}"
      },
      "disconnected_from_waba": {
        "event_name": "API de WhatsApp Business Desconectada",
        "description": "API de WhatsApp Business desconectada - {{userName}}"
      },
      "connected_to_twilio": {
        "event_name": "Integración Twilio Conectada",
        "description": "Twilio conectado - {{metadata.userName}}"
      },
      "disconnected_from_twilio": {
        "event_name": "Twilio Desconectado",
        "description": "Twilio desconectado"
      },
      "purchase-phone": {
        "event_name": "Número Twilio Comprado",
        "description": "Número de teléfono comprado - {{metadata.userName}} compró {{metadata.phone_number}}"
      },
      "update-phone": {
        "event_name": "Número Twilio Actualizado",
        "description": "Número de teléfono actualizado - {{metadata.userName}} actualizó {{metadata.phone_number}}"
      },
      "release-phone": {
        "event_name": "Número Twilio Liberado",
        "description": "Número de teléfono liberado - {{metadata.userName}} liberó {{metadata.phone_number}}"
      },
      "create_campaign": {
        "event_name": "Campaña Creada",
        "description": "Campaña creada - {{metadata.userName}} creó {{metadata.campaign.name}}"
      },
      "update_campaign": {
        "event_name": "Campaña Actualizada",
        "description": "Campaña actualizada - {{metadata.userName}} actualizó {{metadata.campaign.name}}"
      },
      "delete_campaign": {
        "event_name": "Campaña Eliminada",
        "description": "Campaña eliminada - {{metadata.userName}} eliminó {{metadata.campaign.name}}"
      },
      "add_blocklist_phones": {
        "event_name": "Números de teléfono privados agregados",
        "description": "Números de teléfono privados agregados - {{metadata.userName}} agregó {{metadata.addedCount}} números"
      },
      "delete_blocklist_phone": {
        "event_name": "Número de teléfono privado eliminado",
        "description": "Número de teléfono privado eliminado - {{metadata.userName}} eliminó {{metadata.phone}}"
      },
      "add_blocked_phones": {
        "event_name": "Teléfonos Bloqueados (chat) agregados",
        "description": "Teléfonos Bloqueados (chat) agregados - {{metadata.userName}} agregó {{metadata.addedCount}} números"
      },
      "delete_blocked_phone": {
        "event_name": "Teléfonos Bloqueados (chat) eliminados",
        "description": "Teléfonos Bloqueados (chat) eliminados - {{metadata.userName}} eliminó {{metadata.phone}}"
      },
      "add_whitelist_phones": {
        "event_name": "Lista de teléfonos permitidos agregada",
        "description": "Lista de teléfonos permitidos agregada - {{metadata.userName}} agregó {{metadata.addedCount}} números telefónicos"
      },
      "delete_whitelist_phone": {
        "event_name": "Lista de teléfonos permitidos eliminada",
        "description": "Lista de teléfonos permitidos eliminada - {{metadata.userName}} eliminó {{metadata.phone}}"
      },
      "new_tuvis_contact": {
        "event_name": "Contacto de Tuvis Creado",
        "description": "Contacto de Tuvis Creado - {{metadata.userName}} creó {{entityId}}"
      },
      "update_tuvis_contact": {
        "event_name": "Contacto de Tuvis Actualizado",
        "description": "Contacto de Tuvis Actualizado - {{metadata.userName}} actualizó {{entityId}}"
      },
      "delete_tuvis_contact": {
        "event_name": "Contacto de Tuvis Eliminado",
        "description": "Contacto de Tuvis Eliminado - {{metadata.userName}} eliminó {{entityId}}"
      },
      "import_tuvis_contacts": {
        "event_name": "Contactos de Tuvis Importados",
        "description": "Contactos de Tuvis Importados - {{metadata.userName}} importó {{metadata.contacts.length}} contactos"
      },
      "add_malicious_hashes": {
        "event_name": "Hashes maliciosos agregados",
        "description": "Hashes maliciosos agregados - {{metadata.userName}} agregó {{metadata.addedCount}} hashes"
      },
      "delete_malicious_hashes": {
        "event_name": "Hashes maliciosos eliminados",
        "description": "Hashes maliciosos eliminados - {{metadata.userName}} eliminó {{metadata.hashes.length}} hashes"
      },
      "add_malicious_urls": {
        "event_name": "URLs maliciosas agregadas",
        "description": "URLs maliciosas agregadas - {{metadata.userName}} agregó {{metadata.addedCount}} URLs"
      },
      "delete_malicious_urls": {
        "event_name": "URLs maliciosas eliminadas",
        "description": "URLs maliciosas eliminadas - {{metadata.userName}} eliminó {{metadata.urls.length}} URLs"
      },
      "create_account": {
        "event_name": "Cuenta creada",
        "description": "Cuenta creada - {{metadata.name}}"
      },
      "update_account": {
        "event_name": "Cuenta actualizada",
        "description": "Cuenta actualizada - {{metadata.name}}"
      },
      "unassign_org": {
        "event_name": "Organización desasignada de la cuenta",
        "description": "Organización desasignada de la cuenta"
      },
      "update_user_permissions": {
        "event_name": "Permisos de usuario de la cuenta actualizados",
        "description": "Permisos de usuario de la cuenta actualizados"
      },
      "delete_account_users": {
        "event_name": "Usuarios eliminados de la cuenta",
        "description": "Usuarios eliminados de la cuenta - {{metadata.count}} usuario(s)"
      },
      "invite_external_user": {
        "event_name": "Usuario externo invitado a la cuenta",
        "description": "Usuario externo invitado a la cuenta - {{metadata.email}} por {{metadata.userName}}"
      },
      "resend_invite": {
        "event_name": "Invitación de cuenta reenviada",
        "description": "Invitación de cuenta reenviada - {{metadata.count}} invitación(es)"
      },
      "install_platform": {
        "event_name": "Plataforma instalada",
        "description": "Plataforma instalada - {{metadata.platformType}} ({{metadata.platformWorkspaceName}})"
      },
      "uninstall_platform": {
        "event_name": "Plataforma desinstalada",
        "description": "Plataforma desinstalada - {{metadata.platformType}}"
      },
      "update_platform_metadata": {
        "event_name": "Metadatos de plataforma actualizados",
        "description": "Metadatos de plataforma actualizados"
      },
      "create_platform": {
        "event_name": "Plataforma de archivo creada",
        "description": "Plataforma de archivo creada - {{metadata.platform}}"
      },
      "update_platform": {
        "event_name": "Plataforma de archivo actualizada",
        "description": "Plataforma de archivo actualizada - {{metadata.platform}}"
      },
      "delete_platform": {
        "event_name": "Plataforma de archivo eliminada",
        "description": "Plataforma de archivo eliminada - {{metadata.platform}}"
      },
      "scim_create_group": {
        "event_name": "Grupo creado (SCIM)",
        "description": "Grupo creado vía SCIM - {{metadata.displayName}}"
      },
      "scim_update_group": {
        "event_name": "Grupo actualizado (SCIM)",
        "description": "Grupo actualizado vía SCIM - {{metadata.displayName}}"
      },
      "scim_patch_group": {
        "event_name": "Grupo modificado (SCIM)",
        "description": "Grupo modificado vía SCIM - {{metadata.displayName}}"
      },
      "scim_delete_group": {
        "event_name": "Grupo eliminado (SCIM)",
        "description": "Grupo eliminado vía SCIM - {{metadata.displayName}}"
      },
      "scim_create_user": {
        "event_name": "Usuario creado (SCIM)",
        "description": "Usuario creado vía SCIM - {{metadata.userName}}"
      },
      "scim_update_user": {
        "event_name": "Usuario actualizado (SCIM)",
        "description": "Usuario actualizado vía SCIM - {{metadata.userName}}"
      },
      "scim_patch_user": {
        "event_name": "Usuario modificado (SCIM)",
        "description": "Usuario modificado vía SCIM - {{metadata.userName}}"
      },
      "scim_deactivate_user": {
        "event_name": "Usuario desactivado (SCIM)",
        "description": "Usuario desactivado vía SCIM - {{metadata.userName}}"
      },
      "scim_reactivate_user": {
        "event_name": "Usuario reactivado (SCIM)",
        "description": "Usuario reactivado vía SCIM - {{metadata.userName}}"
      },
      "install_saml": {
        "event_name": "SAML instalado",
        "description": "SAML configurado para la organización"
      },
      "remove_saml": {
        "event_name": "SAML eliminado",
        "description": "Configuración SAML eliminada de la organización"
      },
      "save_notifications": {
        "event_name": "Notificaciones del dispositivo guardadas",
        "description": "Configuración de notificaciones del dispositivo guardada"
      },
      "save_flow": {
        "event_name": "Flujo de bot guardado",
        "description": "Versión {{metadata.version}} del flujo de bot guardada por {{metadata.userName}}"
      },
      "publish_flow": {
        "event_name": "Flujo de bot publicado",
        "description": "Versión {{metadata.version}} del flujo de bot publicada por {{metadata.userName}}"
      },
      "unpublish_flow": {
        "event_name": "Flujo de bot despublicado",
        "description": "Flujo de bot despublicado por {{metadata.userName}}"
      },
      "stop_session": {
        "event_name": "Sesión de bot detenida",
        "description": "Sesión de bot para {{metadata.senderNumber}} detenida por {{metadata.userName}}"
      },
      "clone_flow": {
        "event_name": "Flujo de bot clonado",
        "description": "Flujo de bot \"{{metadata.flowName}}\" clonado por {{metadata.userName}}"
      },
      "update_flow_metadata": {
        "event_name": "Metadatos del flujo de bot actualizados",
        "description": "Metadatos del flujo de bot \"{{metadata.flowName}}\" actualizados por {{metadata.userName}}"
      },
      "create_flow": {
        "event_name": "Flujo de bot creado",
        "description": "Flujo de bot \"{{metadata.flowName}}\" creado por {{metadata.userName}}"
      },
      "assign_phones": {
        "event_name": "Teléfonos asignados al flujo de bot",
        "description": "Asignaciones de teléfonos del flujo de bot actualizadas por {{metadata.userName}}"
      },
      "new_application": {
        "event_name": "Aplicación creada",
        "description": "La aplicación fue creada por {{metadata.userName}}"
      },
      "update_application": {
        "event_name": "Aplicación actualizada",
        "description": "La aplicación fue actualizada por {{metadata.userName}}"
      },
      "delete_application": {
        "event_name": "Aplicación eliminada",
        "description": "La aplicación fue eliminada por {{metadata.userName}}"
      },
      "new_application_category": {
        "event_name": "Categoría de aplicación creada",
        "description": "La categoría de aplicación fue creada por {{metadata.userName}}"
      },
      "update_application_category": {
        "event_name": "Categoría de aplicación actualizada",
        "description": "La categoría de aplicación fue actualizada por {{metadata.userName}}"
      },
      "delete_application_category": {
        "event_name": "Categoría de aplicación eliminada",
        "description": "La categoría de aplicación fue eliminada por {{metadata.userName}}"
      },
      "new_start_page_layout": {
        "event_name": "Diseño de página de inicio creado",
        "description": "El diseño de la página de inicio fue creado por {{metadata.userName}}"
      },
      "update_start_page_layout": {
        "event_name": "Diseño de página de inicio actualizado",
        "description": "El diseño de la página de inicio fue actualizado por {{metadata.userName}}"
      },
      "delete_start_page_layout": {
        "event_name": "Diseño de página de inicio eliminado",
        "description": "El diseño de la página de inicio fue eliminado por {{metadata.userName}}"
      },
      "update_start_page_branding": {
        "event_name": "Marca de página de inicio actualizada",
        "description": "La marca de la página de inicio fue actualizada por {{metadata.userName}}"
      },
      "update_block_page_config": {
        "event_name": "Página de bloqueo actualizada",
        "description": "La configuración de la página de bloqueo fue actualizada por {{metadata.userName}}"
      },
      "access_request_submitted": {
        "event_name": "Solicitud de acceso enviada",
        "description": "{{metadata.userName}} solicitó acceso a {{metadata.host}}"
      },
      "access_request_approved": {
        "event_name": "Solicitud de acceso aprobada",
        "description": "La solicitud de acceso fue aprobada por {{metadata.userName}}"
      },
      "access_request_dismissed": {
        "event_name": "Solicitud de acceso descartada",
        "description": "La solicitud de acceso fue descartada por {{metadata.userName}}"
      },
      "new_browser_url_policy": {
        "event_name": "Política de acceso creada",
        "description": "La política de acceso fue creada por {{metadata.userName}}"
      },
      "update_browser_url_policy": {
        "event_name": "Política de acceso actualizada",
        "description": "La política de acceso fue actualizada por {{metadata.userName}}"
      },
      "delete_browser_url_policy": {
        "event_name": "Política de acceso eliminada",
        "description": "La política de acceso fue eliminada por {{metadata.userName}}"
      },
      "new_browser_control": {
        "event_name": "Control del navegador creado",
        "description": "El control del navegador fue creado por {{metadata.userName}}"
      },
      "update_browser_control": {
        "event_name": "Control del navegador actualizado",
        "description": "El control del navegador fue actualizado por {{metadata.userName}}"
      },
      "delete_browser_control": {
        "event_name": "Control del navegador eliminado",
        "description": "El control del navegador fue eliminado por {{metadata.userName}}"
      },
      "archive_device": {
        "event_name": "Dispositivo archivado",
        "description": "El dispositivo fue archivado por {{metadata.userName}}"
      },
      "unarchive_device": {
        "event_name": "Dispositivo desarchivado",
        "description": "El dispositivo fue desarchivado por {{metadata.userName}}"
      },
      "new_block_page_layout": {
        "event_name": "Página de bloqueo creada",
        "description": "La página de bloqueo fue creada por {{metadata.userName}}"
      },
      "update_block_page_layout": {
        "event_name": "Página de bloqueo actualizada",
        "description": "La página de bloqueo fue actualizada por {{metadata.userName}}"
      },
      "delete_block_page_layout": {
        "event_name": "Página de bloqueo eliminada",
        "description": "La página de bloqueo fue eliminada por {{metadata.userName}}"
      },
      "new_branding_layout": {
        "event_name": "Marca creada",
        "description": "La marca fue creada por {{metadata.userName}}"
      },
      "update_branding_layout": {
        "event_name": "Marca actualizada",
        "description": "La marca fue actualizada por {{metadata.userName}}"
      },
      "delete_branding_layout": {
        "event_name": "Marca eliminada",
        "description": "La marca fue eliminada por {{metadata.userName}}"
      },
      "new_edr_agent": {
        "event_name": "Agente EDR creado",
        "description": "El agente EDR fue creado por {{metadata.userName}}"
      },
      "update_edr_agent": {
        "event_name": "Agente EDR actualizado",
        "description": "El agente EDR fue actualizado por {{metadata.userName}}"
      },
      "delete_edr_agent": {
        "event_name": "Agente EDR eliminado",
        "description": "El agente EDR fue eliminado por {{metadata.userName}}"
      },
      "update_posture_baseline": {
        "event_name": "Línea base de estado del dispositivo actualizada",
        "description": "La línea base de estado del dispositivo fue actualizada por {{metadata.userName}}"
      },
      "create_device": {
        "event_name": "Dispositivo creado",
        "description": "Se informó un nuevo dispositivo para {{metadata.userName}}"
      },
      "create_extension": {
        "event_name": "Extensión añadida",
        "description": "{{metadata.userName}} añadió una extensión a la lista"
      },
      "update_extension": {
        "event_name": "Extensión actualizada",
        "description": "{{metadata.userName}} actualizó una extensión"
      },
      "delete_extension": {
        "event_name": "Extensión eliminada",
        "description": "{{metadata.userName}} eliminó una extensión de la lista"
      },
      "create_org": {
        "event_name": "Organización creada",
        "description": "Organización creada por {{metadata.userName}}"
      },
      "disconnect_from_twilio": {
        "event_name": "Twilio desconectado",
        "description": "Twilio desconectado"
      },
      "archive_flow": {
        "event_name": "Flujo de bot archivado",
        "description": "Flujo de bot archivado por {{metadata.userName}}"
      },
      "bulk_delete_tuvis_contacts": {
        "event_name": "Contactos Eliminados en Masa",
        "description": "{{metadata.deletedCount}} contactos eliminados por {{metadata.userName}}"
      },
      "custom_filter_created": {
        "event_name": "Filtro Personalizado Creado",
        "description": "El filtro personalizado \"{{metadata.filterName}}\" fue creado"
      },
      "custom_filter_updated": {
        "event_name": "Filtro Personalizado Actualizado",
        "description": "El filtro personalizado \"{{metadata.filterName}}\" fue actualizado"
      },
      "custom_filter_deleted": {
        "event_name": "Filtro Personalizado Eliminado",
        "description": "El filtro personalizado \"{{metadata.filterName}}\" fue eliminado"
      },
      "disconnect_from_waba": {
        "event_name": "Desconectado de WhatsApp Business",
        "description": "Cuenta de WhatsApp Business {{entityId}} desconectada por {{metadata.userName}}"
      },
      "identity_merge_ambiguous": {
        "event_name": "Fusión de Identidad Ambigua",
        "description": "La identidad no se pudo fusionar automáticamente: más de un usuario coincide con {{metadata.mergeKey}} \"{{metadata.mergeValue}}\""
      },
      "subaccount_created": {
        "event_name": "Subcuenta de Twilio Creada",
        "description": "Subcuenta de Twilio \"{{metadata.friendlyName}}\" creada por {{metadata.userName}}"
      },
      "update_api_key": {
        "event_name": "Clave API Pública Actualizada",
        "description": "Clave API pública actualizada con id {{entityId}}"
      },
      "update_fraud_incident_status": {
        "event_name": "Estado de Incidente de Fraude Actualizado",
        "description": "Estado del incidente de fraude cambiado a \"{{metadata.status}}\" por {{metadata.userName}}"
      }
    }
  },
  "saml_settings": {
    "sign_auth_res": "Firmar respuesta SAML",
    "sign_auth_res_tooltip": "Determina si el mensaje de respuesta de autenticación SAML está firmado digitalmente por el IDP o no, asegúrese de que esta configuración coincida con su IDP.",
    "sign_assertion": "Firmar aserción SAML",
    "sign_assertion_tooltip": "Determina si la afirmación SAML está firmada digitalmente o no, asegúrese de que esta configuración coincida con su IDP.",
    "disable_requested_authn_context": "Deshabilitar Contexto de Autenticación Solicitado",
    "disable_requested_authn_context_tooltip": "Si está marcado, no solicita un contexto de autenticación específico",
    "use_browser": "Abrir autenticación en el navegador",
    "use_browser_tooltip": "Si está marcado, la autenticación SAML se abrirá en el navegador predeterminado del usuario en lugar de dentro de la aplicación",
    "default_permission_title": "Establecer permisos predeterminados para nuevos usuarios:",
    "default_groups_title": "Establecer grupos predeterminados para nuevos usuarios:",
    "provisioning": "Aprovisionamiento",
    "scim_url": "URL de inquilino",
    "scim_token": "Token secreto",
    "disable_scim_invite_email": "Desactivar correo de invitación",
    "disable_scim_invite_email_tooltip": "Si está activado, los usuarios creados mediante aprovisionamiento SCIM no recibirán el correo de invitación a la plataforma.",
    "scim_list_active_only": "Excluir usuarios desactivados de los listados SCIM",
    "scim_list_active_only_tooltip": "Si está activado, las respuestas SCIM `GET /Users` sin filtro devuelven solo usuarios activos. Requerido para IdPs que tratan la lista como el conjunto de usuarios gestionados (por ejemplo, JumpCloud). Déjelo desactivado para un comportamiento conforme a SCIM (RFC 7644 §3.4.2): los IdPs que necesiten solo usuarios activos deben enviar `filter=active eq true`.",
    "attribute_mapping_title": "Asignación de atributos",
    "attribute_mapping_tooltip": "Asigna los atributos SCIM entrantes a los campos de usuario de Tuvis. Los campos estándar se asignan automáticamente y se muestran como referencia. El teléfono solo se aprovisiona si lo asignas: si lo dejas vacío, SCIM nunca modifica el campo Teléfono del usuario; introduce 'phoneNumbers' para el atributo estándar, u otra ruta si tu IdP envía el número en otro atributo. Para cada campo personalizado, introduce la ruta del atributo SCIM de origen; por ejemplo 'title', o una ruta de extensión como los atributos 'employeeNumber' (enterprise) o 'extensionAttribute1' (Entra).",
    "attribute_mapping_placeholder": "Ruta del atributo SCIM (p. ej. title)",
    "attribute_mapping_placeholder_phone": "No se sincroniza: introduce una ruta de atributo SCIM para aprovisionarlo",
    "attribute_mapping_empty": "Crea primero campos personalizados (Plataforma > Campos personalizados) para asignarles atributos SCIM.",
    "attribute_mapping_col_tuvis": "Usuario de Tuvis",
    "attribute_mapping_col_scim": "Usuario de origen SCIM",
    "save_changes": "Guardar cambios",
    "save_changes_confirm": "¿Estás seguro de que deseas guardar los cambios?",
    "title": "Configuración SSO",
    "invite_to_platform_tooltip": "Invite a un nuevo usuario a la plataforma. Esto creará una nueva organización cuando se registren. Se puede hacer invitar a una organización existente desde la página \"Users\".",
    "saml_settings": "Configuración de SSO para Org",
    "force_saml_only": "Allow Login Only Using SSO",
    "drop_xml": "Arrastre el archivo xml o haga click para buscar",
    "import_xml": "Importar metadatos xml",
    "xml_url": "Importar de URL",
    "invalid_url": "URL XML no válida",
    "import_xml_placeholder": "https://login.microsoftonline.com/<tenant_id>/FederationMetadata/2007-06/FederationMetadata.xml?appid=<app_id>",
    "add_to_provider": "Agregue lo siguiente a su proveedor de identidad:",
    "sp_entity_id": "SP Entity ID",
    "acs_url": "SP ACS URL",
    "curreny_saml_settings": "Configuración actual de SSO",
    "domains_usage": " es utilizado por {{organizations}} organización(es)",
    "friendly_org_name": "Nombre de la Organización",
    "friendly_org_name_tooltip": "Se muestra durante el inicio de sesión para ayudar a los usuarios a seleccionar la organización correcta cuando varias organizaciones están asociadas al mismo dominio SAML.",
    "org_email_domain": "Dominio de correo electrónico de organización",
    "idp_entity_id": "IdP Entity ID",
    "idp_sso_url": "IdP SSO URL",
    "idp_certificates": "IdP Certificate",
    "save_saml_settings": "Guardar la configuración de SSO",
    "default_channel_title": "Definir el canal predeterminado para los usuarios nuevos:"
  },
  "search_person": {
    "loading": "Cargando..."
  },
  "file_invalid": {
    "size": "No se puede sincronizar debido al límite de tamaño de archivo",
    "mimeType": "Tipo de archivo no compatible",
    "messageType": "Tipo de mensaje no compatible"
  },
  "destinations_page": {
    "tags": {
      "all_users": "Todos los usuarios"
    },
    "table_actions": {
      "edit_connection": "Editar Conexión",
      "edit_details": "Editar Detalles"
    },
    "table_headers": {
      "name": "Nombre",
      "logo": "Logo",
      "integration": "Integración",
      "type": "Tipo",
      "user_groups": "Grupos de usuarios"
    },
    "edit_integration": {
      "header": "Editar Integración"
    },
    "edit_details": {
      "header": "Editar Detalles",
      "view_only_label": "Solo lectura"
    },
    "add_integration": {
      "header": "Agregar Integración",
      "name": "Nombre",
      "name_placeholder": "p. ej., S3 para Ventas",
      "user_groups": "Grupos de usuarios",
      "all_users": "Todos los usuarios"
    },
    "language": "Idioma",
    "all_types": "Todos los tipos",
    "type": "Tipo",
    "available_fields": "Campos Disponibles",
    "tabs": {
      "messages": "Mensajes",
      "auditLogs": "Registros de Auditoría",
      "dlpIncidents": "Incidentes",
      "audioTranscribes": "Transcripción de Audio",
      "dlpDetectors": "Detectores DLP",
      "security": "Seguridad",
      "fileScanning": "Detección de Fraude",
      "llmProvider": "Proveedores de IA",
      "platforms": "Plataformas",
      "channels": "Canales",
      "archive": "Archive"
    },
    "incident_types": {
      "label": "Tipos de Incidentes",
      "dlp": "DLP",
      "surveillance": "Vigilancia",
      "fraud": "Detección de Fraude"
    },
    "security": {
      "add": "Agregar",
      "remove": "Eliminar",
      "disclaimer": "Selecciona tu infraestructura para recibir de Tuvis la guía correcta de aplicación de red. Agregar una plataforma identifica tu entorno; no establece una conexión de datos en vivo con estos sistemas."
    },
    "pipedrive": {
      "text": "Conecta tu cuenta de PipeDrive para sincronizar mensajes\n",
      "connect": "Conectar",
      "reconnect": "Reconectar"
    },
    "hubspot": {
      "connect": "Conectar",
      "reconnect": "Reconectar",
      "text": "Conecta la cuenta de HubSpot para sincronizar mensajes"
    },
    "crm": {
      "lead": "Prospecto",
      "contact": "Contacto",
      "field_value": "Valor del Campo",
      "field_name": "Nombre del Campo",
      "enableObjectSettingsCheckbox": "Crear objeto si no se encuentra"
    },
    "global_relay": {
      "description": "Para habilitar la integración, por favor, póngase en contacto con su gerente de cuenta o equipo de soporte de Global Relay (copie a provisioning@globalrelay.net en el correo electrónico) y pregunte por los detalles del SMTP personalizado de la cuenta:",
      "subDescription": {
        "host": {
          "subject": "Host del servidor SMTP",
          "desc": ": debe ser así: feeds-xyz.globalrelay.com"
        },
        "username_password": "Nombre de usuario y contraseña SMTP personalizados",
        "smtp_destination": {
          "subject": "Destinatario SMTP para el registro en el diario",
          "desc": ": una dirección de correo electrónico que debe parecerse a esta: feed-########@feeds.globalrelay.com"
        },
        "msg_type": {
          "subject": "X-GlobalRelay-MsgType",
          "desc": ": normalmente será \"TuvisWhatsApp\""
        }
      }
    },
    "title": "Integraciones",
    "revoke_destination": "Desconectar Integración",
    "revoke_destination_confirmation": "¿Estás seguro(a) de que deseas desconectar {{destinationName}}?",
    "revoke_destination_with_batch_mode_on_confirmation": "¿Está seguro de que desea desconectar {{destinationName}}? Desactivar el modo por lotes dejará los mensajes no sincronizados sin sincronizar. ¿Está seguro de que desea continuar?",
    "revoke_button_text": "Desconectar {{destinationName}}",
    "enable_destination_confirmation": "¿Estás seguro(a) de que deseas habilitar {{destinationName}}?",
    "disable_destination_confirmation": "¿Estás seguro(a) de que deseas deshabilitar {{destinationName}}?",
    "cancel_button_text": "Cancelar",
    "format": "Formato",
    "bucket": "Bucket",
    "save_base_path": "Ruta Base de Guardado",
    "read_base_path": "Ruta Base de Lectura",
    "iam_role_name": "ARN del rol",
    "external_id": "ID externo",
    "openid_provider_url": "URL del Proveedor OpenId",
    "access_key_auth": "Auth. por clave de acceso",
    "identity_provider_auth": "Auth. por proveedor ID",
    "file_name_template": "Plantilla de Nombre de Archivo",
    "file_name_upload_date": "Incluir Fecha de Carga en Nombres de Archivos",
    "media_file_name_template": "Plantilla de Nombre de Archivo de Medios",
    "store_media": "Almacenar Medios",
    "client_encryption_key": "Clave de cifrado del cliente",
    "client_encryption": "Cifrado del lado del cliente",
    "flat": "Guardar archivos directamente en la raíz de la ruta base",
    "zipped": "Guardar archivo multimedia comprimido",
    "msg_date_timezone": "Zona horaria de la fecha",
    "file_name_date_timezone": "Zona horaria del nombre de archivo",
    "yes": "Sí",
    "no": "No",
    "region": "Región",
    "accesses_key_id": "ID de Llave de Acceso",
    "secret_access_key": "Llave de Acceso Secreta",
    "enable_long_audio_transcription": "Habilitar transcripción para audios de más de 3 minutos",
    "enable_video_transcription": "Habilitar transcripción de video",
    "enable_video_transcription_tooltip": "Cuando está habilitado, la pista de audio dentro de los archivos de video enviados se transcribe y se analiza en busca de violaciones de DLP.",
    "enable_long_audio_transcription_tooltip": "Para transcribir archivos de audio de más de 3 minutos, Tuvis necesita acceso a un bucket de S3 con permisos de escritura y eliminación.",
    "temporary_s3_bucket": "Bucket S3 temporal",
    "temporary_s3_region": "Región S3 temporal",
    "temporary_s3_prefix": "Prefijo S3 temporal (Opcional)",
    "account_name": "Nombre de la Cuenta",
    "account_key": "Llave de la Cuenta",
    "sas_url": "SAS URL",
    "container_name": "Nombre del Contenedor",
    "storage_url": "URL de Almacenamiento",
    "api_key": "Llave API",
    "host": "Anfitrión",
    "port": "Puerto",
    "user": "Usuario",
    "connection_string": "Cadena de Conexión",
    "password": "Contraseña",
    "rcpt": "Destino SMTP",
    "secure": "Seguro",
    "true": "Verdadero",
    "false": "Falso",
    "server_url": "URL del Servidor",
    "api_url": "URL de la API",
    "blob_storage": "Blob",
    "file_scanning_category": "Escaneo de Archivos",
    "compliance": "Compliance",
    "dlp": "Data Loss Protection",
    "sftp_password_or_privateKeyError": "Debe ingresar una contraseña o una clave privada",
    "create_destination_in_progress": "Creación de destino en progreso",
    "destination_created_successfully": "Destino creado con éxito",
    "failed_to_create_destination": "Error al crear el destino",
    "revoke_destination_in_progress": "Desconexión de la integración en progreso",
    "destination_revoked_successfully": "Integración desconectada exitosamente",
    "failed_to_revoke_destination": "Error al desconectar la integración",
    "do_you_want_store_media": "¿Quieres almacenar multimedia en tu instancia de Salesforce?",
    "update_destination_in_progress": "Actualización de destino en progreso",
    "destination_updated_successfully": "Destino actualizado con éxito",
    "failed_to_update_destination": "Error al actualizar el destino",
    "salesforce_user": "Usuario de Salesforce",
    "failed_to_get_integrations": "Error al obtener integraciones",
    "save": "Guardar",
    "download_certificate": "Descargar certificado",
    "generate_certificate": "Generar certificado",
    "generate_certificate_failed_toast": "Error al generar el archivo del certificado. Por favor, inténtalo nuevamente.",
    "connected_app_consumer_key": "Clave del Consumidor de la Aplicación Conectada",
    "client_id": "ID del Cliente",
    "client_secret": "Secreto del Cliente",
    "url": "URL",
    "tenant_id": "ID del Inquilino",
    "user_id": "ID de Usuario",
    "username": "Nombre de usuario",
    "test_connection": "Probar conexión",
    "test_connection_failed_toast": "Prueba de conexión fallida. Por favor, verifica tu configuración.",
    "test_connection_s3_validation_failed_toast": "Hubo un problema con la validación de S3. Por favor, revisa los permisos del rol.",
    "test_connection_transcribe_validation_failed_toast": "Hubo un problema con la validación de Transcribe. Por favor, revisa los permisos del rol.",
    "project_id": "Project ID",
    "client_email": "Client Email",
    "private_key": "Private Key",
    "batch": {
      "title": "Ejecutar como trabajo por lotes",
      "batch_sync_turn_off_title": "Desactivar el modo 'ejecutar como Lote'",
      "batch_sync_turn_off_desc": "Desactivar el modo por lotes dejará los mensajes no sincronizados sin sincronizar. ¿Está seguro de que desea continuar?"
    },
    "connected_integrations": "Integraciones conectadas",
    "empty_state": {
      "title": "No hay integraciones de {{destinationName}} conectadas",
      "description": "Agrega una integración de {{destinationName}} para comenzar"
    },
    "aws_region": "Región de AWS",
    "aws_access_key_id": "ID de Clave de Acceso de AWS",
    "aws_secret_access_key": "Secreto de Clave de Acceso de AWS",
    "aws_session_token": "Token de Sesión de AWS",
    "target_index": "Flujo de datos / índice de destino",
    "pipeline_id": "ID del pipeline de ingesta",
    "google_api_key": "Clave de API de Google",
    "webhook_access_key": "Clave de acceso del webhook",
    "llm_enabled_models": "Modelos permitidos",
    "llm_enabled_models_placeholder": "Déjalo vacío para permitir todos los modelos",
    "llm_default_model": "Modelo predeterminado",
    "llm_default_model_placeholder": "Selecciona el modelo predeterminado para los chats nuevos",
    "connector_name": "Nombre del conector",
    "object_name": "Nombre del objeto",
    "ingestion_endpoint": "Endpoint de ingesta",
    "sentinel": {
      "tenant_id": "ID de tenant de Azure",
      "client_id": "ID de cliente",
      "client_secret": "Secreto de cliente",
      "dce_endpoint": "URL del endpoint de recopilación de datos",
      "dcr_immutable_id": "ID inmutable de DCR",
      "stream_name": "Nombre del flujo (opcional)"
    }
  },
  "dlp_incident_page": {
    "header": "Detalles del Incidente",
    "channel": "Canal",
    "incident_id": "ID del Incidente",
    "refresh": "Actualizar",
    "details": "Detalles",
    "attachments_match_details": {
      "title": "Detalles de coincidencia de archivos",
      "description": "Detalles sobre cómo los archivos coincidieron con la regla"
    },
    "source": "Origen",
    "image_unappropriate": "Imagen Inapropiada",
    "triggered_rule": "Regla",
    "match_source": {
      "content": "Contenido del archivo",
      "metadata": "Metadatos del archivo",
      "filename": "Nombre del archivo",
      "image": "Imagen"
    }
  },
  "campaigns": {
    "title": "Campañas",
    "campaigns_tab": "Campañas",
    "templates_tab": "Plantillas",
    "new_campaign": "Nueva Campaña",
    "search_placeholder": "Buscar",
    "no_campaigns": "No se encontraron campañas",
    "no_search_results": "Ninguna campaña coincide con su búsqueda",
    "cols": {
      "template": "Plantilla",
      "date": "Fecha",
      "status": "Estado",
      "sent": "Enviado / Audiencia"
    },
    "create_modal": {
      "assign_to": "Asignar conversaciones a",
      "assign_to_placeholder": "Seleccionar agente (opcional)",
      "set_conversation_open": "Establecer conversación como abierta",
      "success": "Campaña creada exitosamente",
      "error": "Error al crear la campaña. Por favor, inténtelo de nuevo.",
      "file_too_large": "El archivo es demasiado grande. Tamaño máximo: {{maxSize}}",
      "csv_empty": "El archivo CSV está vacío",
      "csv_missing_headers": "Al archivo CSV le faltan encabezados requeridos: {{headers}}",
      "csv_invalid_phones": "El archivo CSV contiene números de teléfono inválidos: {{phones}}",
      "csv_missing_params": "Al archivo CSV le faltan columnas de parámetros de plantilla: {{params}}"
    }
  },
  "tuvis_contacts_page": {
    "title": "Contactos de Tuvis",
    "name": "Nombre",
    "phoneNumber": "Número de Teléfono",
    "update_contact": "Editar Contacto",
    "create_contact": "Nuevo Contacto",
    "delete_contact": "Eliminar Contacto",
    "delete_contact_modal_message": "¿Estás seguro de que deseas eliminar este contacto de Tuvis?",
    "import_contacts_preview": "Vista Previa",
    "import_contacts_csv_button": "Importar CSV",
    "import_contacts_csv_template": "Descargar Plantilla CSV",
    "required": "obligatorio",
    "import_button": "Importar",
    "drop_csv": "Suelta el archivo CSV aquí o haz clic para explorar",
    "import_contacts_modal_text": "Crear un archivo CSV: Asegúrate de que tu archivo CSV incluya las siguientes columnas:",
    "import_contacts_csv_invalid_format": "Formato CSV inválido: {{header}}",
    "import_contacts_csv_success": "Resultados de importación: {{numOfNewContacts}} nuevos contactos de Tuvis añadidos desde el archivo CSV",
    "import_contacts_csv_failure": "Los contactos de Tuvis no se pudieron importar {{error}}",
    "csv_errors": {
      "empty_file": "El archivo CSV está vacío",
      "missing_required_headers": "Faltan encabezados requeridos en el archivo CSV: {{missingRequiredHeaders}}",
      "invalid_headers": "El archivo CSV contiene encabezados inválidos: {{invalidHeaders}}",
      "invalid_phone": "El archivo CSV contiene filas con teléfonos inválidos: {{invalidPhones}}",
      "missing_name": "El archivo CSV contiene filas con nombres faltantes: {{missingName}}"
    },
    "assignedUser": "Usuarios Asignados",
    "assignedUserId": "IDs de Usuarios Asignados",
    "assignedUserPlaceholder": "Seleccionar Usuarios",
    "create_contact_failure": "Error al crear contacto de Tuvis",
    "update_contact_failure": "Error al actualizar contacto de Tuvis",
    "search_placeholder": "Buscar contactos",
    "contacts": "Contactos",
    "delete_selected": "Eliminar Seleccionados",
    "delete_selected_contacts": "Eliminar Contactos Seleccionados",
    "delete_selected_contacts_modal_message": "¿Estás seguro de que quieres eliminar {{count}} contactos seleccionados? Esta acción no se puede deshacer.",
    "bulk_delete_success": "Se eliminaron exitosamente {{count}} contactos",
    "bulk_delete_failure": "Error al eliminar los contactos seleccionados",
    "download_csv": "Descargar CSV",
    "download_csv_failure": "Error al descargar CSV",
    "createdAt": "Fecha de Creación"
  },
  "url_policies_page": {
    "title": "Políticas de escritorio",
    "name": "Nombre",
    "url": "URL",
    "type": "Tipo",
    "created_at": "Creado el",
    "updated_at": "Actualizado el",
    "update_policy": "Editar Política",
    "create_policy": "Nueva Política",
    "delete_policy": "Eliminar Política",
    "delete_policy_modal_message": "¿Estás seguro de que deseas eliminar esta política de URL?",
    "watermark": "Marca de agua",
    "action_ON": "ACTIVADO",
    "action_OFF": "DESACTIVADO",
    "protect_download": "Proteger descarga",
    "password": "Contraseña",
    "watermark_tooltip": "Agrega marcas de agua que identifican al usuario en toda la vista para evitar el intercambio no autorizado y permitir el rastreo de filtraciones",
    "protect_download_tooltip": "Cada archivo descargado será comprimido y protegido con la contraseña proporcionada.",
    "dlp": "DLP",
    "dlp_tooltip": "Monitorear y aplicar políticas DLP al contenido de este sitio web",
    "surveillance": "Vigilancia",
    "surveillance_tooltip": "Monitorear el contenido de este sitio web según sus reglas de vigilancia y registrar los incidentes coincidentes",
    "fraud_detection": "Detección de fraude",
    "fraud_detection_tooltip": "Bloquear la descarga de archivos con hashes maliciosos conocidos en este sitio web",
    "wizard": {
      "new_title": "Nueva política",
      "edit_title": "Editar política",
      "back_to_list": "Volver a políticas",
      "step_type": "Tipo",
      "step_configuration": "Configuración",
      "step_summary": "Resumen",
      "select_type_heading": "Seleccionar tipo de política",
      "select_type_sub": "Elija el tipo de política que desea crear.",
      "configure_heading": "Configurar política",
      "configure_sub": "Complete los datos, URL, alcance y funciones.",
      "summary_heading": "Revisar política",
      "summary_sub": "Confirme los datos antes de guardar.",
      "type_applications_title": "Aplicaciones",
      "type_applications_desc": "Permitir aplicaciones de mensajería compatibles dentro de Tuvis Desktop.",
      "type_managed_title": "URL administradas",
      "type_managed_desc": "Aplicar reglas DLP y supervisión a integraciones predefinidas por Tuvis.",
      "type_network_title": "Red",
      "type_network_desc": "Permitir acceso a cualquier sitio web externo o URL personalizada en Tuvis Desktop.",
      "next": "Siguiente",
      "back": "Atrás",
      "submit_create": "Crear política",
      "submit_update": "Guardar cambios",
      "managed_url_placeholder": "Seleccione un sitio administrado (p. ej., Slack, ChatGPT)",
      "application_placeholder": "Seleccione una aplicación…",
      "application_whatsapp": "WhatsApp",
      "application_telegram": "Telegram",
      "application_tuvis": "Mensajes Tuvis",
      "error_select_policy_type": "Seleccione un tipo de política antes de continuar.",
      "error_complete_required_fields": "Complete todos los campos obligatorios antes de continuar.",
      "error_invalid_url": "Introduzca una URL válida (por ejemplo https://example.com).",
      "summary_empty_value": "Ninguno"
    }
  },
  "browser_settings_page": {
    "title": "Controles del navegador",
    "description": "Descripción",
    "allowAutofillForms": "Permitir autocompletado de formularios",
    "allowAutofillForms_hint": "Permite que el navegador autocomplete direcciones y otros datos de formularios.",
    "allowPasswordManager": "Permitir el gestor de contraseñas del navegador",
    "allowPasswordManager_hint": "Permite a los usuarios guardar y autocompletar contraseñas en el navegador.",
    "allowAutofillCreditCards": "Permitir autocompletado de tarjetas",
    "allowAutofillCreditCards_hint": "Permite que el navegador guarde y autocomplete tarjetas de pago.",
    "allowCast": "Permitir Cast",
    "allowCast_hint": "Permite a los usuarios transmitir pestañas y contenido a otros dispositivos.",
    "allowDeveloperTools": "Permitir herramientas de desarrollo",
    "allowDeveloperTools_hint": "Permite abrir las DevTools. A nivel de navegador (no hay opción por URL). Bloquear las desactiva en todas partes.",
    "allowDeleteHistory": "Permitir eliminar el historial del navegador",
    "allowDeleteHistory_hint": "Permite a los usuarios borrar su historial de navegación.",
    "allowTaskManagerEndProcess": "Permitir finalizar procesos en el Administrador de tareas",
    "allowTaskManagerEndProcess_hint": "Permite a los usuarios finalizar procesos del navegador desde el Administrador de tareas.",
    "allowExternalApps": "Permitir abrir enlaces en apps externas",
    "allowExternalApps_hint": "Permite que el navegador abra aplicaciones externas para enlaces (mailto:, tel:, protocolos personalizados).",
    "allowIncognito": "Permitir modo incógnito",
    "allowIncognito_hint": "Permite abrir ventanas de incógnito. Se recomienda bloquear: el incógnito puede evadir la supervisión.",
    "allowFileSelectionDialogs": "Permitir diálogos de archivo (subir / guardar como)",
    "allowFileSelectionDialogs_hint": "Permite elegir archivos para subir o una ubicación para guardar. Bloquear desactiva las subidas y guardar como.",
    "allowAddPerson": "Permitir agregar perfiles del navegador",
    "allowAddPerson_hint": "Permite a los usuarios agregar nuevos perfiles del navegador.",
    "download_restrictions": "Restricciones de descarga",
    "download_restrictions_hint": "Restringe qué descargas se permiten.",
    "download_restrictions_unmanaged": "Sin gestionar (predeterminado de Chrome)",
    "download_restrictions_0": "Sin restricciones",
    "download_restrictions_1": "Bloquear descargas peligrosas",
    "download_restrictions_2": "Bloquear descargas potencialmente peligrosas",
    "download_restrictions_3": "Bloquear todas las descargas",
    "download_restrictions_4": "Bloquear descargas maliciosas",
    "default_search_label": "Motor de búsqueda predeterminado",
    "default_search_hint": "Define el motor de búsqueda predeterminado del navegador. Sin definir, se usa el valor base del navegador (Google).",
    "default_search_unset": "Sin gestionar (base Google)",
    "default_search_custom": "Personalizado...",
    "default_search_custom_name": "Nombre",
    "default_search_custom_url": "URL de búsqueda",
    "default_search_custom_suggest": "URL de sugerencias (opcional)",
    "default_search_placeholder_error": "La URL de búsqueda debe incluir el marcador {searchTerms}.",
    "control_chip_incognito": "Sin incógnito",
    "control_chip_file_dialogs": "Sin diálogos archivo",
    "control_chip_add_person": "Sin perfiles nuevos",
    "control_chip_downloads": "Descargas limitadas",
    "extensions_title": "Extensiones",
    "extensions_hint": "Controla las extensiones con cualquier combinación de las listas siguientes. Introduce un id por línea.",
    "extensions_forcelist": "Instalar de forma forzada",
    "extensions_forcelist_hint": "Se instalan automáticamente y el usuario no puede quitarlas.",
    "extensions_allowlist": "Permitir",
    "extensions_allowlist_hint": "Exentas de la lista de bloqueo (usa * en Bloquear para permitir solo estas).",
    "extensions_blocklist": "Bloquear",
    "extensions_blocklist_hint": "Bloqueadas. Usa * para bloquear todo excepto las permitidas.",
    "extensions_ids_placeholder": "Ids de extensión, uno por línea",
    "extensions_picker_placeholder": "Busca o pega un ID de extensión…",
    "save": "Guardar",
    "name": "Nombre",
    "priority": "Prioridad",
    "required": "Obligatorio",
    "cancel": "Cancelar",
    "enforces": "Aplica",
    "create_policy": "Nueva Política",
    "update_policy": "Editar",
    "delete_policy": "Eliminar",
    "delete_policy_modal_message": "¿Seguro que quieres eliminar esta política de configuración del navegador?",
    "new_policy_title": "Crear política de controles del navegador",
    "edit_policy_title": "Editar política de controles del navegador",
    "section_details_title": "Detalles",
    "section_details_desc": "Nombra esta política y define su prioridad (la más alta gana si varias coinciden con un usuario).",
    "section_identity_title": "Identidad",
    "section_identity_desc": "Se aplica a todos, o restrinja a grupos o usuarios específicos.",
    "section_settings_title": "Configuración",
    "section_settings_desc": "Los controles de navegador que esta política aplica.",
    "section_login_restrictions_title": "Restricciones de inicio de sesión",
    "section_login_restrictions_desc": "Haga que Tuvis Browser aplique el encabezado de restricción de tenant propio del proveedor al iniciar sesión en las siguientes aplicaciones, de modo que el proveedor solo acepte las cuentas que usted indique. Tuvis aplica el encabezado; el proveedor lo hace cumplir.",
    "login_restrictions_empty": "Ninguna aplicación del catálogo admite aún restricciones de inicio de sesión.",
    "login_restrictions_personal_note": "Las cuentas personales no tienen un ID de espacio de trabajo u organización, por lo que no se pueden agregar a esta lista. Para permitir el inicio de sesión con cuentas personales en {{app}}, deje esta restricción deshabilitada - al habilitarla, Tuvis aplica el encabezado a cada inicio de sesión y el proveedor lo hace cumplir.",
    "login_restrictions_required_error": "Este campo es obligatorio para aplicar la restricción.",
    "corporate_domains_title": "Dominios corporativos",
    "corporate_domains_hint": "Dominios que Tuvis Browser trata como corporativos al clasificar una cuenta iniciada sesión en el dispositivo. Se usa para cualquier aplicación de esta política cuya restricción de inicio de sesión anterior esté deshabilitada - la configuración habitual cuando desea permitir una cuenta personal pero aun así distinguirla de una corporativa. Tuvis lee y clasifica la dirección en el dispositivo; no bloquea ni detecta una cuenta por sí mismo - su política de DLP o vigilancia decide qué hacer con la clasificación.",
    "corporate_domains_placeholder": "Dominios, uno por línea (p. ej. corp.com)",
    "control_chip_autofill_forms": "Sin autocompletar",
    "control_chip_password_manager": "Sin gestor contraseñas",
    "control_chip_autofill_cards": "Sin tarjetas",
    "control_chip_cast": "Sin Cast",
    "control_chip_devtools": "Sin DevTools",
    "control_chip_delete_history": "Sin borrar historial",
    "control_chip_task_manager": "Adm. tareas limitado",
    "control_chip_external_apps": "Sin apps externas",
    "control_chip_extensions": "Extensiones",
    "updates_title": "Actualizaciones del navegador",
    "updates_hint": "Si este grupo recibe actualizaciones de Tuvis Browser y con qué frecuencia.",
    "updates_unmanaged": "Sin gestionar (solo indicador)",
    "updates_notify": "Recomendado: avisar al usuario",
    "updates_required": "Obligatorio: forzar el reinicio",
    "updates_deadline_label": "Plazo (días)",
    "updates_deadline_hint": "Días desde que una actualización está disponible hasta que se aplica el reinicio. Déjalo en blanco para el valor predeterminado.",
    "updates_enabled": "Buscar actualizaciones",
    "updates_enabled_hint": "Desactivado detiene todas las comprobaciones de actualización, incluidos el elemento de menú Buscar actualizaciones y la página Acerca de. La política MDM del dispositivo tiene prioridad.",
    "updates_period_label": "Comprobar cada",
    "updates_period_hint": "Con qué frecuencia cada navegador busca una versión nueva.",
    "updates_period_default": "Predeterminado del navegador (4 horas)",
    "updates_period_30": "30 minutos",
    "updates_period_60": "1 hora",
    "updates_period_240": "4 horas",
    "updates_period_720": "12 horas",
    "updates_period_1440": "Una vez al día",
    "updates_channel_label": "Canal de actualización",
    "updates_channel_hint": "Qué canal de versiones sigue este grupo. Usa Beta para un grupo piloto.",
    "updates_channel_default": "Igual que la versión instalada",
    "updates_channel_release": "Estable",
    "updates_channel_beta": "Beta",
    "updates_enforcement_label": "Aplicación de actualizaciones pendientes",
    "updates_enforcement_hint": "Con qué firmeza el navegador aplica una actualización ya descargada.",
    "group_monitoring": "Integridad de la supervisión",
    "group_monitoring_hint": "Funciones que permiten a un usuario actuar fuera de la vista de Tuvis. Revísalas primero.",
    "group_extensions": "Extensiones",
    "group_extensions_hint": "Si los usuarios pueden instalar extensiones y cuáles fuerza, permite o bloquea tu organización.",
    "group_data": "Movimiento de datos",
    "group_data_hint": "Descargas, acceso a archivos, apertura de otras aplicaciones e importación desde otro navegador.",
    "group_autofill": "Autocompletado y contraseñas",
    "group_autofill_hint": "Datos de formularios guardados, tarjetas de pago y el gestor de contraseñas integrado.",
    "group_privacy": "Privacidad y telemetría",
    "group_privacy_hint": "Informes en segundo plano y tráfico de predicción que el navegador enviaría.",
    "group_device": "Acceso a dispositivos y hardware",
    "group_device_hint": "Ubicación, sensores y acceso directo al hardware desde las páginas web.",
    "group_platform": "Plataforma web",
    "group_platform_hint": "Comportamiento del navegador sin impacto en datos ni supervisión. Puede dejarse como está.",
    "allowUsageMetrics": "Permitir métricas de uso",
    "allowUsageMetrics_hint": "Controla si el navegador envía estadísticas de uso anonimizadas e informes de fallos a Google. Desactivado: no sale del dispositivo ninguna métrica ni informe de fallos.",
    "allowSearchSuggestions": "Permitir sugerencias de búsqueda",
    "allowSearchSuggestions_hint": "Controla si las pulsaciones en la barra de direcciones se envían al proveedor de búsqueda para obtener sugerencias en vivo. Desactivado: nada de lo que se escribe sale del dispositivo hasta que se envía la búsqueda.",
    "allowUrlKeyedDataCollection": "Permitir recopilación de datos por URL",
    "allowUrlKeyedDataCollection_hint": "Controla si las URL de las páginas visitadas se envían a Google para habilitar funciones como las anotaciones de página. Desactivado: las URL visitadas no se envían.",
    "allowNetworkPrediction": "Permitir predicción de red",
    "allowNetworkPrediction_hint": "Controla si el navegador precarga y preconecta con páginas antes de hacer clic. Desactivado: sin conexiones especulativas en segundo plano.",
    "allowEnhancedSpellCheck": "Permitir corrector ortográfico mejorado",
    "allowEnhancedSpellCheck_hint": "Controla si el texto escrito se envía al servicio de corrección ortográfica de Google para obtener mejores sugerencias. Desactivado: la corrección ortográfica permanece en el dispositivo.",
    "allowGeolocation": "Permitir acceso a la ubicación",
    "allowGeolocation_hint": "Controla si los sitios pueden solicitar la ubicación geográfica del dispositivo. Desactivado: las solicitudes de ubicación se bloquean (los sitios nunca ven dónde estás).",
    "allowSensors": "Permitir sensores de movimiento",
    "allowSensors_hint": "Controla si los sitios pueden leer los sensores de movimiento y de luz ambiental. Desactivado: el acceso a los sensores se bloquea.",
    "allowWebUsb": "Permitir WebUSB",
    "allowWebUsb_hint": "Controla si los sitios pueden conectarse a dispositivos USB mediante la API WebUSB. Desactivado: el acceso a dispositivos USB se bloquea.",
    "allowWebBluetooth": "Permitir Web Bluetooth",
    "allowWebBluetooth_hint": "Controla si los sitios pueden conectarse a dispositivos Bluetooth mediante la API Web Bluetooth. Desactivado: el acceso a dispositivos Bluetooth se bloquea.",
    "allowSerialPorts": "Permitir puertos serie",
    "allowSerialPorts_hint": "Controla si los sitios pueden acceder a los puertos serie mediante la API Web Serial. Desactivado: el acceso a los puertos serie se bloquea.",
    "allowFileSystemRead": "Permitir lectura del sistema de archivos",
    "allowFileSystemRead_hint": "Controla si los sitios pueden leer archivos y carpetas locales mediante la API File System Access. Desactivado: los sitios no pueden leer archivos locales.",
    "allowFileSystemWrite": "Permitir escritura en el sistema de archivos",
    "allowFileSystemWrite_hint": "Controla si los sitios pueden escribir en archivos y carpetas locales mediante la API File System Access. Desactivado: los sitios no pueden escribir archivos locales.",
    "allowQuic": "Permitir el protocolo QUIC",
    "allowQuic_hint": "Controla si el navegador usa el protocolo de transporte QUIC (basado en UDP). Desactivado: las conexiones vuelven a TCP/TLS, que algunos cortafuegos corporativos inspeccionan de forma más fiable.",
    "allowJavaScriptJit": "Permitir JIT de JavaScript",
    "allowJavaScriptJit_hint": "Controla si el motor de JavaScript V8 usa compilación just-in-time. Desactivado: el JIT se deshabilita, lo que reduce notablemente la superficie de ataque de JavaScript con un pequeño coste de rendimiento.",
    "allowPaymentMethodQuery": "Permitir consultas de métodos de pago",
    "allowPaymentMethodQuery_hint": "Controla si los sitios pueden comprobar (mediante la API Payment Request) si tienes métodos de pago guardados. Desactivado: los sitios no pueden hacer esa comprobación.",
    "allowAutoplay": "Permitir reproducción automática",
    "allowAutoplay_hint": "Controla si los sitios pueden reproducir audio y vídeo automáticamente. Desactivado: el contenido no se reproduce hasta que el usuario interactúa.",
    "allowImportAutofill": "Permitir importar datos de autocompletado",
    "allowImportAutofill_hint": "Controla si se pueden importar datos de formularios y autocompletado desde otro navegador. Desactivado: la importación se bloquea.",
    "allowImportBookmarks": "Permitir importar marcadores",
    "allowImportBookmarks_hint": "Controla si se pueden importar marcadores desde otro navegador. Desactivado: la importación se bloquea.",
    "allowImportHistory": "Permitir importar historial",
    "allowImportHistory_hint": "Controla si se puede importar el historial de navegación desde otro navegador. Desactivado: la importación se bloquea.",
    "allowImportSavedPasswords": "Permitir importar contraseñas guardadas",
    "allowImportSavedPasswords_hint": "Controla si se pueden importar contraseñas guardadas desde otro navegador. Desactivado: la importación se bloquea.",
    "allowImportSearchEngine": "Permitir importar motores de búsqueda",
    "allowImportSearchEngine_hint": "Controla si se pueden importar las preferencias de motor de búsqueda desde otro navegador. Desactivado: la importación se bloquea.",
    "allowExtensionInstall": "Permitir instalar extensiones",
    "allowExtensionInstall_hint": "Controla si los usuarios pueden instalar extensiones del navegador. Desactivado: se bloquean todas las extensiones salvo las gestionadas por Tuvis (que se instalan de forma forzada). Usa la lista de permitidas de abajo para autorizar extensiones concretas.",
    "allowExternalExtensions": "Permitir extensiones externas",
    "allowExternalExtensions_hint": "Controla si se instalan las extensiones que otras aplicaciones del dispositivo intentan añadir (a través del registro del sistema o del mecanismo de extensiones externas). Desactivado: las aplicaciones no pueden instalar extensiones en el navegador de forma silenciosa.",
    "summary_title": "Resumen",
    "summary_desc": "Revise lo que aplica esta política antes de guardar.",
    "summary_untitled": "Controles sin título",
    "summary_unset": "Sin definir",
    "summary_sentence_one": "Estos controles se aplican a {{identity}}. Esta política define 1 de ellos; el resto conserva la configuración base de la organización.",
    "summary_sentence_other": "Estos controles se aplican a {{identity}}. Esta política define {{count}} de ellos; el resto conserva la configuración base de la organización.",
    "summary_manages_nothing": "Esta política aún no define nada, por lo que todo lo de abajo es la configuración base de la organización y guardar no cambia nada.",
    "summary_allowed": "Permitido",
    "summary_blocked": "Bloqueado",
    "summary_updates_on": "Buscando actualizaciones",
    "summary_updates_off": "Congelado en la versión actual",
    "summary_default_search": "Motor de búsqueda predeterminado",
    "summary_corporate_domains": "Dominios corporativos",
    "summary_extension_count_one": "1 extensión",
    "summary_extension_count_other": "{{count}} extensiones",
    "summary_login_restriction_count_one": "1 aplicación restringida",
    "summary_login_restriction_count_other": "{{count}} aplicaciones restringidas",
    "summary_domain_count_one": "1 dominio",
    "summary_domain_count_other": "{{count}} dominios",
    "summary_not_managed": "Sin gestionar",
    "summary_group_other": "Otros ajustes"
  },
  "applications_page": {
    "title": "Aplicaciones",
    "predefined_title": "Aplicaciones predefinidas",
    "predefined_hint": "Aplicaciones integradas mantenidas por Tuvis. Solo lectura.",
    "custom_title": "Aplicaciones personalizadas",
    "custom_hint": "Aplicaciones definidas para su organización.",
    "categories_title": "Categorías",
    "categories_hint": "Agrupe aplicaciones en categorías para las condiciones de Tráfico de las Políticas de Acceso.",
    "manage_categories": "Gestionar categorías",
    "tab_applications": "Aplicaciones",
    "tab_categories": "Categorías",
    "type": "Tipo",
    "type_predefined": "Predefinida",
    "type_custom": "Personalizada",
    "search_placeholder": "Buscar aplicaciones…",
    "filter_title": "Filtros",
    "categories_search_placeholder": "Buscar categorías…",
    "add_category": "Añadir categoría",
    "edit_category": "Editar categoría",
    "category_name": "Nombre de la categoría",
    "create_application": "Añadir aplicación",
    "update_application": "Editar aplicación",
    "delete_application": "Eliminar aplicación",
    "delete_application_modal_message": "¿Está seguro de que desea eliminar esta aplicación?",
    "delete_category": "Eliminar categoría",
    "delete_category_modal_message": "¿Está seguro de que desea eliminar esta categoría?",
    "new_application_title": "Nueva aplicación",
    "edit_application_title": "Editar aplicación",
    "section_details_title": "Detalles",
    "section_details_desc": "Nombre, patrones de coincidencia y categorías de esta aplicación.",
    "name": "Nombre",
    "patterns": "Patrones",
    "patterns_hint": "Un patrón de host por línea, p. ej. *.salesforce.com",
    "patterns_placeholder": "*.salesforce.com",
    "categories": "Categorías",
    "categories_placeholder": "Seleccionar categorías…",
    "icon_url": "URL del icono",
    "icon_url_placeholder": "https://example.com/icon.png",
    "launch_url": "URL de inicio",
    "launch_url_placeholder": "https://example.com",
    "required": "Obligatorio",
    "save": "Guardar",
    "cancel": "Cancelar"
  },
  "device_posture_page": {
    "title": "Estado del dispositivo",
    "tab_baseline": "Línea base",
    "tab_edr_agents": "Agentes EDR",
    "baseline_enable_label": "Exigir línea base de estado",
    "baseline_hint": "Los dispositivos que no coincidan con esta expresión se consideran no conformes.",
    "save": "Guardar",
    "predefined_agents_title": "Agentes EDR/antivirus predefinidos",
    "predefined_agents_hint": "Agentes EDR/antivirus integrados mantenidos por Tuvis. Solo lectura.",
    "custom_agents_title": "Agentes EDR/antivirus personalizados",
    "custom_agents_hint": "Agentes EDR/antivirus definidos para su organización.",
    "agent_name": "Nombre",
    "agent_paths": "Rutas",
    "agent_paths_win": "Rutas de Windows (una por línea)",
    "agent_paths_mac": "Rutas de macOS (una por línea)",
    "agent_paths_linux": "Rutas de Linux (una por línea)",
    "add_agent": "Añadir agente",
    "edit_agent": "Editar agente",
    "delete_agent": "Eliminar agente",
    "delete_agent_modal_message": "¿Está seguro de que desea eliminar este agente?"
  },
  "devices_page": {
    "title": "Dispositivos",
    "hint": "Inventario de hardware y último estado de conformidad de los dispositivos con Tuvis Browser de la organización.",
    "user": "Usuario",
    "filter_title": "Filtros",
    "filter_os": "Sistema operativo",
    "filter_user": "Usuario",
    "filter_disk_encryption": "Cifrado de disco",
    "show_archived": "Mostrar archivados",
    "archive": "Archivar",
    "unarchive": "Desarchivar",
    "status": "Estado",
    "archived": "Archivado",
    "device": "Dispositivo",
    "os": "SO",
    "tuvis_version": "Versión de Tuvis",
    "extension_version": "Versión de la extensión",
    "cpu": "CPU",
    "ram": "RAM",
    "disk": "Disco",
    "compliant": "Conforme",
    "last_seen": "Última conexión",
    "empty_state": "Todavía no se ha informado de ningún dispositivo.",
    "detail_title": "Detalles del dispositivo",
    "search_empty": "Ningún dispositivo coincide con tu búsqueda",
    "refresh": "Actualizar",
    "detail_section_user": "Usuario",
    "detail_section_device": "Dispositivo",
    "detail_section_hardware": "Hardware",
    "detail_section_posture": "Estado de seguridad",
    "detail_section_extensions": "Extensiones",
    "detail_name": "Nombre",
    "detail_model": "Modelo",
    "detail_hostname": "Nombre de host",
    "detail_serial": "Número de serie",
    "detail_os": "Sistema operativo",
    "detail_last_seen": "Última conexión",
    "detail_device_id": "ID del dispositivo",
    "detail_cpu": "CPU",
    "detail_memory": "Memoria",
    "detail_disk": "Disco",
    "detail_compliance": "Cumplimiento",
    "detail_failed_checks": "Comprobaciones fallidas",
    "detail_signal_disk_encryption": "Cifrado de disco",
    "detail_signal_screen_lock": "Bloqueo de pantalla",
    "detail_signal_firewall": "Firewall",
    "detail_signal_secure_boot": "Arranque seguro",
    "detail_signal_av": "Antivirus / EDR",
    "detail_compliant": "Conforme",
    "detail_non_compliant": "No conforme",
    "tristate_enabled": "Habilitado",
    "tristate_disabled": "Deshabilitado",
    "tristate_unknown": "Desconocido",
    "detail_not_reported": "No informado",
    "detail_disk_value": "{{free}} libres de {{total}}",
    "detail_cpu_full": "{{model}} · {{cores}} núcleos · {{arch}}",
    "detail_cpu_cores": "{{model}} ({{cores}} núcleos)",
    "detail_account_detection_title": "Detección de cuenta",
    "detail_account_detection_status_ok": "OK",
    "detail_account_detection_status_no_match": "Sin coincidencia",
    "detail_account_detection_status_error": "Error",
    "detail_account_detection_last_result": "Última detección",
    "detail_extension_item": "{{name}} ({{version}}) - {{installType}}",
    "detail_tuvis_version": "Versión de Tuvis Browser",
    "detail_extension_version": "Versión de la extensión de monitoreo"
  },
  "extensions_page": {
    "title": "Extensiones",
    "hint": "Inventario unificado de las extensiones del navegador en la flota de Tuvis Browser de la organización, que combina lo aplicado por política con lo observado realmente en los dispositivos y lo puntúa por riesgo.",
    "name": "Extensión",
    "risk": "Riesgo",
    "source": "Origen",
    "devices": "Dispositivos",
    "enabled": "Habilitadas",
    "policies": "Políticas",
    "state": "Estado",
    "empty_state": "Esperando la actualización de la extensión: la extensión de monitorización necesita una nueva versión para informar de las extensiones instaladas.",
    "empty_state_none_installed": "No hay extensiones instaladas en ningún dispositivo que informe.",
    "awaiting_banner": "Ningún dispositivo ha informado todavía de extensiones instaladas, por lo que las filas siguientes provienen únicamente de sus políticas: los valores «Desconocido» y «Forzada, no observada» son esperables hasta que la extensión de monitorización publique una nueva versión.",
    "search_empty": "Ninguna extensión coincide con tu búsqueda",
    "refresh": "Actualizar",
    "detail_title": "Detalles de la extensión",
    "detail_risk": "Riesgo",
    "detail_reasons": "Motivos",
    "detail_permissions": "Permisos",
    "detail_enforcement": "Aplicación",
    "install_types": "Tipos de instalación",
    "permissions": "Permisos",
    "host_permissions": "Permisos de host",
    "assign": "Asignar a Controles del navegador",
    "add_extension": "Añadir extensión",
    "add_title": "Añadir extensión a la lista",
    "edit_title": "Editar extensión",
    "delete": "Eliminar",
    "delete_extension": "Eliminar extensión",
    "delete_extension_modal_message": "¿Seguro que quieres eliminar esta extensión de la lista mantenida manualmente?",
    "extension_id": "ID de extensión",
    "extension_name": "Nombre",
    "notes": "Notas",
    "source_manual": "Manual",
    "source_discovered": "Descubierto",
    "source_policy": "Desde la política",
    "no_longer_reported": "Ningún dispositivo lo reporta ya",
    "invalid_id": "Introduce un ID de extensión válido de 32 caracteres",
    "risk_reason": {
      "sensitive_permission": "Permiso sensible: {{detail}}",
      "unrecognized_permission": "Permiso no reconocido, puntuado de forma conservadora: {{detail}}",
      "global_host_access": "Puede leer y cambiar datos en todos los sitios",
      "specific_host_access": "Acceso a {{detail}} sitio(s) específico(s)",
      "install_type_not_policy": "No instalada por política de la organización (tipo de instalación: {{detail}})",
      "not_observed": "No se ha observado en ningún dispositivo, por lo que se desconocen sus permisos.",
      "from_last_report": "Puntuado a partir del último informe de esta extensión: ningún dispositivo la informa ya."
    },
    "risk_total": "Total",
    "risk_total_capped": "Total (limitado desde {{raw}})",
    "delete_blocked_by_policy": "Primero quítala de estas políticas de Controles del navegador: {{policies}}",
    "last_report_title": "Último informe",
    "last_report_hint": "Ningún dispositivo informa ya de esta extensión. La versión, los tipos de instalación y los permisos siguientes -y la puntuación de riesgo- provienen de su último informe.",
    "last_seen": "Último informe",
    "last_report_devices": "Dispositivos · usuarios · habilitadas (en el último informe)",
    "last_known_suffix": "último conocido"
  },
  "saas_page": {
    "title": "Descubrimiento de SaaS",
    "hint": "Aplicaciones SaaS utilizadas en la flota de Tuvis Browser de la organización, con estado de catalogación, estado de sanción y seguimiento de licencias.",
    "app": "Aplicación",
    "category": "Categoría",
    "catalogued": "Catalogado",
    "catalogued_yes": "Catalogado",
    "catalogued_no": "No catalogado",
    "status": "Estado",
    "status_unreviewed": "Sin revisar",
    "status_sanctioned": "Sancionado",
    "status_unsanctioned": "No sancionado",
    "users": "Usuarios",
    "devices": "Dispositivos",
    "visits": "Visitas",
    "seats": "Licencias",
    "last_seen": "Última actividad",
    "empty_state": "Aún no se han reportado aplicaciones SaaS.",
    "detail_title": "Detalles de la aplicación",
    "search_empty": "Ninguna aplicación SaaS coincide con tu búsqueda",
    "refresh": "Actualizar",
    "usage_section": "Uso",
    "governance_section": "Gobernanza",
    "filter_category_all": "Todas las categorías",
    "filter_status_all": "Todos los estados",
    "filter_catalogued_all": "Todas las aplicaciones",
    "filter_catalogued_yes": "Catalogadas",
    "filter_catalogued_no": "No catalogadas",
    "license_seats": "Licencias",
    "license_cost": "Costo",
    "license_renewal_date": "Fecha de renovación",
    "license_notes": "Notas",
    "save": "Guardar",
    "chart_top_apps": "Aplicaciones principales por usuarios",
    "chart_categories": "Usuarios por categoría",
    "chart_over_time": "Uso a lo largo del tiempo",
    "category_uncategorized": "Sin categoría",
    "users_section": "Usuarios",
    "no_users": "Aún no se han reportado usuarios."
  },
  "customization_page": {
    "title": "Personalización",
    "tab_start_page": "Página de inicio",
    "tab_branding": "Personalización de marca",
    "tab_block_page": "Página de bloqueo",
    "block_page_coming_soon": "La personalización de la página de bloqueo estará disponible próximamente."
  },
  "start_page_page": {
    "title": "Página de inicio",
    "create_layout": "Añadir diseño",
    "update_layout": "Editar diseño",
    "delete_layout": "Eliminar diseño",
    "delete_layout_modal_message": "¿Está seguro de que desea eliminar este diseño?",
    "new_layout_title": "Nuevo diseño de página de inicio",
    "edit_layout_title": "Editar diseño de página de inicio",
    "identity_everyone": "Todos",
    "section_details_title": "Detalles",
    "section_details_desc": "Asigne un nombre a este diseño de página de inicio.",
    "section_identity_title": "Identidad",
    "section_identity_desc": "Aplicar a todos o limitar a grupos o usuarios específicos.",
    "section_sections_title": "Secciones",
    "section_sections_desc": "Agrupe los accesos de aplicaciones en secciones que se muestran en la página de inicio de la nueva pestaña.",
    "section_branding_title": "Personalización de marca",
    "section_branding_desc": "Personalice el logotipo y el fondo que se muestran en la página de inicio. La personalización de marca es común a toda la organización y se comparte entre todos los diseños.",
    "name": "Nombre",
    "priority": "Prioridad",
    "section_title_placeholder": "Título de la sección",
    "section_apps_placeholder": "Seleccionar aplicaciones…",
    "add_section": "Añadir sección",
    "logo_url": "URL del logotipo",
    "logo_url_placeholder": "https://example.com/logo.png",
    "background": "Fondo",
    "background_placeholder": "#0b1220 o https://example.com/background.png",
    "required": "Obligatorio",
    "save": "Guardar",
    "cancel": "Cancelar"
  },
  "browser_url_policies_page": {
    "title": "Políticas de acceso",
    "nav_group_title": "Navegador Tuvis",
    "name": "Nombre",
    "action": "Acción",
    "conditions": "Condiciones",
    "controls": "Controles",
    "order": "Orden",
    "create_policy": "Nueva Política",
    "update_policy": "Editar política",
    "delete_policy": "Eliminar política",
    "delete_policy_modal_message": "¿Está seguro de que desea eliminar esta política de URL del navegador?",
    "new_policy_title": "Crear política de acceso",
    "edit_policy_title": "Editar política de acceso",
    "action_allow": "Permitir",
    "action_block": "Bloquear",
    "save": "Guardar",
    "cancel": "Cancelar",
    "enabled": "Habilitada",
    "section_details_title": "Detalles",
    "section_details_desc": "Asigne un nombre a esta política y elija si permite o bloquea el tráfico coincidente.",
    "section_traffic_title": "Tráfico",
    "section_traffic_desc": "Haga coincidir la navegación por host, URL o categoría.",
    "section_identity_title": "Identidad",
    "section_identity_desc": "Se aplica a todos, o restrinja a grupos o usuarios específicos.",
    "section_posture_title": "Postura del dispositivo",
    "section_account_title": "Cuenta (opcional)",
    "section_account_desc": "Restrinja esta política a un tipo específico de cuenta con sesión iniciada en la aplicación.",
    "account_hint": "Coincide según la cuenta que tenga la sesión iniciada en la aplicación. Tuvis lee la cuenta con sesión iniciada en este dispositivo para decidir qué política aplicar; su política de DLP decide qué se bloquea.",
    "account_type_label": "Tipo de cuenta",
    "account_domain_label": "Dominio de la cuenta",
    "account_type_corporate": "Corporativa",
    "account_type_personal": "Personal",
    "account_type_unknown": "Desconocida (aún no se ha leído en este dispositivo)",
    "unknown_reference": "{{id}} — ya no existe",
    "unknown_reference_count": "{{count}} desconocido",
    "account_gate_needs_application": "Esta condición necesita al menos una aplicación seleccionada en Tráfico: Tuvis lee la cuenta con sesión iniciada por aplicación, así que una condición de cuenta no puede aplicarse sin una.",
    "account_gate_needs_unknown": "Ninguna política habilitada admite una cuenta desconocida para {{application}}. Agregue una política, o una condición aquí, que permita una cuenta desconocida (tipo de cuenta es desconocida), para que un dispositivo donde la cuenta aún no se ha leído, o que acaba de cambiar de cuenta, no quede bloqueado.",
    "account_summary_chip": "Cuenta",
    "section_controls_title": "Controles",
    "section_controls_desc": "Monitorización y aplicación aplicadas al tráfico permitido.",
    "priority": "Prioridad",
    "description": "Descripción",
    "summary_title": "Resumen",
    "summary_desc": "Revise la política antes de guardar.",
    "summary_untitled": "Política sin título",
    "summary_sentence": "Esta política va a {{action}} el tráfico que coincida con {{traffic}} para {{identity}}.",
    "summary_unset": "Sin definir",
    "required": "Obligatorio",
    "summary_none": "Ninguno",
    "control_dlp": "Análisis DLP",
    "control_surveillance": "Análisis de vigilancia",
    "control_fraud": "Captura de fraude",
    "control_mask": "Ocultar datos sensibles",
    "control_mask_hint": "Oculta números de tarjeta, SSN, IBAN, correos y números de teléfono que se muestran en la página.",
    "control_watermark": "Marca de agua en la página",
    "control_watermark_hint": "Superpone el correo del usuario y una marca de tiempo en toda la página.",
    "control_protect_download": "Proteger descargas con contraseña",
    "control_download_password_placeholder": "Contraseña de descarga",
    "control_block_print": "Bloquear impresión",
    "control_block_clipboard": "Bloquear portapapeles (copiar/pegar)",
    "control_block_microphone": "Bloquear micrófono",
    "control_block_camera": "Bloquear cámara",
    "control_block_screen_capture": "Bloquear captura de pantalla",
    "control_inject_elite_token": "Inyectar token de seguridad elite",
    "control_inject_elite_token_hint": "Añade el encabezado del token de seguridad elite de la organización y el user-agent a las solicitudes en las páginas coincidentes.",
    "control_dlp_hint": "Analiza cargas, descargas y texto escrito según tus políticas de DLP y bloquea lo que las infrinja.",
    "control_surveillance_hint": "Registra el contenido de la página para revisión de cumplimiento. Nunca bloquea al usuario.",
    "control_fraud_hint": "Verifica los archivos descargados y cargados con el servicio de hash de fraude/malware y bloquea los archivos maliciosos conocidos.",
    "control_block_print_hint": "Impide imprimir la página: el atajo de impresión, el menú, el clic derecho y window.print() quedan deshabilitados.",
    "control_block_clipboard_hint": "Impide copiar desde la página y pegar en ella.",
    "control_block_microphone_hint": "Bloquea el acceso de la página al micrófono.",
    "control_block_camera_hint": "Bloquea el acceso de la página a la cámara.",
    "control_block_screen_capture_hint": "Bloquea capturas de pantalla, grabación de pantalla y getDisplayMedia mientras este sitio es la pestaña activa.",
    "control_protect_download_hint": "Reempaqueta las descargas de las páginas coincidentes como un zip cifrado con AES que se abre con la contraseña de abajo.",
    "control_chip_dlp": "DLP",
    "control_chip_surveillance": "Vigil.",
    "control_chip_fraud": "Fraude",
    "control_chip_mask": "Ocultar",
    "control_chip_watermark": "Marca",
    "control_chip_print": "Imprim.",
    "control_chip_clipboard": "Portap.",
    "control_chip_microphone": "Micro",
    "control_chip_camera": "Cámara",
    "control_chip_screen_capture": "Captura",
    "control_chip_elite": "Elite",
    "control_chip_password": "Contr.",
    "disable_request_review": "Desactivar la solicitud de acceso",
    "import_desktop": "Importar valores del escritorio",
    "import_desktop_done": "Se crearon {{created}} políticas de acceso (incluidas {{imported}} de sus políticas de URL existentes), el control de navegador con los límites del escritorio y una página de inicio correspondiente.",
    "import_desktop_exists": "Esta organización ya está configurada. Elimine primero sus políticas de acceso y controles de navegador, o reemplácelos.",
    "import_desktop_failed": "No se pudieron importar los valores del escritorio.",
    "import_desktop_replace_title": "¿Reemplazar lo que tiene esta organización?",
    "import_desktop_replace_body": "Esta organización tiene {{count}} políticas de acceso. Importar los valores del escritorio las elimina, junto con sus controles de navegador y páginas de inicio, y crea un conjunto nuevo.",
    "import_desktop_replace_ok": "Reemplazarlas",
    "import_desktop_replace_cancel": "Conservarlas",
    "import_desktop_fresh_body": "Crea una política de acceso por cada aplicación que permitía la aplicación de escritorio de Tuvis - su CRM, WhatsApp, Telegram y Tuvis - más una regla que bloquea todo lo demás, los controles de navegador del escritorio y una página de inicio con esas aplicaciones."
  },
  "browser_notifications_page": {
    "title": "Notificaciones",
    "access_request_title": "Solicitudes de acceso",
    "access_request_description": "Se envía por correo cuando alguien solicita acceso a un sitio bloqueado. La solicitud aparece en la cola de Solicitudes de acceso aunque no se envíe ningún correo.",
    "recipients_placeholder": "Escribe una dirección de correo y pulsa Enter",
    "nobody_emailed": "No se envía correo a nadie. Las solicitudes siguen apareciendo en la cola.",
    "invalid_email": "{{email}} no es una dirección de correo válida",
    "save": "Guardar",
    "saved": "Destinatarios guardados",
    "save_failed": "No se pudieron guardar los destinatarios"
  },
  "dlp_page": {
    "bulk_update": {
      "success": "Se actualizaron correctamente {{numOfIncidents}} incidentes",
      "failed": "Error al actualizar los incidentes"
    },
    "unassigned": "Sin asignar",
    "is_group": "Es Grupo",
    "true": "Verdadero",
    "false": "Falso",
    "created_at": "Creado el",
    "updated_at": "Actualizado el",
    "final_action": "Acción final",
    "sent": "Enviado",
    "blocked": "Bloqueado",
    "filters": {
      "title": "Filtrar incidentes",
      "show_incidents_related_to_me": "Mostrar incidentes relacionados conmigo",
      "file_only_corrupted_or_encrypted": "Mostrar incidentes con archivo corrupto o cifrado",
      "hide_incidents_with_keyword_campaigns": "Ocultar incidentes que coincidan con palabras clave"
    },
    "pii_categories": {
      "AuthToken": "Token de autenticación",
      "AwsCredentials": "Claves de acceso a la cuenta de Amazon Web Services (AWS)",
      "AzureAuthToken": "Token de autenticación de Microsoft Azure",
      "BasicAuthHeader": "Encabezado de autenticación básica HTTP",
      "EncryptionKey": "Clave de cifrado",
      "GcpApiKey": "Clave de API de Google Cloud Platform (GCP)",
      "GcpCredentials": "Credenciales de cuenta de servicio de Google Cloud Platform (GCP)",
      "HttpCookie": "Cookie HTTP",
      "JsonWebToken": "Token Web JSON (JWT)",
      "OauthClientSecret": "Secreto de cliente OAuth",
      "Password": "Contraseña",
      "SslCertificate": "Certificado SSL",
      "StorageSignedPolicyDocument": "Documento de política firmada de almacenamiento en la nube",
      "StorageSignedUrl": "URL firmada de almacenamiento en la nube",
      "WeakPasswordHash": "Hash de contraseña débil",
      "XsrfToken": "Token de falsificación de solicitud entre sitios (CSRF)",
      "Age": "Edad",
      "Email": "Correo electrónico",
      "Date": "Fecha",
      "Organization": "Organización",
      "Person": "Persona",
      "PhoneNumber": "Número de teléfono",
      "Address": "Dirección",
      "IPAddress": "Dirección IP",
      "URL": "URL",
      "CreditCardNumber": "Número de tarjeta de crédito",
      "SwiftCode": "Código SWIFT",
      "InternationalBankingAccountNumber": "Número de cuenta bancaria internacional (IBAN)",
      "ABARoutingNumber": "Número de ruta de ABA",
      "ARNationalIdentityNumber": "Número de identidad nacional de Argentina (DNI)",
      "ATIdentityCard": "Cédula de identidad de Austria",
      "ATTaxIdentificationNumber": "Número de identificación fiscal de Austria",
      "ATValueAddedTaxNumber": "Número de IVA de Austria",
      "AUBankAccountNumber": "Número de cuenta bancaria de Australia",
      "AUBusinessNumber": "Número de negocio australiano",
      "AUCompanyNumber": "Número de compañía australiana",
      "AUDriversLicenseNumber": "Número de licencia de conducir australiana",
      "AUMedicalAccountNumber": "Número de cuenta médica australiana",
      "AUPassportNumber": "Número de pasaporte australiano",
      "AUTaxFileNumber": "Número de archivo fiscal australiano",
      "AzureDocumentDBAuthKey": "Clave de autenticación de Azure DocumentDB",
      "AzureIaasDatabaseConnectionAndSQLString": "Cadena de conexión de base de datos Azure IAAS y cadena de conexión de SQL de Azure",
      "AzureIoTConnectionString": "Cadena de conexión de Azure IoT",
      "AzurePublishSettingPassword": "Contraseña de configuración de publicación de Azure",
      "AzureRedisCacheString": "Cadena de conexión de Azure Redis Cache",
      "AzureSAS": "Azure SAS",
      "AzureServiceBusString": "Cadena de conexión de Azure Service Bus",
      "AzureStorageAccountGeneric": "Clave de cuenta de almacenamiento de Azure (Genérico)",
      "AzureStorageAccountKey": "Clave de cuenta de almacenamiento de Azure",
      "BENationalNumber": "Número nacional de Bélgica",
      "BENationalNumberV2": "Número nacional de Bélgica V2",
      "BEValueAddedTaxNumber": "Número de IVA de Bélgica",
      "BGUniformCivilNumber": "Número civil uniforme de Bulgaria",
      "BrcpfNumber": "Número CPF de Brasil",
      "BRLegalEntityNumber": "Número de entidad legal de Brasil (CNPJ)",
      "BRNationalIdrg": "Número de documento de identidad nacional de Brasil (RG)",
      "CABankAccountNumber": "Número de cuenta bancaria de Canadá",
      "CADriversLicenseNumber": "Número de licencia de conducir de Canadá",
      "CAHealthServiceNumber": "Número de servicio de salud de Canadá",
      "CAPassportNumber": "Número de pasaporte de Canadá",
      "CAPersonalHealthIdentification": "Número de identificación de salud personal de Canadá (PHIN)",
      "CASocialInsuranceNumber": "Número de seguro social de Canadá",
      "CHSocialSecurityNumber": "Número de seguro social de Chile",
      "CLIdentityCardNumber": "Número de cédula de identidad de Chile",
      "CNResidentIdentityCardNumber": "Número de tarjeta de identidad de residente de China (PRC)",
      "CYIdentityCard": "Cédula de identidad de Chipre",
      "CYTaxIdentificationNumber": "Número de identificación fiscal de Chipre",
      "CZPersonalIdentityNumber": "Número de identificación personal de la República Checa",
      "CZPersonalIdentityV2": "Número de identificación personal de la República Checa V2",
      "DEDriversLicenseNumber": "Número de licencia de conducir alemana",
      "DEIdentityCardNumber": "Número de cédula de identidad de Alemania",
      "DEPassportNumber": "Número de pasaporte de Alemania",
      "DETaxIdentificationNumber": "Número de identificación fiscal de Alemania",
      "DEValueAddedNumber": "Número de IVA de Alemania",
      "DKPersonalIdentificationNumber": "Número de identificación personal de Dinamarca",
      "DKPersonalIdentificationV2": "Número de identificación personal de Dinamarca V2",
      "DrugEnforcementAgencyNumber": "Número de la Agencia Antidrogas de EE. UU. (DEA)",
      "EEPersonalIdentificationCode": "Código de identificación personal de Estonia",
      "Esdni": "DNI de España",
      "PeruDni": "DNI de Perú",
      "ESSocialSecurityNumber": "Número de seguro social de España (SSN)",
      "ESTaxIdentificationNumber": "Número de identificación fiscal de España",
      "EUDebitCardNumber": "Número de tarjeta de débito de la UE",
      "EUDriversLicenseNumber": "Número de licencia de conducir de la UE",
      "EugpsCoordinates": "Coordenadas GPS de la UE",
      "EUNationalIdentificationNumber": "Número de identificación nacional de la UE",
      "EUPassportNumber": "Número de pasaporte de la UE",
      "EUSocialSecurityNumber": "Número de seguro social de la UE (SSN) o identificación equivalente",
      "EUTaxIdentificationNumber": "Número de identificación fiscal de la UE (TIN)",
      "FIEuropeanHealthNumber": "Número europeo de seguro de salud de Finlandia",
      "FINationalID": "Cédula de identidad nacional de Finlandia",
      "FINationalIDV2": "Cédula de identidad nacional de Finlandia V2",
      "FIPassportNumber": "Número de pasaporte de Finlandia",
      "FRDriversLicenseNumber": "Número de licencia de conducir de Francia",
      "FRHealthInsuranceNumber": "Número de seguro de salud de Francia",
      "FRNationalID": "Cédula de identidad nacional de Francia (CNI)",
      "FRPassportNumber": "Número de pasaporte de Francia",
      "FRSocialSecurityNumber": "Número de seguro social de Francia (INSEE)",
      "FRTaxIdentificationNumber": "Número de identificación fiscal de Francia (Numéro SPI)",
      "FRValueAddedTaxNumber": "Número de IVA de Francia",
      "GRNationalIDCard": "Tarjeta de identidad nacional griega",
      "GRNationalIDV2": "Tarjeta de identidad nacional griega V2",
      "GRTaxIdentificationNumber": "Número de identificación fiscal griego",
      "HKIdentityCardNumber": "Número de tarjeta de identidad de Hong Kong (HKID)",
      "HRIdentityCardNumber": "Número de tarjeta de identidad de Croacia",
      "HRNationalIDNumber": "Número de identificación nacional de Croacia",
      "HRPersonalIdentificationNumber": "Número de identificación personal de Croacia",
      "HRPersonalIdentificationOIBNumberV2": "Número de identificación personal de Croacia (OIB) V2",
      "HUPersonalIdentificationNumber": "Número de identificación personal de Hungría",
      "HUTaxIdentificationNumber": "Número de identificación fiscal de Hungría",
      "HUValueAddedNumber": "Número de IVA de Hungría",
      "IDIdentityCardNumber": "Número de tarjeta de identidad de Indonesia (KTP)",
      "IEPersonalPublicServiceNumber": "Número de servicio público personal de Irlanda (PPS)",
      "IEPersonalPublicServiceNumberV2": "Número de servicio público personal de Irlanda (PPS) v2",
      "ILBankAccountNumber": "Número de cuenta bancaria de Israel",
      "ILNationalID": "Identificación nacional de Israel",
      "INPermanentAccount": "Número de cuenta permanente de India (PAN)",
      "INUniqueIdentificationNumber": "Número de identificación único de India (Aadhaar)",
      "ITDriversLicenseNumber": "Número de licencia de conducir de Italia",
      "ITFiscalCode": "Código fiscal de Italia",
      "ITValueAddedTaxNumber": "Número de IVA de Italia",
      "JPBankAccountNumber": "Número de cuenta bancaria de Japón",
      "JPDriversLicenseNumber": "Número de licencia de conducir de Japón",
      "JPMyNumberCorporate": "\"Mi número\" de Japón (Corporativo)",
      "JPMyNumberPersonal": "\"Mi número\" de Japón (Personal)",
      "JPPassportNumber": "Número de pasaporte de Japón",
      "JPResidenceCardNumber": "Número de tarjeta de residencia de Japón",
      "JPResidentRegistrationNumber": "Número de registro de residente de Japón",
      "JPSocialInsuranceNumber": "Número de seguro social de Japón (SIN)",
      "KRResidentRegistrationNumber": "Número de registro de residente de Corea del Sur",
      "LTPersonalCode": "Código personal lituano",
      "LUNationalIdentificationNumberNatural": "Número de identificación nacional de Luxemburgo (Personas naturales)",
      "LUNationalIdentificationNumberNonNatural": "Número de identificación nacional de Luxemburgo (Personas jurídicas)",
      "LVPersonalCode": "Código personal letón",
      "MTIdentityCardNumber": "Número de tarjeta de identidad de Malta",
      "MTTaxIDNumber": "Número de identificación fiscal de Malta",
      "MYIdentityCardNumber": "Número de tarjeta de identidad de Malasia",
      "NLCitizensServiceNumber": "Número de servicio ciudadano de los Países Bajos",
      "NLCitizensServiceNumberV2": "Número de servicio ciudadano de los Países Bajos V2",
      "NLTaxIdentificationNumber": "Número de identificación fiscal de los Países Bajos",
      "NLValueAddedTaxNumber": "Número de IVA de los Países Bajos",
      "NOIdentityNumber": "Número de identificación de Noruega",
      "NZBankAccountNumber": "Número de cuenta bancaria de Nueva Zelanda",
      "NZDriversLicenseNumber": "Número de licencia de conducir de Nueva Zelanda",
      "NZInlandRevenueNumber": "Número de ingresos internos de Nueva Zelanda",
      "NZMinistryOfHealthNumber": "Número de Ministerio de Salud de Nueva Zelanda",
      "NZSocialWelfareNumber": "Número de bienestar social de Nueva Zelanda",
      "PHUnifiedMultiPurposeIDNumber": "Número de identificación multifuncional unificado de Filipinas",
      "PLIdentityCard": "Tarjeta de identidad de Polonia",
      "PLNationalID": "Identificación nacional de Polonia",
      "PLNationalIDV2": "Identificación nacional de Polonia V2",
      "PLPassportNumber": "Número de pasaporte de Polonia",
      "PlregonNumber": "Número REGON de Polonia",
      "PLTaxIdentificationNumber": "Número de identificación fiscal de Polonia",
      "PTCitizenCardNumber": "Número de tarjeta de ciudadano de Portugal",
      "PTCitizenCardNumberV2": "Número de tarjeta de ciudadano de Portugal V2",
      "PTTaxIdentificationNumber": "Número de identificación fiscal de Portugal",
      "ROPersonalNumericalCode": "Código numérico personal de Rumania (CNP)",
      "RUPassportNumberDomestic": "Número de pasaporte doméstico de Rusia",
      "RUPassportNumberInternational": "Número de pasaporte internacional de Rusia",
      "SANationalID": "Identificación nacional de Sudáfrica",
      "SENationalID": "Identificación nacional de Suecia",
      "SENationalIDV2": "Identificación nacional de Suecia V2",
      "SEPassportNumber": "Número de pasaporte de Suecia",
      "SETaxIdentificationNumber": "Número de identificación fiscal de Suecia",
      "SGNationalRegistrationIdentityCardNumber": "Número de tarjeta de identidad de registro nacional de Singapur",
      "SITaxIdentificationNumber": "Número de identificación fiscal de Eslovenia",
      "SIUniqueMasterCitizenNumber": "Número único de ciudadano maestro de Eslovenia",
      "SKPersonalNumber": "Número personal de Eslovaquia",
      "SQLServerConnectionString": "Cadena de conexión de SQL Server",
      "THPopulationIdentificationCode": "Código de identificación de la población de Tailandia",
      "TRNationalIdentificationNumber": "Número de identificación nacional de Turquía",
      "TWNationalID": "Identificación nacional de Taiwán",
      "TWPassportNumber": "Número de pasaporte de Taiwán",
      "TWResidentCertificate": "Certificado de residencia de Taiwán (ARC/TARC)",
      "UAPassportNumberDomestic": "Número de pasaporte doméstico de Ucrania",
      "UAPassportNumberInternational": "Número de pasaporte internacional de Ucrania",
      "UKDriversLicenseNumber": "Número de licencia de conducir del Reino Unido",
      "UKElectoralRollNumber": "Número de registro electoral del Reino Unido",
      "UKNationalHealthNumber": "Número del Servicio Nacional de Salud del Reino Unido (NHS)",
      "UKNationalInsuranceNumber": "Número de seguro nacional del Reino Unido (NINO)",
      "UKUniqueTaxpayerNumber": "Número de referencia único del contribuyente del Reino Unido",
      "USBankAccountNumber": "Número de cuenta bancaria de EE. UU.",
      "USDriversLicenseNumber": "Número de licencia de conducir de EE. UU.",
      "USIndividualTaxpayerIdentification": "Número de identificación del contribuyente individual de EE. UU. (ITIN)",
      "USSocialSecurityNumber": "Número de seguro social de EE. UU. (SSN)",
      "UsukPassportNumber": "Número de pasaporte de EE. UU. o del Reino Unido",
      "ZAIdentificationNumber": "Número de identificación de Sudáfrica"
    },
    "search_placeholder": "Buscar...",
    "title": "Data Loss Protection",
    "policy_name": "Nombre de la política",
    "export_yes": "Sí",
    "export_no": "No",
    "export_rule_id": "ID de regla",
    "export_expressions": "Expresiones",
    "export_pii": "Categorías de PII",
    "export_metadata": "Metadatos",
    "export_create_incident": "Crear incidente",
    "export_scope": "Alcance",
    "export_message_type": "Tipo de mensaje",
    "export_file_conditions": "Condiciones de archivo",
    "export_rules": "Reglas",
    "rule_name": "Nombre de la regla",
    "severity": "Gravedad",
    "include": "Incluir",
    "exclude": "Excluir",
    "file_warning": "Advertencia de archivo",
    "create_an_incident": "Crear un incidente",
    "incident_severity": "Gravedad del incidente",
    "should_attach_msg_content": "Adjuntar contenido del mensaje y/o archivo",
    "custom_alert_message": "Mensaje de alerta personalizado",
    "custom_alert_message_placeholder": "Ingrese un mensaje personalizado para mostrar cuando esta política bloquee un mensaje",
    "priority": "Prioridad",
    "description": "Descripción",
    "comment": "Comentario",
    "action": "Acción",
    "action_taken": "Acción Tomada",
    "content": "Contenido del Mensaje",
    "created_by": "Creado por",
    "sender": "Remitente",
    "senderEmail": "Correo del Remitente",
    "senderLogin": "Usuario del Remitente",
    "assignee": "Responsable designado",
    "senderPhone": "Número de Teléfono del Remitente",
    "recipient": "Destinatario",
    "incidents": "Incidentes",
    "status": "Status",
    "createdAt": "Fecha de Creación del Incidente",
    "messageSentAt": "Mensaje Enviado el",
    "recipientPhone": "Número de Teléfono del Destinatario",
    "attachment": "Adjuntos",
    "file_corrupted_or_encrypted": "Archivo corrupto o cifrado",
    "matched_expressions": "Expresiones Coincidentes",
    "unique_matches_identified": "Coincidencias Únicas Identificadas",
    "fileName": "Nombre del Archivo",
    "fileSize": "Tamaño del Archivo",
    "fileType": "Tipo de Archivo",
    "update_incident_status": "Estado del Incidente",
    "update_incident_status_desc": "Por favor, explique por qué este incidente está {{ status }}:",
    "low": "Bajo",
    "medium": "Medio",
    "high": "Alto",
    "critical": "Crítico",
    "resolved": "Resuelto",
    "dismissed": "Descartado",
    "new": "Nuevo",
    "enabled": "Habilitado",
    "action_ALLOW": "Permitir",
    "action_BLOCK": "Bloquear",
    "delete_rule": "Eliminar Regla",
    "delete_rule_modal_message": "¿Estás seguro de que quieres eliminar esta regla de DLP?",
    "rule_in_use": "Regla en uso",
    "rule_in_use_description": "Esta regla está actualmente en uso por {{policies}} políticas y no se puede eliminar.",
    "update_rule": "Editar Regla",
    "create_rule": "Nueva Regla",
    "delete_policy": "Eliminar Política",
    "delete_policy_modal_message": "¿Estás seguro de que quieres eliminar esta política de DLP?",
    "update_policy": "Editar Política",
    "create_policy": "Nueva Política",
    "catch_all_policy_description": "Capturar todo",
    "search_policies": "Buscar políticas",
    "no_policies_found": "No se encontraron políticas",
    "search_rules": "Buscar reglas",
    "no_rules_found": "No se encontraron reglas",
    "subscriptions": "Destinatarios de notificación, separados por \",\"",
    "notify_by_email_when_policy_is_triggered": "Notificar por correo electrónico cuando se active la política",
    "email_attachment_size_limit_tooltip": "Límite de adjuntos por correo electrónico: 5 MB.",
    "tabs": {
      "policies": "Políticas",
      "rules": "Reglas"
    },
    "conditions": {
      "title": "Condiciones",
      "expressions": "Expresión",
      "user": "Usuario",
      "user_description": "Usuario == {{user}}",
      "user_all": "Todos los usuarios",
      "group": "Grupo",
      "group_description": "Grupo == {{group}}",
      "mime_type": "Tipo de Archivo",
      "mime_type_description": "Tipo de Archivo == {{mimeType}}",
      "file_size": "Tamaño de Archivo",
      "file_size_description": "Tamaño de Archivo {{operator}} {{size}}",
      "file_size_placeholder": "Tamaño en bytes",
      "template": "Plantilla de mensaje",
      "template_description": "Plantillas de mensajes creadas a través de Tuvis",
      "devtools": "Acceso a DevTools",
      "devtools_description": "Intento de acceso a herramientas de desarrollador",
      "and_between_conditions": "Y",
      "direction_all": "Todos los mensajes",
      "direction_OUTBOUND": "Enviar Mensajes ⇨",
      "direction_OUTBOUND_description": "Mensaje {{msgType}} enviado",
      "direction_INBOUND": "Texto Recibido ⇦",
      "direction_INBOUND_description": "Texto del mensaje recibido",
      "direction_DOWNLOAD": "Descargar adjunto ⇩",
      "direction_DOWNLOAD_description": "Adjunto descargado",
      "direction_UPLOAD": "Subir adjunto ⇧",
      "direction_UPLOAD_description": "Adjunto subido",
      "PII": "Información Personal Identificable (PII)",
      "rule": "DLP Regla",
      "image_unappropriate": "Imagen Inapropiada",
      "has_expression": "Contiene Expresión",
      "import_expression_csv": "Importar expresiones desde CSV",
      "expression": "Expresión",
      "expression_casesensitive": "Expresión (sensible a mayúsculas y minúsculas)",
      "pii_category": "PII Categoría",
      "max_occurrences": "Ocurrencias máximas",
      "count_unique_values_only": "Contar solo valores únicos",
      "metadata": "Metadatos",
      "metadata_key": "Clave de Metadatos",
      "metadata_value": "Valor",
      "delete_expression": "Eliminar",
      "test_condition": "Probar",
      "or_between_expression": "O",
      "description": "Descripción",
      "invalid_expression": "Expresión inválida",
      "internal_users": "Usuarios Internos",
      "internal_users_description": "{{include}} Usuarios Internos"
    },
    "operators": {
      "gt": "mayor que (>)",
      "lt": "menor que (<)",
      "gte": "mayor o igual (≥)",
      "lte": "menor o igual (≤)"
    },
    "outbound_message_types": {
      "text": "Texto",
      "event": "Evento",
      "order": "Orden",
      "poll": "Encuesta",
      "contact": "Contacto"
    },
    "builder": {
      "create_title": "Crear Política de DLP",
      "edit_title": "Editar Política de DLP",
      "cancel": "Cancelar",
      "save_policy": "Guardar Política",
      "load_failed": "Error al cargar esta política.",
      "aria_clear": "Limpiar {{label}}",
      "aria_open": "Abrir {{label}}",
      "steps": {
        "details": {
          "title": "Detalles de la Política",
          "description": "Define la información básica, acción, notificaciones y comportamiento de incidentes para esta política."
        },
        "scope": {
          "title": "Alcance",
          "description": "Elige a quién se aplica esta política."
        },
        "conditions": {
          "title": "Condiciones",
          "description": "Define cuándo debe activarse esta política."
        },
        "summary": {
          "title": "Resumen de la Política",
          "description": "Revisa la política resultante antes de guardar."
        }
      },
      "scope": {
        "senderScopeLabel": "Alcance del remitente",
        "contactScopeLabel": "Alcance del contacto",
        "allUsers": {
          "title": "Todos los Usuarios",
          "description": "Aplica esta política a todos en la organización."
        },
        "specificUsers": {
          "title": "Usuarios Específicos",
          "description": "Aplica esta política solo a usuarios seleccionados.",
          "selector": "Seleccionar usuarios"
        },
        "specificGroups": {
          "title": "Grupos de Usuarios",
          "description": "Aplica esta política solo a grupos seleccionados.",
          "selector": "Seleccionar grupos"
        },
        "anyContact": {
          "title": "Todos los Contactos",
          "description": "Aplica esta política al hablar con cualquier contacto."
        },
        "internalUsers": {
          "title": "Usuarios Internos",
          "description": "Aplica esta política al hablar con usuarios internos (Tuvis)."
        },
        "externalContacts": {
          "title": "Contactos Externos",
          "description": "Aplica esta política al hablar con contactos externos."
        }
      },
      "message_type": {
        "title": "Tipo de Mensaje",
        "description": "Elige la dirección principal del mensaje que debe inspeccionar esta política.",
        "outbound_selector": "Tipos de mensajes salientes"
      },
      "file_conditions": {
        "title": "Condiciones de Archivo",
        "description": "Restringe la política a tipos o tamaños de archivo específicos cuando sea relevante."
      },
      "rules": {
        "title": "Reglas de DLP",
        "description": "Combina reglas de DLP existentes. Las reglas dentro de un grupo son OR. Los grupos separados son AND.",
        "group_title": "Grupo de Reglas {{number}}",
        "group_help": "Seleccionar múltiples reglas en un grupo significa lógica OR dentro de ese grupo.",
        "add_group": "Agregar Grupo de Reglas"
      },
      "advanced": {
        "title": "Otras Condiciones",
        "description": "Aplica esta política a contextos de mensajes adicionales, como plantillas y actividad de DevTools."
      },
      "summary": {
        "untitled_policy": "Política sin título",
        "policy_sentence": "Esta política va a {{action}} mensajes para {{scope}} cuando {{conditions}}.",
        "surveillance_policy_sentence": "Esta política monitoreará mensajes para {{scope}} cuando {{conditions}}.",
        "no_scope_selection": "No hay usuarios seleccionados aún",
        "no_conditions": "Sin condiciones establecidas - esta política se aplica a todos los mensajes.",
        "no_notifications": "Sin correos electrónicos de notificación",
        "outbound_types": "Tipos de mensajes enviados: {{types}}",
        "file_types": "Tipos de archivo: {{types}}",
        "file_size": "Tamaño de archivo {{operator}} {{size}}"
      }
    },
    "rule_modal": {
      "steps": {
        "details": {
          "title": "Detalles de la regla",
          "description": "Define la información básica de esta regla."
        },
        "conditions": {
          "title": "Condiciones",
          "description": "Elige y configura las verificaciones que debe ejecutar esta regla."
        }
      },
      "condition_types": {
        "add_label": "Tipos de condición",
        "empty": "Selecciona un tipo de condición para empezar.",
        "has_expression": "Coincide texto mediante expresiones regulares.",
        "PII": "Detecta categorías integradas de datos personales o sensibles.",
        "metadata": "Coincide mensajes mediante pares clave-valor de metadatos.",
        "image_unappropriate": "Marca imágenes inapropiadas en contenido compartido."
      }
    },
    "required": "Requerido",
    "rules_load_failed": "Error al cargar las reglas"
  },
  "submit": "Enviar",
  "download_tuvispace_page": {
    "description": "Descargue tuvis® y garantice la seguridad, eficacia y conformidad de sus comunicaciones.",
    "download_mac": "Descargar para MacOS ({{appleType}})",
    "download_windows": "O descargar para Windows",
    "download_for": "O descargar para",
    "already_installed": "¿Ya instalaste la aplicación tuvis®? ¡Entra en tu espacio de trabajo ahora!",
    "open_tuvispace": "Abrir tuvis®",
    "title": "tuvis®"
  },
  "sidecarNotifications": {
    "sidecar_disconnected": "Desconexión del dispositivo",
    "sidecar_paired": "Dispositivo emparejado",
    "sidecar_invited": "Invitación enviada",
    "sidecar_phone_mismatch": "Número de teléfono no coincide",
    "title": "Notificaciones",
    "saveSettings": "Guardar configuraciones",
    "subHeader": "Notifícame sobre...",
    "recipients": "Destinatarios:",
    "recipients_text": "Agrega escribiendo la dirección de correo electrónico o buscando por nombre (Usa “,” para agregar varios miembros)",
    "saved_successfully": "La configuración de notificaciones se guardó correctamente",
    "saved_failed": "Error al guardar la configuración de notificaciones",
    "customInviteEmail": {
      "title": "Personaliza tu invitación por correo electrónico",
      "description": "Personaliza la invitación por correo electrónico a tu equipo. Puedes usar las siguientes variables en el cuerpo del correo electrónico. Las variables marcadas con * son requeridas.",
      "preview": "Vista previa",
      "dropzone": "Arrastra y suelta un archivo HTML o selecciona uno",
      "variables": {
        "invite_link": "Enlace de invitación",
        "inviter_name": "Nombre del invitador",
        "inviter_email": "Correo electrónico del invitador",
        "channel_name": "Nombre del canal",
        "expected_phone": "Teléfono esperado"
      },
      "errors": {
        "invalid_html": "HTML inválido",
        "missing_variables": "Tu correo electrónico está faltando las siguientes variables requeridas: {{variables}}"
      }
    },
    "invite_email_first_connection_template": {
      "title": "Plantilla de invitación por correo electrónico para la primera conexión",
      "description": "Selecciona un archivo HTML para usar como plantilla de correo electrónico enviado como invitación por correo electrónico para la primera conexión."
    },
    "invite_email_reconnection_template": {
      "title": "Plantilla de invitación por correo electrónico para la reconexión",
      "description": "Selecciona un archivo HTML para usar como plantilla de correo electrónico enviado como invitación por correo electrónico para la reconexión."
    },
    "invite_email_first_connection_subject": {
      "title": "Asunto del Correo de Primera Invitación",
      "description": "Define el asunto del correo de invitación enviado por primera vez."
    },
    "invite_email_reconnection_subject": {
      "title": "Asunto del Correo de Reconexión",
      "description": "Define el asunto del correo de invitación de reconexión."
    },
    "remove": "Eliminar",
    "select_file": "Selecciona un archivo",
    "default_support_email": {
      "title": "Correo electrónico de soporte por defecto",
      "description": "Si está definido, este correo electrónico se usará como el correo electrónico de soporte por defecto para las invitaciones de sidecar en lugar del correo electrónico del invitador."
    },
    "orgConfigs": {
      "inviter_name": {
        "title": "Nombre del invitador",
        "description": "Nombre mostrado como invitador en los correos de invitación de Remote Sync. Déjelo vacío para usar el nombre del usuario que invita."
      }
    }
  },
  "sidecarCustomizations": {
    "title": "Personalizaciones",
    "saveSettings": "Guardar configuración",
    "saved_successfully": "Personalizaciones guardadas correctamente",
    "saved_failed": "Error al guardar las personalizaciones",
    "remote_sync_custom_error_text": {
      "title": "Mensaje de error personalizado de sincronización",
      "description": "Si se define, este texto se muestra debajo del error estándar de Remote Sync (p. ej. Sincronización fallida) para dirigir a los usuarios a su contacto de cumplimiento o soporte."
    }
  },
  "sf_email_domain": {
    "update_successfully": "Actualizado exitosamente",
    "duplicate_domains_error": "El dominio de correo electrónico ya existe. Por favor, utilice un dominio diferente.",
    "update_failure": "Error al actualizar",
    "partial_success": "{{insertedCount}} dominio(s) agregado(s) exitosamente, {{duplicateCount}} duplicado(s) fueron omitidos"
  },
  "users_management": {
    "user_messages": "Mensajes de Usuario",
    "invite_to_remote_sync": "Invitar a Tuvis Remote Sync",
    "invite_to_platform": "Invitar a la plataforma Tuvis",
    "invite_to_platform_tooltip": "Cuando está habilitado, los usuarios recibirán una invitación por correo electrónico para unirse a la plataforma",
    "invite_to_desktop_and_extensions": "Invitar a las aplicaciones de escritorio y extensiones de Tuvis",
    "invite_to_desktop_and_extensions_tooltip": "Cuando está habilitado, los usuarios recibirán una invitación por correo electrónico para unirse a la aplicación de escritorio y las extensiones del navegador de Tuvis"
  },
  "actions_find_accounts": "Buscar Cuenta",
  "actions_create_new": "Crear Nuevo",
  "actions_create_button": "Crear",
  "super_admin_org_configs": {
    "generate": "Generar",
    "last_updated_at": "Última actualización el",
    "title": {
      "entity": "Entity",
      "autoSync": "Auto Sync",
      "search": "Search",
      "layout": "Layout",
      "layoutLimits": "Límite de campos",
      "actions": "Actions",
      "apps": "Apps",
      "notifications": "Notifications",
      "security": "Security",
      "analytics": "Dashboard",
      "sidecars": "Remote Sync",
      "superAdmin": "Super Admin",
      "page_title": "Organization Settings",
      "general": "General Settings",
      "incidents_summary_email": "Resumen de incidentes",
      "org_admin": "Administrador de la organización",
      "orgAdminMessageSync": "Sincronización de mensajes",
      "orgAdminRules": "Reglas",
      "orgAdminUserManagement": "Gestión de usuarios",
      "tuvisAdminChannels": "Canales",
      "tuvisAdminFeatures": "Funciones",
      "tuvisAdminMessagesSync": "Sincronización de mensajes",
      "tuvisAdminSecurity": "Seguridad",
      "autoSyncCases": "Sincronización automática de casos",
      "autoSyncActivities": "Sincronización automática de actividades"
    },
    "confirm_changes": "¿Estás seguro de que deseas aplicar los siguientes cambios?",
    "reason_label": "Motivo de los cambios",
    "reason_placeholder": "ej., Probando función para cliente X, Mejora de rendimiento...",
    "who_requested_label": "Quién solicitó",
    "who_requested_placeholder": "ej., Nombre del cliente, ID de ticket...",
    "one_change_at_a_time_toast": "Solo se puede cambiar una configuración a la vez. Revierte los demás cambios e inténtalo de nuevo.",
    "view_opportunity_link": "Ver oportunidad",
    "view_opportunity_link_url": "#",
    "opportunity_link_label": "Enlace a la oportunidad",
    "opportunity_link_placeholder": "Pega la URL de la oportunidad de Salesforce",
    "import_configuration": "Importar Configuración",
    "importing_configuration": "Importando configuración de {{ orgName }}",
    "import_configuration_failed": "Error al importar la configuración",
    "import_configuration_success": "Configuración importada con éxito, haz clic en 'Guardar' para aplicar los cambios",
    "conflicts_with": "Conflictos con",
    "conflict_banner": {
      "title": "Conflictos de Configuración Detectados",
      "description": "Al habilitar {{enabled}}, las siguientes configuraciones han sido desactivadas:"
    },
    "configs": {
      "names": {
        "identityMergeKey": "Clave de combinación de identidad",
        "sf": "Salesforce",
        "msd": "Microsoft Dynamics",
        "allow_elite_token": "Permitir Token de Seguridad Elite",
        "allow_im_templates": "Permitir plantillas de mensajes",
        "show_only_wap_channels_in_desktop": "Mostrar solo canales de WhatsApp en escritorio",
        "hide_wap_channels_button_in_desktop": "Oculta el botón de 'Canales' de WhatsApp",
        "hide_delete_conversation_button": "Oculta el botón 'Eliminar conversación' de WhatsApp",
        "hide_block_contact_button": "Oculta el botón 'Bloquear contacto' de WhatsApp",
        "limit_date_range_of_messages": "Periodo del históricos de mensajes",
        "org_partner": "Socio de Organización",
        "phones_blocked_from_sync": "Bloquear números de teléfono específicos",
        "available_crm": "CRM Disponible",
        "organizationName": "Nombre de la organización",
        "orgType": "Tipo de Organización",
        "description": "Descripción",
        "isActive": "Is Organization Active",
        "paidLicences": "Licencias Tuvis Desktop  - Adquiridas",
        "exceededLicences": "Licencias Tuvis Desktop - Permitidas",
        "isPOC": "Is In POC Trial",
        "POCExpiration": "POC Trial Expiration Date",
        "leadsdisplay": "Prospectos - Visualizar",
        "leadscreate": "Prospectos - Crear",
        "contactscreate": "Contactos - Crear",
        "contactsdisplay": "Contactos - Visualizar",
        "casesdisplay": "Casos - Visualizar",
        "activitiesdisplay": "Actividades - Visualizar",
        "hideleadprogresstopbar": "Prospectos - Ocultar la barra superior de progreso",
        "enableautosynchidebutton": "Chat Sync- Ocultar botón",
        "enableautosyncfiles": "Archivos - Habilitar sincronización automática",
        "autosynclimittomaxfilesize": "Archivos - Sincronizar tamaño máximo",
        "activitiescreate": "Actividades - Crear",
        "hidesearchonmessenger": "Hide Search on Messenger",
        "tasksdisplay": "Tareas - Visualizar",
        "appshidegooglemeet": "Ocultar Google Meet",
        "appshidemsteams": "Ocultar MS Teams",
        "taskscreate": "Tareas - Crear",
        "casescreate": "Casos - Crear",
        "hideopportunitytopbar": "Oportunidades - Ocultar la barra superior de progreso",
        "hidesearchongoogle": "Hide Search on Google",
        "hidesearchonlinkedin": "Hide Search on LinkedIn",
        "appshidedocusign": "Ocultar DocuSign",
        "enableautosyncalwayson": "Chat Sync - Activa por defecto",
        "appshideall": "Ocultar directorio de aplicaciones",
        "appshideallvideoapps": "Ocultar todas las aplicaciones de vídeo",
        "allowuserstograntsupportaccess": "Allow users to grant support access",
        "appshidezoom": "Ocultar Zoom",
        "serverlocation": "Server Location",
        "hideedittemplatesbuttons": "Plantillas dinámicas - Ocultar edición",
        "hidenewtemplatebutton": "Plantillas dinámicas - Ocultar Crear",
        "sendalertsuserloggedout": "Send Alerts - USER_LOGGED_OUT",
        "sendalertsuseruninstalledextension": "Send Alerts - USER_UNINSTALLED_EXTENSION",
        "sentalertsuserturnedautosyncoff": "Send Alerts - USER_TURNED_AUTO_SYNC_OFF",
        "sentalertsuserturnedautosyncon": "Sent Alerts - USER_TURNED_AUTO_SYNC_ON",
        "sentalertsapicurrentlydisabled": "Send Alerts - API_CURRENTLY_DISABLED",
        "sentalertsapexrestservicesdisabled": "Send Alerts - APEX_REST_SERVICES_DISABLED",
        "fileuploadshidecompletely": "File Uploads to CRM - Hide Option Completely",
        "hideaccountbox": "Contactos - Ocultar cuadro de Cuenta",
        "hidetemplatesbutton": "Plantillas dinámicas - Ocultar",
        "multichannellimitchannels": "Límite de canales múltiples",
        "hidenavigatetoaddress": "Hide Navigate to Address",
        "hidesearchonfacebook": "Hide Search on Facebook",
        "hidecallbutton": "Hide Call button",
        "auto_sync_groups_default": "Grupos - Sincronización automática siempre activada",
        "hide_whatsapp_filters": "Hide WhatsApp Filters",
        "block_unknown_person_per_role": "Bloquear persona desconocida por rol",
        "allow_inviting_users": "Permitir invitar a usuarios",
        "show_chat_now_action": "Habla ahora - Habilitar",
        "auto_sync_activities__enabled": "Sincronización automática de Actividades - Habilitar",
        "auto_sync_activities__show_run_now_button": "Sincronización automática de Actividades - Mostrar el botón \"Ejecutar ahora\"",
        "auto_sync_activities__task_completed_status": "Sincronización automática de Actividades  - Cambiar estado",
        "auto_sync_activities__task_subject": "Sincronización automática de Actividades - Asunto",
        "show_auto_sync_button_per_profile": "Show Auto Sync Button Per Profile",
        "show_edit_layout_per_profile": "Show Edit Layout Per Profile",
        "show_chat_summarize_action": "AI - Show Chat Summarize Action",
        "enable_widget_ai_assistant": "Habilitar el asistente de IA del widget",
        "create_case_opportunity_field_name": "Casos - Oportunidad relacionada",
        "allow_edit_layout_drag_and_drop": "Allow edit layout drag and drop",
        "show_admin_notifications_tab": "Mostrar pestaña de notificaciones de administrador",
        "disable_save_as_at_desktop": "Restringir la descarga de archivos",
        "allow_desktop_lite": "Desktop Lite",
        "allow_mobile_call_recording": "Allow mobile call recordings",
        "block_whatsapp_calls": "WhatsApp - Bloquea llamadas en Android",
        "delete_crm_session_on_logout_in_desktop": "Otros - Eliminar sesión de CRM al cerrar sesión",
        "layout_limits_case": "Límite de campos - Caso",
        "layout_limits_lead": "Límite de campos - Prospecto",
        "layout_limits_contact": "Límite de campos - Contacto",
        "layout_limits_task": "Límite de campos - Tarea",
        "layout_limits_activity": "Límite de campos - Actividad",
        "layout_limits_account": "Límite de campos - Cuenta",
        "layout_limits_person_account": "Límite de campos - Cuenta personal",
        "layout_limits_event": "Límite de campos - Evento",
        "layout_limits_opportunity": "Layout Limits - Opportunity",
        "layout_limits__new_activity": "Límite de campos - Nueva Actividad",
        "layout_limits__new_case": "Límite de campos - Nuevo Caso",
        "set_whatid__accountid__new_task_and_activity": "Otros - Establecer AccountId como WhatId",
        "allow_platform_integrations": "Integraciones",
        "layout_limits__new_event": "Límite de campos - Nuevo Evento",
        "layoutlimitsnewopportunity": "Layout Limits - New Opportunity",
        "layout_limits__new_person_account": "Límite de campos - Nueva Cuenta personal",
        "opps__display__per_profile": "Opps - Display - Per Profile",
        "enable_auto_sync__always_on__per_profile": "Enable Auto-Sync - Always On - Per Profile",
        "contacts__create__per_profile": "Contacts - Create - Per Profile",
        "enable_groups_auto_sync__always_on__per_profile": "Enable Groups Auto-Sync - Always On - Per Profile",
        "leads__display__per_profile": "Leads - Display - Per Profile",
        "leads__create__per_profile": "Leads - Create - Per Profile",
        "contacts__display__per_profile": "Contacts - Display - Per Profile",
        "activities__display__per_profile": "Activities - Display - Per Profile",
        "activities__create__per_profile": "Activities - Create - Per Profile",
        "create_person_account__per_profile": "Create Person Account - Per Profile",
        "tasks__display__per_profile": "Tasks - Display - Per Profile",
        "tasks__create__per_profile": "Tasks - Create - Per Profile",
        "cases__create__per_profile": "Cases - Create - Per Profile",
        "cases__display__per_profile": "Cases - Display - Per Profile",
        "show_person_account__per_profile": "Show Person Account - Per Profile",
        "auto_sync_files__allow_message_types": "Archivos - Tipos de mensajes de sincronización automática",
        "auto_sync_files__allow_media_mime_types": "Archivos - Sincronización automática de tipos MIME",
        "auto_sync_files__ignore_media_file_message_if_not_pass_validation": "Archivos - No sincronizar si no pasa la validación",
        "use_new_message_sync_code": "Use New Message Sync Code",
        "ignore_chat_now_logic": "Ignore Chat Now Logic",
        "auto_sync_message_updates": "Sincronización para actualizaciones de mensajes",
        "auto_sync_message_on_status_change": "Sincronización al cambiar de estado de mensajes",
        "default_notifications_over_due_only": "Default Notifications Over Due Only",
        "prefix_phone_number_to_remove": "Otros - Eliminar prefijo de número de teléfono",
        "chat_now_modal_no_contact": "Chat Now Modal No Contact",
        "allow_platform_settings": "Allow Platform Settings",
        "allow_create_support_case": "Allow Create Support Case",
        "blur_contact_on_block_unknown_person": "Difumar mensajes de persona desconocida",
        "allow_platform_global_layout": "Layout global",
        "allow_platform_admin_notifications": "Notificaciones al administrador",
        "show_chat_now_action_per_profile": "Show Chat Now Action Per Profile",
        "show_add_to_phone_action_per_profile": "Show Add To Phone Action Per Profile",
        "show_new_event_action_per_profile": "Show New Event Action Per Profile",
        "show_calendar_per_profile": "Show Calendar Per Profile",
        "extra_search_account_name_field": "Contactos - Buscar cuenta por campo adicional",
        "auto_sync_activities__limit_to_profile": "Sincronización automática de Actividades - Limitar al perfil",
        "allow_link_unknown_person": "Contactos - Permitir enlace a persona desconocida",
        "access_audit_log": "Registros de auditoría",
        "auto_sync_activities__hide_message_content": "Sincronización automática de Actividades - Ocultar el contenido del mensaje",
        "force_saml_login": "Force SAML Login",
        "elite_security_token__user_agent_header": "Token de seguridad Elite - Encabezado del agente de usuario",
        "layoutlimitsnewtask": "Límite de campos - Nueva Tarea",
        "layoutlimitsnewaccount": "Límite de campos - Nueva Cuenta",
        "layoutlimitsnewcontact": "Límite de campos - Nuevo Contacto",
        "layoutlimitsnewlead": "Límite de campos - Nuevo prospect",
        "hidesaveasmobilecontact": "Hide Save as Mobile Contact",
        "appshidemsoutlook": "Ocultar MS Outlook",
        "showselectivechatsync": "Mostrar sincronización de chat selectiva",
        "sendalertsnewusercreated": "Send Alerts - NEW_USER_CREATED",
        "hidesendemail": "Hide Send Email",
        "hidescheduleeventsaction": "Hide Schedule Events Action",
        "hidecalendar": "Hide Calendar",
        "sendalertsuserloggedin": "Send Alerts - USER_LOGGED_IN",
        "hideglobalsearch": "Ocultar la búsqueda global",
        "hidecrmlinks": "Otros - Ocultar enlaces de CRM",
        "oppsdisplay": "Oportunidades - Visualizar",
        "showwhatsllytask": "Show Whatslly Task",
        "showwhatsllytasksicon": "Show Whatslly Tasks Icon",
        "showblurmode": "Difumar todos los mensajes",
        "ignoreaddleadsourcecreatecontact": "Contactos - Ignorar \"Añadir LeadSource\"",
        "ignoreaddleadsourcecreatelead": "Prospectos - Ignorar \"Añadir LeadSourde\"",
        "trackanalytics": "Dashboard - Permitir análisis",
        "contactoppsdisplay": "Contactos - Mostrar oportunidades de contactos",
        "hide_create_business_account": "Cuentas - Ocultar creaccion",
        "search_business_account__name_field": "Cuentas - Buscar",
        "status_bar__allow_change_opp_stage": "Oportunidades - Permitir etapa de cambio en la barra de estado",
        "hide_mark_task_as_completed": "Tareas - Ocultar marcar como completada",
        "new_lead__phone_field": "Prospectos - Anular campo de teléfono",
        "new_contact__phone_field": "Contactos - Cambiar campo de teléfono",
        "never_blocklist_users": "Never Blocklist Users",
        "allow_to_sync_group": "Grupos: permite sincronizar grupos.",
        "sent_alerts__user_turned_group_auto_sync_on": "Sent Alerts - USER_TURNED_GROUP_AUTO_SYNC_ON",
        "sent_alerts__user_turned_group_auto_sync_off": "Sent Alerts - USER_TURNED_GROUP_AUTO_SYNC_OFF",
        "new_lead__phone_field_prefix": "Prospectos - Crear con prefijo telefónico personalizado",
        "new_contact__phone_field_prefix": "Contactos - Crear con prefijo telefónico personalizado",
        "block_browser_extension": "Bloquear la Extensión Tuvis para navegador",
        "elite_security_token": "Token de seguridad Elite",
        "show_favorite_templates": "Show Favorite Templates",
        "block_unknown_person": "Bloquear persona desconocida",
        "block_groups_with_unknown_contacts": "Bloquear grupos con contactos desconocidos",
        "enable_dependent_picklist": "Enable Dependent Picklist",
        "disable_generate_reminder_params": "Otros - Deshabilitar la fecha de la actividad/tarea y la fecha del recordatorio",
        "allow_only_invited_users": "Permitir solo usuarios invitados",
        "limit_sf_open_url": "Otros - Bloquear URL que no sean de Salesforce",
        "limit_open_external_url": "Restricción de enlaces externos",
        "show_person_account": "Cuenta personal - Visualizar",
        "create_person_account": "Cuenta personal - Crear",
        "limit_login_via_sf_mobile_phone": "Validación telefónica de CRM/SSO",
        "block_change_profile_image": "Block Change Profile Image",
        "sidecars_enabled": "Remote Sync - Habilitar",
        "inviter_name": "Nombre del Invitador",
        "max_sidecars": "Cantidad máxima de dispositivos sidecar",
        "max_devices_whatsapp": "WhatsApp - Máximo de dispositivos",
        "max_devices_telegram": "Telegram - Máximo de dispositivos",
        "max_devices_line": "Line - Dispositivos máximos",
        "max_devices_signal": "Signal - Máximo de dispositivos",
        "default_sidecar_frequency": "Remote Sync - Frecuencia",
        "show_im_groups_ui": "Grupos de WhatsApp - meta datos",
        "show_analytics_ui": "Dashboard - Conversaciones",
        "show_dashboards_ui": "Vista Personalizada en Desktop",
        "show_custom_filters_ui": "Mostrar filtros personalizados",
        "use_sf_mega_describe": "Use SF Mega Describe",
        "custom_error_failed_to_query": "Otros - Error personalizado: No se pudo realizar la consulta",
        "show_record_type_layout": "Otros - Mostrar menú de tipo de registro",
        "auto_sync_to_duplicate_records": "Sincronización con registros duplicados",
        "multi_channel_limit_channels_per_profile": "Multi-Channel Limit Channels Per Profile",
        "block_unknown_person_per_profile": "Block Unknown Person Per Profile",
        "hide_all_create_actions_per_profile": "Hide All Create Actions Per Profile",
        "show_global_search_per_profile": "Show Global Search Per Profile",
        "enable_record_types_pick_list": "Otros - Habilitar lista de selección de tipos de registros",
        "enable_create_entities_to_not_focused_contact": "Otros - Crear tareas/actividades para un registro no pre-seleccionado.",
        "show_saml_settings": "Configuración SAML",
        "filter_analytics_by_profile": "Dashboard - Filtrar por perfil",
        "show_chat_groups_ui": "Show Chat Groups UI",
        "global_layout_per_profile": "Global Layout Per Profile",
        "return_selective_to_prev": "Chat Sync - Regresar desde \"selectivo'' al estado anterior",
        "business_account__create": "Cuentas - Crear",
        "disable_retroactive_synchronization": "Deshabilitar la sincronización retroactiva",
        "syncronizeLastDays": "Sincronizar los mensajes de los últimos días",
        "scroll_to_earliest_message": "Desplazar hasta el mensaje más antiguo",
        "contact__allow_add_to_campaign_button": "Contact - Allow Add to Campaign Button",
        "disable_contact_require_account": "Contactos - Deshabilitar cuenta obligatoria",
        "edit_lead": "Prospectos - Editar",
        "edit_contact": "Contactos - Editar",
        "edit_task": "Tareas - Editar",
        "edit_activity": "Actividades - Editar",
        "edit_case": "Casos - Editar",
        "edit_person_account": "Cuenta personal - Editar",
        "edit_business_account": "Cuentas - Editar",
        "edit_opportunity": "Oportunidades - Editar",
        "show_create_account_under_create_contact": "Contactos - Crear contacto con cuenta",
        "show_create_account_under_edit_contact": "Contactos - Mostrar Crear cuenta",
        "hideEditLayout": "Hide Edit Layout",
        "notificationRecipients": "Notification Recipients",
        "enabledNotifications": "Enabled Notifications",
        "use_only_wap_special_link": "Habla ahora - Usa el enlace estándar de WhatsApp",
        "query_cache_ttl": "Cache Query results TTL",
        "allow_dlp": "DLP - Habilitar",
        "enable_surveillance": "Surveillance",
        "allow_dlp_ai": "DLP con IA",
        "dlp_audio": "DLP con audio",
        "allow_waba": "WhatsApp Business API",
        "allow_messages_analytics": "Conversaciones en la plataforma",
        "allow_twilio": "Grabación de llamadas - Habilitar",
        "allow_imessage": "iMessage",
        "allow_telegram": "Telegram - Habilitar escritorio",
        "hide_telegram_channel": "Ocultar canal de Telegram",
        "new_agent_mode": "Modo de agente",
        "hide_widget_close_button": "Hide Widget Close Button",
        "hide_forward_button": "Hide WhatsApp forward message button",
        "hide_bulk_messages": "Hide bulk messages button",
        "block_extension_sidebar_in_desktop": "CRM solo para credenciales de login",
        "defaultLanguage": "Default Language for new users",
        "allow_embedded_signup_with_partner": "WhatsApp Business API vía Smarters",
        "hide_intro_video": "Hide Intro Video",
        "wa_custom_notification_sound__enabled": "Allow Custom WhatsApp Notification Sound",
        "default_favorite_actions": "Acciones favoritas predeterminadas",
        "use_apex_upload_files": "Otros - Utilizar el archivo de carga de SF Apex",
        "periodicAutoSync": "Sincronizar periódicamente todos los mensajes",
        "periodicAutoSyncInterval": "Sincronizar periódicamente todos los mensajes",
        "periodicGroupSync": "Grupos - Sincronizar los metadatos de los grupos",
        "periodicGroupSyncInterval": "Grupos - Sincronizar los metadatos de los grupos (intervalo)",
        "allow_customer_facing_settings": "Configuración de cara al cliente",
        "allow_public_api": "API pública de Tuvis",
        "created_entities_title_prefix": "Otros - Crear entidades con prefijo de título",
        "force_user_phone": "Validación de la plataforma telefónica",
        "desktop_add_paired_phone_on_login": "Agregar teléfono vinculado al iniciar sesión",
        "max_paired_phones_on_login": "Máximo de teléfonos emparejados",
        "replace_phone_on_limit_exceeded": "Reemplazar el teléfono si se supera el límite.",
        "enable_limit_number_of_contacts_engaged": "Habilitar un límite de contactos por día",
        "limit_number_of_contacts_engaged": "Límite de contactos activos por día",
        "enable_limit_number_of_msgs_to_unresponsive_contact": "Habilitar un límite de mensajes para contactos que no responden",
        "limit_number_of_msgs_to_unresponsive_contact": "Límite de mensajes para contactos que no responden",
        "hide_logout": "Ocultar el botón de cerrar sesión",
        "hide_edit_user": "Ocultar botón de edición de usuario en el menú de usuario",
        "desktopForceNewTab": "Forzar nueva pestaña para enlaces",
        "fraud_detection": "Detección de fraude - Habilitar",
        "allow_keyword_insights": "Rastreador de palabras clave",
        "allow_keyword_insights_report_message_content": "Rastreador de palabras clave - Mostrar el contenido del mensaje.",
        "allow_user_analytics": "Paneles de control - Análisis de usuarios",
        "analytics_compliance": "Dashboard - Compliance",
        "enable_call_recording_disclaimer": "Grabación de llamadas - Aviso legal",
        "allow_phones_whitelist": "Lista de teléfonos permitidos",
        "allow_phones_blocklist": "Lista de teléfonos privados",
        "allow_blocked_phones": "Bloquear teléfonos (chat)",
        "blocked_phones_create_incidents": "Bloquear teléfonos (incidentes)",
        "allow_tuvis_contacts": "Contactos de Tuvis",
        "custom_user_fields": "campos personalizados del perfil de usuario",
        "collect_messages_group_participants": "Recopilar datos de los participantes de grupos",
        "disable_opportunities_default_layout_field_for_entities": "Otros - Ocultar oportunidad relacionada",
        "dlp_show_false_positive_incidents": "DLP Incidentes - Muestra falsos positivos",
        "dlp_notify_email_on_false_positive": "DLP Incidentes -  Notificar por correo electrónico en caso de falso positivo.",
        "query_cache_ttl_per_user": "TTL de caché de consulta por usuario",
        "allow_whatsapp_channels": "WhatsApp Canales - Sincronizar mensajes",
        "sidecar_ebs_size_in_gb": "Remote Sync - Tamaño total",
        "incidents_filter_matched_keyword_campaigns_default_value": "DLP - Ocultar incidentes que coincidan con palabras clave",
        "sidecar_ebs_size_in_gb_per_user": "Remote Sync - Tamaño por usuario",
        "collect_whatsapp_status_messages": "WhatsApp - Mensajes de estado",
        "block_copy_paste": "Bloquear copiar y pegar en la aplicación de Tuvis",
        "salesforce_use_browser": "Otros - Abra la autenticación de Salesforce en el navegador estandár",
        "sidecar_snapshot_keep_count": "Remote Sync - Cantidade de snapshots",
        "sidecar_snapshot_ttl_days": "Remote Sync - Días de snapshot",
        "remote_sync_custom_error_text": "Mensaje de error personalizado de Remote Sync",
        "restrict_to_direct_reports": "Restringir el alcance de los datos a los informes directos.",
        "restrict_to_direct_reports_bypass_list": "Restringir a los subordinados directos - Lista de excepcion",
        "view_only_own_messages": "Ver solo tus propios mensajes",
        "enable_hybrid_analysis_scan_url": "Detección de fraude - Hybrid Analysis",
        "fraud_detection_create_incidents": "Crear incidentes de detección de fraude",
        "fraud_detection_incident_email_recipients": "Destinatarios de correo de incidentes de fraude",
        "allow_slack_platform": "WhatsApp Business API con Slack",
        "allow_teams_platform": "WhatsApp Business API con MS Teams",
        "allow_archive": "Habilitar archivo",
        "allow_teams_archive": "Habilitar archivado de Teams",
        "disable_internal_messages_sync": "Deshabilitar la sincronización de mensajes internos",
        "activitieshideuserassignmentfield": "Actividades - Ocultar usuario asignado",
        "auto_sync_cases_case_subject": "Sincronización automática de Casos - Asunto",
        "auto_sync_cases_case_completed_status": "Sincronización automática de Casos - Cambiar el estado completado",
        "auto_sync_cases_enabled": "Sincronización automática de Casos - Habilitar",
        "auto_sync_cases_hide_message_content": "Sincronización automática de Casos - Ocultar el contenido del mensaje",
        "auto_sync_cases_limit_to_profile": "Sincronización automática de Casos - Límite a perfil",
        "auto_sync_cases_show_run_now_button": "Sincronización automática de Casos - Mostrar el botón \"Ejecutar ahora\"",
        "find_account_record_types": "Contactos - Buscar cuentas relacionadas con un tipo de registro",
        "load_record_type_on_find_account": "Otros - Cargar cuentas relacionadas con un tipo de registro",
        "taskshideuserassignmentfield": "Tareas - Ocultar \"asignar al usuario\"",
        "line_sidecars_enabled": "Line - Habilitar sincronización remota",
        "signal_sidecars_enabled": "Signal - Habilitar Remote Sync",
        "telegram_sidecars_enabled": "Telegram - Habilitar sincronización remota",
        "whatsapp_sidecars_enabled": "WhatsApp - Habilitar sincronización remota",
        "allow_audio_transcribes": "Permitir transcripción de audio",
        "track_filter_analytics": "Dashboard -  Status de Conversaciones",
        "analytics_filter_show_related_to_me": "Dashboard -  Mostrar solo datos relacionados conmigo",
        "enable_whatsapp_voice_video": "WhatsApp - Habilita las llamadas en tu ordenador",
        "sync_whatsapp_voice_video": "WhatsApp - Sincronización de voz/vídeo",
        "phishing_fraud_detection": "Detección de fraude - URLs de phishing",
        "enable_virustotal_scan_url": "Detección de fraude - VirusTotal",
        "allow_url_policy": "Políticas de escritorio - Habilitar",
        "allow_tuvis_browser": "Tuvis Browser - Habilitar",
        "allow_bot_builder": "Permitir el creador de bots",
        "hide_meta_ai_button_in_desktop": "Oculta el botón 'Meta AI' de WhatsApp",
        "activeUsersCount": "Número de usuarios activos (30 días)",
        "show_email_attachment": "Adjunto de correo",
        "multiple_records_extra_fields": "Otros: campos adicionales para registros",
        "show_default_auto_sync_config": "Mostrar la configuración predeterminada de sincronización automática",
        "fraud_detection_mode": "Modo de detección de fraude",
        "sidecar_invite_from_address": "Sincronización remota: dirección de correo",
        "sidecar_invite_from_name": "Sincronización remota: nombre de la invitación"
      },
      "options": {
        "default_sidecar_frequency": {
          "0 * * * *": "Every hour",
          "0 */3 * * *": "Every 3 hours",
          "0 */6 * * *": "Every 6 hours",
          "0 */12 * * *": "Every 12 hours",
          "permanent": "Permanent"
        },
        "default_favorite_actions": {
          "view": "Ver",
          "call": "Llamar",
          "meeting": "Reunión",
          "messenger": "Mensajero",
          "email": "Correo electrónico",
          "navigate": "Navegar",
          "refresh": "Actualizar",
          "facebook": "Facebook",
          "linkedin": "Linkedin",
          "google": "Google",
          "find": "Encontrar",
          "addToPhone": "Agregar al teléfono",
          "createCustomObject": "Crear objeto personalizado",
          "createCase": "Crear caso",
          "createTask": "Crear tarea",
          "createActivity": "Crear actividad",
          "createLead": "Crear líder",
          "createContact": "Crear contacto",
          "createPersonAccount": "Crear cuenta personal",
          "chatNow": "Chatear ahora",
          "showChatSummarizeAction": "Mostrar acción de resumen de chat",
          "createBusinessAccount": "Crear cuenta empresarial",
          "showAiChat": "Chat con VIS"
        },
        "showselectivechatsync": {
          "Hide": "Ocultar",
          "Enabled": "Habilitado",
          "Disabled": "Deshabilitado",
          "Enable_Without_Auto": "Habilitar sin la opción de sincronización automática"
        }
      },
      "help_text": {
        "show_only_wap_channels_in_desktop": "Oculta todas las pestañas excepto los canales de WhatsApp y evita que el usuario cambie a otras pestañas",
        "periodicAutoSyncInterval": "Sincroniza automáticamente todos los mensajes cada X milisegundos (1000 ms = 1 segundo). El valor predeterminado es 86400000 ms (24 horas).",
        "periodicGroupSyncInterval": "Sincroniza automáticamente los metadatos de todos los grupos cada X milisegundos (1000 ms = 1 segundo). El valor predeterminado es 3600000 ms (1 hora).",
        "limit_date_range_of_messages": "Limita el historial de mensajes a los últimos X meses. Los usuarios solo verán los mensajes dentro de este período.",
        "phones_blocked_from_sync": "Números de teléfono separados por comas",
        "force_user_phone": "Restringe el inicio de sesión en WhatsApp en función del número de teléfono específico definido en la página de gestión de usuarios de Tuvis.",
        "desktop_add_paired_phone_on_login": "Al iniciar sesión, guarda automáticamente el número de WhatsApp asociado al usuario en el campo Teléfono de su perfil de usuario.",
        "max_paired_phones_on_login": "Número máximo de cuentas únicas de WhatsApp que un solo usuario puede vincular.",
        "replace_phone_on_limit_exceeded": "Una vez superado el límite de dispositivos, reemplaza automáticamente el teléfono emparejado más antiguo por el más reciente.",
        "leadsdisplay": "Mostrar el objeto principal predeterminado en el panel",
        "contactsdisplay": "Mostrar el objeto Contactos predeterminado en el panel",
        "casesdisplay": "Mostrar el objeto de caso predeterminado en el panel",
        "activitiesdisplay": "Mostrar el objeto Actividades predeterminado en el panel",
        "autosynclimittomaxfilesize": "Cambiar el tamaño máximo de carga para la sincronización automática. Nota: Salesforce no admite más de 4,4 MB.",
        "tasksdisplay": "Mostrar el objeto Tareas predeterminado en el panel",
        "hidesearchongoogle": "Hide \"Search on Google\" action from panel",
        "hidesearchonlinkedin": "Hide \"Search on Linkedin\" action in panel",
        "fileuploadshidecompletely": "Hide upload file from create task/activity/case page",
        "hidesearchonfacebook": "Hide \"Search on Facebook\" action in panel",
        "hidecallbutton": "Hide \"Call\" action button from actions panel",
        "allow_inviting_users": "Permitir el envío de invitaciones a nuevos usuarios y la asignación de permisos y licencias a través de la página de Gestión de usuarios.",
        "show_chat_now_action": "Mostrar Habla ahora en el panel Acciones",
        "auto_sync_activities__enabled": "Habilitar \"Actividades de sincronización automática\" en Salesforce",
        "auto_sync_activities__show_run_now_button": "Mostrar el botón \"Ejecutar ahora\" en la pestaña \"Actividades de sincronización automática\"",
        "auto_sync_activities__task_completed_status": "De forma predeterminada, la tarea creada con Sincronización automática de actividades tiene el estado \"Completada\". Defina otro estado a continuación:",
        "auto_sync_activities__task_subject": "Define el tema de las actividades creadas automáticamente mediante la sincronización de conversaciones. Por defecto, usamos \"Tuvis Chat\" para diferenciarlas de las creadas manualmente.",
        "show_chat_summarize_action": "Show the \"Chat Summarize\" action in the panel",
        "enable_widget_ai_assistant": "Habilita la acción del Asistente de IA en el panel.",
        "create_case_opportunity_field_name": "Agregue un campo de selección \"Oportunidad relacionada\" en la página de creación de caso. Es necesario definir el nombre del campo de la API de CRM.",
        "allow_edit_layout_drag_and_drop": "Allow to change edit layout field order by drag and drop",
        "show_admin_notifications_tab": "Mostrar la pestaña de notificaciones de administrador en la pestaña de configuración de Salesforce Tuvis",
        "allow_desktop_lite": "Permite una versión ligera de Tuvis Desktop para organizaciones que no requieren integraciones con CRM ni el panel lateral.",
        "delete_crm_session_on_logout_in_desktop": "Si la opción está activada, todas las sesiones de CRM se eliminan al cerrar la sesión del usuario. Si la opción está desactivada, todas las sesiones de CRM se compartirán entre sesiones.",
        "layout_limits_case": "Cambiar el número máximo de campos para cada caso",
        "layout_limits_lead": "Cambiar el número máximo de campos para clientes potenciales (Leads)",
        "layout_limits_contact": "Cambiar el número máximo de campos para el contacto",
        "layout_limits_task": "Cambiar el número máximo de campos para la tarea",
        "layout_limits_activity": "Cambiar el número máximo de campos para la actividad",
        "layout_limits_account": "Cambiar el número máximo de campos para la cuenta",
        "layout_limits_person_account": "Cambiar el número máximo de campos para una cuenta personal (solo Salesforce)",
        "layout_limits_event": "Cambiar el número máximo de campos para el evento",
        "layout_limits_opportunity": "Change maximum number of fields for opportunity",
        "layout_limits__new_activity": "Cambiar el número máximo de campos para la nueva actividad",
        "layout_limits__new_case": "Cambiar el número máximo de campos para un nuevo caso",
        "set_whatid__accountid__new_task_and_activity": "Al crear una tarea/actividad, por defecto, permitimos seleccionar una oportunidad y guardarla en el campo WhatId. Con esta opción, usamos el AccountId para este campo WhatId.",
        "allow_platform_integrations": "Activa la página de Integraciones de la plataforma para ver y administrar los servicios conectados.",
        "layout_limits__new_event": "Cambiar el número máximo de campos para un nuevo evento",
        "layoutlimitsnewopportunity": "Change maximum number of fields for new opportunity",
        "layout_limits__new_person_account": "Cambiar el número máximo de campos para una nueva cuenta personal",
        "auto_sync_files__allow_message_types": "Limita la sincronización de archivos a tipos de medios específicos. Si utilizas más de un tipo, sepáralos con un punto y coma.\nEj.: image; document\n\nTipos: sticker, video, image, document",
        "auto_sync_files__allow_media_mime_types": "Limita la sincronización de archivos a tipos MIME de medios específicos. Si utilizas más de un tipo, sepáralos con un punto y coma.\nEj.: audio/ogg;application/vnd.openxmlformats-officedocument.wordprocessingml.document;application/msword\n\nTipos MIME comunes: https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types",
        "auto_sync_files__ignore_media_file_message_if_not_pass_validation": "No sincronizar los mensajes con texto y multimedia si no podemos validar el archivo por tipo MIME o tipo de mensaje multimedia.",
        "ignore_chat_now_logic": "Ignore chat now logic and return phone number as is",
        "auto_sync_message_updates": "Esto hará que un mensaje que tenga actualizaciones (texto editado o eliminado) sincronice las actualizaciones nuevamente.",
        "auto_sync_message_on_status_change": "Sincronización automática de nuevos mensajes si cambia el estado del mensaje (enviado, leído).",
        "default_notifications_over_due_only": "Change default notifications filter to show over due only",
        "prefix_phone_number_to_remove": "Al crear una cuenta de cliente potencial/contacto/persona en el CRM, defina un prefijo de teléfono que debe eliminarse de la inserción automática (por ejemplo, eliminar el código de país 972, 55)",
        "chat_now_modal_no_contact": "Show chat now modal if the chat now number not found in WhatsApp contact list",
        "allow_platform_settings": "Allow access to instance to platform settings page",
        "allow_create_support_case": "Allow Create Support Case In JIra",
        "blur_contact_on_block_unknown_person": "Cuando la opción Bloquear persona desconocida está activada, la vista previa del mensaje en la lista de contactos se difumina automáticamente.",
        "block_groups_with_unknown_contacts": "Impide la interacción con grupos de WhatsApp si no se ha identificado a ningún miembro como registro existente en el CRM.",
        "allow_platform_global_layout": "Permitir que la instancia utilice el Layout global dentro de la plataforma Tuvis.",
        "allow_platform_admin_notifications": "Permite alertas y actualizaciones del sistema.",
        "extra_search_account_name_field": "Al crear un nuevo contacto, muestra información adicional en el menú desplegable \"Buscar cuenta\". Debes definir el nombre de la API del campo que quieres mostrar.",
        "auto_sync_activities__limit_to_profile": "La sincronización automática de actividades solo se aplicará a perfiles específicos.",
        "allow_link_unknown_person": "Si el whatsapp es desconocido se puede vincular a contacto o lead",
        "access_audit_log": "Muestra la página de registros de auditoría en la plataforma Tuvis",
        "auto_sync_activities__hide_message_content": "Ocultar el contenido del mensaje al crear actividades de sincronización automática",
        "force_saml_login": "Decline any login method besides SAML",
        "elite_security_token__user_agent_header": "Agregar token de élite al agente de usuario",
        "new_lead__phone_field": "Anular el campo Teléfono predeterminado en el nuevo diseño de cliente potencial. Formato: Nombre de API del campo, Etiqueta del campo (separados por coma). P. ej., Teléfono móvil, Teléfono móvil.",
        "new_contact__phone_field": "Al crear un contacto, el valor predeterminado es Teléfono. Con esta opción, puedes guardar WhatsApp en otro campo (por ejemplo, Teléfono móvil).",
        "block_browser_extension": "Bloquea la extensión Tuvis en el navagador común y permite usar Tuvis solo a través de la aplicación Desktop.",
        "elite_security_token": "Genera una cadena única de al menos 25 caracteres a través del sitio web https://1password.com/password-generator/ (sin símbolos especiales).",
        "limit_login_via_sf_mobile_phone": "Restringe el inicio de sesión de WhatsApp en función del número de teléfono almacenado en Salesforce (Mobile Phone) o en los atributos de Active Directory (Phone).",
        "sidecars_enabled": "Habilita la función de sincronización de aplicaciónes móviles.",
        "show_analytics_ui": "Mostrar la pestaña Conversación en la página de Dashboard de la plataforma.",
        "show_dashboards_ui": "Muestra la vista personalizada (informes y widgets creados en el CRM) en la página principal de Tuvis Desktop.",
        "show_custom_filters_ui": "Permitir que la instancia muestre Filtros personalizados (filtrar conversaciones por resultados de informes de Salesforce) en la plataforma y el escritorio",
        "show_im_groups_ui": "Recopila información de los grupos de WhatsApp, como los miembros y la configuración de las invitaciones.",
        "show_record_type_layout": "Mostrar el menú desplegable superior al crear un registro.",
        "enable_record_types_pick_list": "Habilitar la obtención de opciones de lista de selección según el tipo de registro seleccionado. Si es falso, la selección se deshabilita.",
        "enable_create_entities_to_not_focused_contact": "Al crear una tarea o actividad, el usuario debe seleccionar un contacto, prospecto o cuenta personal.",
        "show_saml_settings": "Activa la página de configuración de SSO para gestionar la autenticación de identidad basada en SAML.",
        "filter_analytics_by_profile": "Filtra los datos analíticos para mostrar solo a los usuarios con perfiles específicos de SF.",
        "show_chat_groups_ui": "Show Chat Groups UI",
        "global_layout_per_profile": "Allow to define global layout per profile",
        "return_selective_to_prev": "Si selecciona la opción \"Selectivo\" en lugar del estado \"Desactivado\", el estado de sincronización automática volverá al estado anterior al camiar de conversación.",
        "business_account__create": "Habilitar para crear una cuenta comercial",
        "disable_retroactive_synchronization": "Sincroniza únicamente los mensajes que se enviaron después de que el usuario se creara en Tuvis.",
        "syncronizeLastDays": "Los mensajes se sincronizarán si tienen una antigüedad máxima de X días (máx 90 días).",
        "scroll_to_earliest_message": "Desplácese hacia atrás para cargar todos los mensajes de la extensión de escritorio o del navegador de los últimos días configurados.",
        "contact__allow_add_to_campaign_button": "Show \"Add to Campaign\" button under contact object - SF only",
        "disable_contact_require_account": "Durante la creación del contacto, la selección de la cuenta no será obligatoria.",
        "edit_lead": "Habilitar la edición de clientes potenciales incluso sin la función \"Crear cliente potencial\"",
        "edit_contact": "Habilitar la edición de contactos incluso sin la función \"Crear contacto\"",
        "edit_task": "Habilitar la edición de tareas incluso sin la función \"Crear tarea\"",
        "edit_activity": "Habilitar la edición de actividad incluso sin la función \"Crear actividad\"",
        "edit_case": "Habilitar la edición de casos incluso sin la función \"Crear caso\"",
        "edit_person_account": "Habilitar la edición de la cuenta personal incluso sin la función \"Crear cuenta personal\"",
        "edit_business_account": "Habilitar la edición de la cuenta comercial, incluso sin la función \"Crear cuenta comercial\"",
        "edit_opportunity": "Enable to edit opportunity even without \"create opportunity\" feature",
        "show_create_account_under_edit_contact": "Al editar un contacto, habilite el menú desplegable para crear una cuenta",
        "hideEditLayout": "Hide Edit Layout",
        "notificationRecipients": "Insert email addresses (comma separated)",
        "enabledNotifications": "Insert email addresses (comma separated)",
        "allow_dlp_ai": "Permite el uso de IA para identificar información personal identificable y extraer datos adjuntos mediante OCR.",
        "dlp_audio": "Las políticas de protección contra pérdida de datos también se pueden aplicar a los audios enviados a través del escritorio (requiere integración).",
        "desktopForceNewTab": "Los enlaces dentro de la aplicación se abrirán automáticamente en una nueva pestaña dentro de la aplicación de Desktop de Tuvis.",
        "enable_call_recording_disclaimer": "Reproducir un aviso sobre la grabación de llamadas cuando se contesta una llamada saliente o cuando se marca una llamada entrante.",
        "custom_user_fields": "Permite añadir hasta cinco campos de texto personalizados en la sección de perfil de usuario, mediante valores separados por comas.",
        "collect_messages_group_participants": "Si esta opción está habilitada, se recopilarán los números de teléfono de los participantes del grupo para cada mensaje.",
        "disable_opportunities_default_layout_field_for_entities_description": "Deshabilita el campo \"Oportunidad relacionada\" en las páginas de creación de tareas, actividades y casos.\r\nEs necesario definir las entidades para las que deseas deshabilitar el campo",
        "dlp_show_false_positive_incidents": "Los incidentes de DLP de falso positivo se mostrarán en la lista de incidentes.",
        "dlp_notify_email_on_false_positive": "Enviar un correo electrónico a las direcciones de correo electrónico definidas en el campo de destinatarios de notificaciones cuando se cree un incidente DLP falso positivo.",
        "query_cache_ttl_per_user": "Si está habilitado, la caché de consulta se habilitará para el usuario",
        "allow_whatsapp_channels": "Si esta opción está habilitada, los usuarios comenzarán a sincronizar y ejecutar DLP en los canales de WhatsApp si la sincronización y DLP están habilitadas.",
        "new_agent_mode": "Una vez activados, los usuarios de esta organización tendrán acceso a agentes y colas en Tuvis Messaging.",
        "sidecar_ebs_size_in_gb": "Espacio total en GB de almacenamiento EBS disponible para sincronización remota.",
        "incidents_filter_matched_keyword_campaigns_default_value": "Si esta opción está habilitada, los incidentes de DLP que coincidan con las palabras clave se ocultarán de forma predeterminada.",
        "sidecar_ebs_size_in_gb_per_user": "Espacio de almacenamiento EBS disponible en GB para cada usuario durante la sincronización remota.",
        "collect_whatsapp_status_messages": "Recopilar los estados publicados por el usuario.",
        "block_copy_paste": "Cuando está habilitado, la copia y el pegado se bloquearán en la aplicación de Tuvis",
        "salesforce_use_browser": "Si se marca, la autenticación de Salesforce se abrirá en el navegador predeterminado del usuario en lugar de en la aplicación Tuvis. Esta configuración no afecta a los clientes web ni móviles.",
        "sidecar_snapshot_keep_count": "El número de copias de seguridad (snapshot) almacenadas para el proceso de sincronización remota para cada usuario.",
        "sidecar_snapshot_ttl_days": "El número de días que se conserva un snapshot antes de ser eliminada automáticamente.",
        "remote_sync_custom_error_text": "Si se define, este texto se muestra debajo del error estándar de Remote Sync (p. ej. Sincronización fallida) para dirigir a los usuarios a su contacto de cumplimiento o soporte (p. ej. correo o extensión).",
        "restrict_to_direct_reports": "Limita la visibilidad de los datos del usuario en la plataforma exclusivamente a la información de sus subordinados directos.",
        "restrict_to_direct_reports_bypass_list": "Define los usuarios exentos de la restricción de visibilidad de datos de los subordinados directos.",
        "view_only_own_messages": "Restringe a los usuarios la visualización únicamente de su propio historial de mensajes dentro de la plataforma.",
        "enable_hybrid_analysis_scan_url": "Analiza las URL utilizando la API de Hybrid Analysis para detectar malware y phishing.",
        "fraud_detection_create_incidents": "Cuando está habilitado, se crean incidentes automáticamente al detectar hashes o URLs maliciosas en los mensajes.",
        "fraud_detection_incident_email_recipients": "Seleccione los usuarios que deben recibir alertas por correo cuando se cree un incidente de detección de fraude.",
        "allow_slack_platform": "Permite integrar la aplicación Tuvis en los canales de Slack, lo que posibilita que la organización vincule un número de API de WhatsApp para una comunicación centralizada a través de Slack.",
        "allow_teams_platform": "Permite integrar la aplicación Tuvis en Microsoft Teams, lo que posibilita que la organización vincule un número de WhatsApp API para una comunicación centralizada a través de Teams.",
        "allow_archive": "Habilitar para permitir las funciones de archivado de mensajes",
        "allow_teams_archive": "Habilitar para permitir el archivado de Teams",
        "disable_internal_messages_sync": "Impide la sincronización de los mensajes enviados entre los miembros del equipo interno.",
        "activitiescreate": "Habilitar para crear actividades",
        "activitieshideuserassignmentfield": "Ocultar campo Propietario de la actividad (asignar al usuario)",
        "auto_sync_cases_case_subject": "Define el asunto de los casos creados automáticamente mediante la sincronización de conversaciones. Por defecto, usamos \"Tuvis Chat\" para diferenciarlos de los creados manualmente.",
        "auto_sync_cases_case_completed_status": "Cambiar el estado de la tarea predeterminada de completada a otro estado personalizado",
        "auto_sync_cases_enabled": "Permitir que los casos se creen automáticamente",
        "auto_sync_cases_hide_message_content": "Ocultar el contenido del mensaje al crear casos de sincronización automática",
        "auto_sync_cases_limit_to_profile": "Lista de nombres de perfil cuyos mensajes recopilamos únicamente para ellos. Por ejemplo: Administrador del sistema, Usuario de demostración, Prr.",
        "auto_sync_cases_show_run_now_button": "Mostrar el botón \"Ejecutar ahora\" en la pestaña \"Sincronización automática de casos\"",
        "hide_create_business_account": "Deshabilitar la creación de una cuenta empresarial",
        "search_business_account__name_field": "La búsqueda predeterminada es Nombre de cuenta, se pueden agregar otros campos a continuación",
        "casescreate": "Habilitar para crear casos",
        "contactscreate": "Habilitar para crear contactos",
        "show_create_account_under_create_contact": "Mostrar el menú desplegable para crear cuenta en la creación de contactos",
        "new_contact__phone_field_prefix": "Por defecto, copiamos el número de WhatsApp para crear un nuevo contacto en el CRM. Con esta opción, podemos añadir un prefijo (por ejemplo: +).",
        "contactoppsdisplay": "Mostrar oportunidades de contacto, además de las oportunidades de cuenta estándar.",
        "hideaccountbox": "Ocultar la tarjeta de cuenta del contacto",
        "ignoreaddleadsourcecreatecontact": "Por defecto, la fuente principal es \"WhatsApp Web\". Con esta opción, no se completa este campo.",
        "find_account_record_types": "Al crear un nuevo contacto, el campo Cuenta solo cargará cuentas que también estén relacionadas con un tipo de registro específico, por Id. o DeveloperName",
        "layoutlimitsnewaccount": "Cambiar el número máximo de campos para una nueva cuenta",
        "layoutlimitsnewcontact": "Cambiar el número máximo de campos para un nuevo contacto",
        "layoutlimitsnewlead": "Cambiar el número máximo de campos para un nuevo cliente potencial (Leads)",
        "layoutlimitsnewtask": "Cambiar el número máximo de campos para una nueva tarea",
        "leadscreate": "Habilitar para crear clientes potenciales",
        "new_lead__phone_field_prefix": "Por defecto, copiamos el número de WhatsApp para crear un nuevo cliente potencial en el CRM. Con esta opción, podemos añadir un prefijo (por ejemplo: +).",
        "hideleadprogresstopbar": "Ocultar la barra superior de progreso del cliente potencial",
        "ignoreaddleadsourcecreatelead": "Ignorar \"Agregar leadSource\" al crear un contacto",
        "status_bar__allow_change_opp_stage": "Permitir cambiar el estado en Opps",
        "oppsdisplay": "Mostrar el objeto de oportunidad predeterminado en el panel",
        "hideopportunitytopbar": "Ocultar la barra superior del progreso de la oportunidad",
        "limit_sf_open_url": "Al utilizar Tuvis Desktop, cualquier enlace que no sea Salesforce estará restringido",
        "created_entities_title_prefix": "Al crear un registro, el título comienza con [Tuvis]. El prefijo del título se puede cambiar con esta bandera.",
        "disable_generate_reminder_params": "No agregue los campos ReminderDateTime y IsReminderSet",
        "disable_opportunities_default_layout_field_for_entities": "Oculte el campo \"Oportunidad relacionada\" en las páginas de creación de tareas, actividades y casos. Seleccione las entidades para las que desea deshabilitar el campo.",
        "load_record_type_on_find_account": "Primero, el usuario elige el tipo de registro en el widget CRM y luego la búsqueda de cuentas solo cargará las cuentas según esa selección.",
        "use_apex_upload_files": "Al crear una tarea, actividad o caso, usamos la API oficial de Salesforce para adjuntar archivos de forma predeterminada. Si está habilitada, usaremos Tuvis Salesforce Apex.",
        "create_person_account": "Habilitar para crear una cuenta personal",
        "show_person_account": "Mostrar el objeto de cuenta personal predeterminado en el panel",
        "taskscreate": "Habilitar para crear tareas",
        "hide_mark_task_as_completed": "Evita que los usuarios marquen la tarea como completada",
        "taskshideuserassignmentfield": "Ocultar campo Propietario de la tarea (asignar al usuario)",
        "auto_sync_to_duplicate_records": "Sincroniza automáticamente el chat con todos los registros de CRM coincidentes si un contacto está asociado a varias entradas.",
        "enableautosyncalwayson": "Activa la sincronización automática de chat por defecto cada vez que se inicia una nueva conversación. Esta configuración se puede modificar si los controles de Modo de Chat Sync están visibles en el Desktop.",
        "enableautosynchidebutton": "Oculta los botones para activar y desactivar la sincronización automática de mensajes.",
        "enableautosyncfiles": "Permite la sincronización automática de los archivos del usuario, incluidos audios, documentos y otros archivos multimedia.",
        "allow_to_sync_group": "Permite la sincronización de chats grupales.",
        "auto_sync_groups_default": "Garantiza que la sincronización automática permanezca activa por defecto para los grupos y que los usuarios no puedan modificarla.",
        "showselectivechatsync": "El usuario puede elegir manualmente qué mensajes deben almacenarse en el CRM.",
        "block_unknown_person": "Restringe a los usuarios la posibilidad de enviar mensajes a cualquier contacto que no tenga un registro correspondiente en el CRM.",
        "block_unknown_person_per_role": "Restringe a los usuarios con roles específicos de Salesforce la posibilidad de enviar mensajes a cualquier contacto que no tenga un registro correspondiente en el CRM.",
        "showblurmode": "Difumina todo el contenido de los mensajes dentro de la interfaz de chat, mostrando el texto solo cuando el usuario coloca el cursor sobre el mensaje.",
        "enable_limit_number_of_msgs_to_unresponsive_contact": "Permite restringir la cantidad de mensajes que se pueden enviar a un contacto que no ha respondido.",
        "enable_limit_number_of_contacts_engaged": "Habilita un límite en la cantidad de contactos únicos con los que un usuario puede interactuar por día para evitar el spam.",
        "limit_open_external_url": "Impide que los usuarios abran URL externas directamente desde el Tuvis Desktop",
        "hideglobalsearch": "Elimina la barra de búsqueda global del panel superior para evitar que los usuarios busquen contactos de CRM.",
        "allow_keyword_insights_report_message_content": "En las apariciones de palabras clave, permita mostrar el mensaje original en los detalles.",
        "limit_number_of_contacts_engaged": "Establece el número máximo de contactos únicos con los que un usuario puede interactuar cada 24 horas.",
        "limit_number_of_msgs_to_unresponsive_contact": "Establezca el número máximo de mensajes salientes permitidos a un contacto antes de recibir una respuesta.",
        "disable_save_as_at_desktop": "Deshabilita la opción \"Guardar como\" para los archivos dentro de la plataforma para evitar que los usuarios los descarguen.",
        "allow_only_invited_users": "Los usuarios solo pueden iniciar sesión en Tuvis tras recibir una invitación. Debe configurarse como VERDADERO si se utiliza el mismo dominio de correo electrónico para el inicio de sesión único (SSO) en diferentes organizaciones.",
        "block_extension_sidebar_in_desktop": "Utiliza las credenciales de CRM únicamente para la autenticación, pero oculta el panel lateral de CRM en la aplicación Tuvis Desktop.",
        "hide_logout": "Elimina el botón de cerrar sesión del menú de usuario.",
        "allow_twilio": "Habilitar la grabación de llamadas a través de la aplicación Tuvis y exibir el dashboard correspondiente en la plataforma.",
        "exceededLicences": "Establece el máximo de usuarios, que puede coincidir con el número exacto de licencias adquiridas o incluir un margen adicional.",
        "paidLicences": "Licencias adquiridas por la organización. Por defecto, otorgamos un margen de gracia del 10 % por encima del límite de licencias.",
        "line_sidecars_enabled": "Habilitar la sincronización remota para Line. Nota: Line no tiene Desktop.",
        "max_devices_line": "Licencias de sincronización remota para Line.",
        "default_sidecar_frequency": "Frecuencia de sincronización de mensajes",
        "signal_sidecars_enabled": "Habilitar la sincronización remota para la aplicación móvil Signal.",
        "max_devices_signal": "Licencias adquiridas de sincronización remota para Signal",
        "allow_telegram": "Habilitar Telegram en Tuvis Desktop",
        "hide_telegram_channel": "Cuando está habilitado, oculta la opción del canal de Telegram en Tuvis Desktop.",
        "telegram_sidecars_enabled": "Habilitar la sincronización remota para la aplicación móvil de Telegram",
        "max_devices_telegram": "Licencias adquiridas de Remote Sync para Telegram",
        "whatsapp_sidecars_enabled": "Habilitar la sincronización remota para la aplicación móvil de WhatsApp",
        "max_devices_whatsapp": "Licencias de sincronización remota para WhatsApp.",
        "allow_waba": "Permitir la integración de la API de WhatsApp Business",
        "allow_embedded_signup_with_partner": "Habilitar el Embedded Signup (registro integrado) para conectar un número de WhatsApp API",
        "allow_audio_transcribes": "Requiere la integración con Audio Transcribe (Amazon o Azure).",
        "allow_messages_analytics": "Muestra la página de Conversación en el menú principal para supervisar los mensajes sincronizados y las grabaciones de llamadas.",
        "allow_customer_facing_settings": "Permite a los administradores de la organización gestionar configuraciones específicas de la plataforma.",
        "trackanalytics": "Permitir recopilar datos para mostrarlos en los Dashboards",
        "analytics_compliance": "Mostrar la pestaña Compliance en la página de Dashboard de la plataforma.",
        "track_filter_analytics": "Mostrar la pestaña Status de Conversaciones en el Dashboard de la plataforma Tuvis, que muestra el volumen de chats por estado (No leídos, Esperando respuesta y Necesitan respuesta) con frecuencia horaria.",
        "analytics_filter_show_related_to_me": "Restringe la visibilidad del panel únicamente a los subordinados directos del gerente, desactivando el acceso a datos de otros departamentos o usuarios.",
        "allow_user_analytics": "Mostrar la pestaña Análisis de usuarios en la página Dashboard de la plataforma",
        "allow_keyword_insights": "Habilita el Rastreador de palabras clave y muestra la pestaña Análisis de palabras clave en el Dashboard de la plataforma.",
        "multichannellimitchannels": "Limita el número máximo de canales que pueden conectar los usuarios.",
        "periodicAutoSync": "Programar la sincronización completa de todo el historial de conversaciones para los usuarios activos.",
        "allow_phones_whitelist": "Active un modo de monitorización restringido, en el que solo se sincronizan las conversaciones con números de teléfono añadidos específicamente a la lista blanca.",
        "allow_phones_blocklist": "Excluye números de teléfono específicos de todo el seguimiento y sincronización de la plataforma para garantizar la privacidad del usuario.",
        "allow_blocked_phones": "Bloquea la conversación en la extensión para números de teléfono específicos, mostrando una superposición de contacto bloqueado.",
        "blocked_phones_create_incidents": "Crea un incidente de fraude cuando un usuario envía un mensaje a un número de teléfono bloqueado, incluidos los mensajes enviados fuera de Tuvis. Requiere Bloquear teléfonos (chat).",
        "allow_public_api": "Permite a la organización conectarse e intercambiar datos con la API pública de Tuvis.",
        "allow_tuvis_contacts": "Permitir que Tuvis Contacts sea el CRM del cliente (solo SAML).",
        "block_whatsapp_calls": "Impide que los usuarios inicien o reciban llamadas de WhatsApp en la aplicación de Android.",
        "enable_whatsapp_voice_video": "Si está habilitada, la función de llamadas de voz y vídeo de WhatsApp solo estará disponible para conversaciones individuales (no para llamadas grupales) en un ordenador.",
        "sync_whatsapp_voice_video": "Si está habilitada, la sincronización de mensajes de voz y vídeo de WhatsApp se realizará a través del ordenador.",
        "periodicGroupSync": "Habilitar la sincronización periódica de metadatos para todos los grupos.",
        "allow_dlp": "Muestra la página de Data Loss Protection(Protección contra pérdida de datos) para los usuarios con los permisos adecuados para crear reglas de supervisión de seguridad.",
        "fraud_detection": "Consulta la página de Detección de Fraude en la plataforma Tuvis para identificar enlaces de phishing y hashes maliciosos en los archivos adjuntos.",
        "enable_virustotal_scan_url": "Habilitar la análisis de enlaces con VirusTotal",
        "allow_url_policy": "Active la página de Políticas de escritorio en la plataforma Tuvis para configurar las funciones aplicables a los canales, sitios gestionados y otros enlaces.",
        "allow_tuvis_browser": "Habilite la sección Tuvis Browser (Políticas de acceso + Controles del navegador) para esta organización.",
        "multiple_records_extra_fields": "Cuando el número de teléfono coincide con varios Leads, Contactos o Cuentas personales, indica los API_names de los campos adicionales que se mostrarán.",
        "use_only_wap_special_link": "Cuando se activa, el botón \"Chat now\" usará enlaces nativos de WhatsApp para iniciar la conversación en lugar del método estándar.",
        "default_favorite_actions": "Selecciona las acciones favoritas predeterminadas para los accesos rápidos del panel"
      }
    },
    "show_changed_configs": "Mostrar configuraciones cambiadas",
    "changes": "Cambios",
    "nav": {
      "system_notifications": "Notificaciones del sistema",
      "api_keys": "Claves API",
      "sso_settings": "Configuración SSO",
      "incidents_summary_email": "Correo de resumen de incidentes",
      "elite_token": "Token de Seguridad Elite"
    }
  },
  "user_page": {
    "remove_waba": "¿Estás seguro de que deseas eliminar el número de teléfono de WhatsApp Business API?",
    "remove_twilio": "¿Estás seguro de que deseas eliminar el número de teléfono de Twilio?",
    "assign_phone": "Agregar número de teléfono",
    "unassign_phone": "Eliminar número de teléfono",
    "assign_sidecar": "Agregar dispositivo",
    "unassign_sidecar": "Eliminar dispositivo",
    "choose_phone": "Elegir número de teléfono",
    "enabled": "Habilitado",
    "waba": "WhatsApp Business API (aplicación de escritorio)"
  },
  "incidents_summary_email": {
    "title": "Correo de resumen de incidentes",
    "discription_text": "Configure quién recibe los resúmenes por correo y sobre qué incidentes se notifica a cada destinatario.",
    "send_summary_to": "Enviar resumen a",
    "which_incidents": "¿Qué incidentes?",
    "scope_all": "Todos los incidentes de la plataforma",
    "scope_user": "Incidentes de un usuario específico",
    "scope_manager": "Incidentes de un manager específico",
    "for": "para",
    "select_user": "Seleccionar usuario",
    "select_manager": "Seleccionar manager",
    "add_recipient": "Agregar destinatario",
    "remove_row": "Eliminar destinatario",
    "saved_successfully": "La configuración del correo de resumen de incidentes se guardó correctamente",
    "saved_failed": "Error al guardar la configuración del correo de resumen de incidentes",
    "validation_email_required": "El correo es obligatorio para cada destinatario",
    "validation_reference_required": "Seleccione un usuario o manager para este destinatario",
    "loading": "Cargando...",
    "saveSettings": "Guardar configuración"
  },
  "incidents_page": {
    "change_assignee": "Cambiar Asignatario",
    "assignee": "Asignatario",
    "change_status": "Cambiar Estado",
    "select_status": "Seleccionar estado",
    "matched_keyword_campaigns": "Criterios de Palabras Clave"
  },
  "messages_analytics_page": {
    "title": "Conversaciones",
    "sent_date": "Fecha de envío",
    "type": "Tipo",
    "sender": "Remitente",
    "receiver": "Destinatario",
    "message": "Mensaje",
    "attachment": "Adjunto",
    "fileName": "Nombre de archivo",
    "fileType": "Tipo de archivo",
    "no_valid_integrations": "No se encontraron integraciones válidas (S3, Azure, SFTP, GCP)",
    "no_messages": "No se encontraron mensajes",
    "tabs": {
      "messages": "Mensajes",
      "calls": "Llamadas"
    },
    "edited": "Editado",
    "deleted": "Eliminado",
    "message_history": "Historial de mensajes"
  },
  "test_regex_modal": {
    "test_regex_modal_title": "Probar Expresión Regular",
    "test_regex_settings": "Ajustes de Expresión Regular",
    "test_regex_expression": "Expresión",
    "text_to_test_placeholder": "Texto para Probar",
    "test_button": "Probar",
    "not_case_sensitive": "No distingue entre mayúsculas y minúsculas",
    "failed_to_test_regex": "Error al probar la expresión regular"
  },
  "test_pii_modal": {
    "test_pii_modal_title": "Probar PII",
    "test_pii_settings": "Configuración de PII",
    "pii_category": "Categoría de PII",
    "text_to_test_placeholder": "Texto para Probar",
    "test_button": "Probar",
    "failed_to_test_pii": "Error al probar PII"
  },
  "test_rule_modal": {
    "failed_to_test": "Error al probar",
    "texts_to_test": "Textos para Probar",
    "test_metadata_title": "Probar Metadatos",
    "upload_file_to_test_metadata": "Sube un archivo y haz clic en Cargar para extraer sus metadatos",
    "load": "Cargar",
    "test_metadata_phase": "Probar la condición de metadatos con los metadatos extraídos arriba",
    "metadata_match": "Coincide",
    "metadata_no_match": "No coincide",
    "extracted_metadata": "Metadatos extraídos"
  },
  "account_admin": {
    "title": "Administración de Cuenta",
    "users_page": {
      "title": "Usuarios de la Cuenta",
      "toasts": {
        "invite_failed_user_exists": "El correo electrónico ya existe, reenviar invitación en su lugar"
      },
      "add_button": "Agregar Usuario",
      "assign_permissions_modal": {
        "button": "Asignar Permisos",
        "title": "Asignar Permisos de Usuario",
        "description": "Asignar permisos de organización para <1>{{name}}</1>.",
        "select_user": "Seleccionar Usuario",
        "search_users": "Buscar Usuarios",
        "permissions_for_in": "Permisos para <1>{{name}}</1> en <1>{{orgName}}</1>",
        "indication": {
          "own_org": "{{name}} es parte de esta organización",
          "has_permission": "{{name}} puede ver esta organización porque tiene al menos un permiso asignado"
        },
        "error_message": "No se pudieron asignar los permisos al usuario",
        "no_instance_configs": "No se encontraron configuraciones de instancia",
        "no_instance_configs_description": "No se encontraron configuraciones de instancia para esta organización. Por favor, contacte a su administrador."
      },
      "account_admin_modal": {
        "assign_title": "Asignar Administrador de Cuenta",
        "assign_description": "¿Está seguro que desea asignar a <1>{{name}}</1> como Administrador de Cuenta?",
        "assign_confirm": "Sí, asignar",
        "remove_title": "Eliminar Administrador de Cuenta",
        "remove_description": "¿Está seguro que desea eliminar a <1>{{name}}</1> como Administrador de Cuenta?",
        "remove_confirm": "Sí, eliminar",
        "error_message": "No se pudo cambiar el estado de administrador del usuario"
      },
      "cannot_change_own_admin": "No puede cambiar su propio estado de administrador",
      "is_account_admin": "Es Administrador de Cuenta",
      "invite_external_user_success": "Invitación enviada correctamente",
      "invite_external_user_error": "Error al enviar la invitación",
      "from_user": "De un usuario de la organización",
      "from_external": "De un usuario externo"
    },
    "overview_page": {
      "title": "Resumen de la Cuenta",
      "account_name": "Nombre de la Cuenta",
      "account_id": "ID de la Cuenta"
    },
    "no_access_overlay": {
      "title": "Ninguna Cuenta Seleccionada",
      "text": "Por favor, seleccione una cuenta del menú desplegable superior para ver esta página.",
      "button": "Volver"
    },
    "account_orgs": {
      "title": "Organizaciones de la Cuenta",
      "columns": {
        "registered_users": "Usuarios Registrados",
        "consumed_licences": "Licencias Consumidas"
      },
      "summary": {
        "purchased_licences": "Licencias Compradas"
      },
      "assign_orgs_modal": {
        "title": "Asignar Organizaciones",
        "description": "Seleccione las organizaciones que desea asignar a esta cuenta.",
        "trigger": "Asignar Organizaciones",
        "success_message": "Organizaciones asignadas a la cuenta",
        "error_message": "No se pudieron asignar las organizaciones a la cuenta"
      },
      "remove_org_modal": {
        "title": "Eliminar Organización de la Cuenta",
        "description": "¿Está seguro de que desea eliminar la organización de la cuenta?",
        "success_message": "Organización eliminada de la cuenta",
        "error_message": "No se pudo eliminar la organización de la cuenta",
        "trigger": "Desasignar"
      },
      "view_org": "Ver organización",
      "create_org": "Crear organización"
    }
  },
  "keyword_insights_occurrence": {
    "header": "Detalles de la ocurrencia"
  },
  "keyword_insights": {
    "title": "Rastreador de Palabras Clave",
    "dashboard_page": {
      "title": "Análisis de Keywords",
      "date_range": "Rango de Fechas",
      "kpis": {
        "active_agents": {
          "label": "Agentes Activos",
          "tooltip": "Número total de usuarios conectados"
        },
        "campaigns_created": {
          "label": "Criterios Creados",
          "tooltip": "Cuántos criterios diferentes se crearon"
        },
        "campaigns_sent": {
          "label": "Criterios Enviados",
          "tooltip": "Cuántos criterios diferentes se enviaron"
        },
        "reach": {
          "label": "Alcance",
          "tooltip": "Cuántos contactos recibieron al menos uno de los criterios"
        },
        "impressions": {
          "label": "Impresiones Totales",
          "tooltip": "Cuántos mensajes que contienen criterios fueron enviados. La misma persona puede recibir múltiples criterios o el mismo criterio más de una vez"
        },
        "avg_impressions_per_agent": {
          "label": "Promedio de Impresiones por Agente",
          "tooltip": "Impresiones Totales / Agentes Activos"
        },
        "avg_reach_per_agent": {
          "label": "Promedio de Alcance por Agente",
          "tooltip": "Alcance / Agentes Activos"
        },
        "avg_reach_per_sent_campaign": {
          "label": "Promedio de Alcance por Criterio",
          "tooltip": "Alcance / Criterios Enviados"
        }
      },
      "charts": {
        "impressions": {
          "title": "Impresiones a lo Largo del Tiempo",
          "legend": "Impresiones"
        },
        "campaigns": {
          "title": "Criterios vs Criterios Enviados",
          "legendCampaigns": "Criterios",
          "legendCampaignsSent": "Criterios Enviados"
        },
        "period": "Últimos {{months}} meses"
      },
      "export_kpis": "Exportar KPIs",
      "export_charts": "Exportar Gráficos"
    },
    "campaigns_page": {
      "title": "Criterios",
      "upsert_campaign_modal": {
        "create_trigger": "Crear Criterio",
        "create_title": "Crear Criterio de Palabra Clave",
        "create_loading_message": "Creando criterio...",
        "create_error_message": "¡Error! No se pudo crear el criterio",
        "create_success_message": "Criterio creado",
        "update_trigger": "Actualizar Criterio",
        "update_title": "Actualizar Criterio de Palabra Clave",
        "update_loading_message": "Actualizando criterio...",
        "update_error_message": "¡Error! No se pudo actualizar el criterio",
        "update_success_message": "Criterio actualizado",
        "name": "Nombre del Criterio",
        "description": "Descripción",
        "conditions": "Condiciones del Criterio",
        "conditions_description": "Si se cumple alguna de las expresiones siguientes, se activará el criterio.",
        "add_condition_tooltip": "Agregar Condición",
        "delete_condition_tooltip": "Eliminar Condición"
      },
      "delete_campaign_modal": {
        "trigger": "Eliminar Criterio",
        "title": "Eliminar Criterio",
        "description": "¿Estás seguro de que quieres eliminar este criterio?",
        "confirm": "Sí, eliminar",
        "success_message": "Criterio eliminado",
        "error_message": "No se pudo eliminar el criterio",
        "loading_message": "Eliminando criterio..."
      },
      "cols": {
        "name": "Nombre del Criterio",
        "description": "Descripción",
        "conditions": "Condiciones",
        "created_at": "Creado el",
        "updated_at": "Actualizado el",
        "enabled": "Activado"
      },
      "stop_tracking_campaign_modal": {
        "title": "Dejar de Rastrear Criterio",
        "description": "¿Estás seguro de que quieres dejar de rastrear este criterio de palabras clave?",
        "submit": "Sí"
      },
      "toggle_campaign": {
        "enabled_success_message": "Se reanudó el rastreo del criterio",
        "disabled_success_message": "Se detuvo el rastreo del criterio",
        "error_message": "No se pudo actualizar el criterio"
      },
      "search_campaigns_placeholder": "Buscar criterios..."
    },
    "occurrences_page": {
      "title": "Ocurrencias",
      "date_range": "Fecha de Creación del Registro",
      "yes": "Sí",
      "no": "No",
      "cols": {
        "created_at": "Creado el",
        "campaign_name": "Nombre del Criterio",
        "campaign_id": "ID del Criterio",
        "content": "Mensaje",
        "matched_keywords": "Palabras Clave Coincidentes",
        "sender": "Remitente",
        "sender_phone": "Teléfono del Remitente",
        "receiver": "Receptor",
        "recipient_phone": "Teléfono del Receptor",
        "is_group": "Es Grupo"
      }
    }
  },
  "search_accounts": {
    "search_accounts": "Buscar Cuentas",
    "create_new_account": "Crear Nueva Cuenta",
    "create_new_account_success": "Se creó la cuenta exitosamente: {{accountName}}",
    "create_new_account_error": "No se pudo crear la cuenta",
    "change_account_name": "Cambiar Nombre de la Cuenta",
    "change_account_name_success": "Se cambió exitosamente el nombre de la cuenta a: {{accountName}}",
    "change_account_name_error": "No se pudo cambiar el nombre de la cuenta"
  },
  "surveillance_page": {
    "title": "Surveillance",
    "tabs": {
      "policies": "Políticas",
      "rules": "Reglas",
      "incidents": "Incidentes"
    },
    "create_policy": "Crear Política",
    "create_rule": "Crear Regla",
    "update_policy": "Editar Política",
    "update_rule": "Editar Regla",
    "delete_policy": "Eliminar Política",
    "delete_policy_modal_message": "¿Estás seguro de que deseas eliminar esta política?",
    "delete_rule": "Eliminar Regla",
    "delete_rule_modal_message": "¿Estás seguro de que deseas eliminar esta regla?",
    "rule_in_use": "Regla en Uso",
    "rule_in_use_description": "Esta regla se está utilizando en las siguientes políticas: {{policies}}",
    "incident_header": "Incidente de Surveillance",
    "builder": {
      "create_title": "Crear Política de Surveillance",
      "edit_title": "Editar Política de Surveillance",
      "rules": {
        "title": "Reglas de Surveillance"
      }
    }
  },
  "field_is_required": "El campo es obligatorio",
  "im_templates": {
    "title": "Plantillas",
    "create_template": "Nueva Plantilla",
    "edit_template": "Editar Plantilla",
    "delete_template": "Eliminar Plantilla",
    "delete_template_confirm": "¿Está seguro de que desea eliminar esta plantilla?",
    "name": "Nombre",
    "content": "Mensaje",
    "status": "Estado",
    "status_active": "Activo",
    "status_stopped": "Detenido",
    "created_at": "Creado el",
    "updated_at": "Actualizado el",
    "attachments": "Archivos adjuntos",
    "attachment_size_error": "El tamaño total de los archivos adjuntos no debe superar 10MB"
  },
  "branding_page": {
    "name": "Nombre",
    "priority": "Prioridad",
    "create_branding": "Añadir marca",
    "update_branding": "Editar marca",
    "delete_branding": "Eliminar marca",
    "delete_branding_modal_message": "¿Seguro que quieres eliminar esta marca?",
    "new_branding_title": "Nueva marca",
    "edit_branding_title": "Editar marca",
    "identity_everyone": "Todos",
    "summary_title": "Marca",
    "summary_logo_set": "Logotipo configurado",
    "section_details_title": "Detalles",
    "section_details_desc": "Nombra esta marca.",
    "section_identity_title": "Identidad",
    "section_identity_desc": "Aplicar a todos, o limitar a grupos o usuarios específicos.",
    "section_title": "Marca",
    "section_desc": "Personaliza el logotipo, el nombre de la empresa y el fondo mostrados en la página de inicio para esta identidad.",
    "company_name": "Nombre de la empresa",
    "company_name_placeholder": "p. ej. Acme Corp (se muestra cuando no hay logotipo)",
    "company_name_help": "Se usa como marca denominativa de la página de inicio solo cuando no hay logotipo. Si agregas un logotipo abajo, reemplaza el nombre de la empresa en la nueva pestaña.",
    "logo": "Logotipo",
    "logo_remove": "Quitar",
    "logo_upload": "Subir logotipo",
    "logo_uploading": "Subiendo…",
    "logo_help": "Tuvis almacena el archivo y lo entrega a los navegadores de sus usuarios.",
    "logo_drop_hint": "Arrastre una imagen aquí, o haga clic para buscarla",
    "logo_formats": "PNG, JPG, WEBP, GIF o SVG · hasta 1 MB",
    "logo_replace": "Reemplazar",
    "logo_preview_caption": "Vista previa: cómo aparece en la página de inicio",
    "logo_bad_type": "Ese tipo de archivo no es compatible. Use PNG, JPG, WEBP, GIF o SVG.",
    "logo_too_large": "Esa imagen supera 1 MB. Suba un archivo más pequeño.",
    "logo_upload_failed": "No se pudo subir la imagen. Inténtelo de nuevo.",
    "background": "Fondo",
    "background_placeholder": "#0b1220 o https://…/imagen.jpg",
    "required": "Obligatorio",
    "save": "Guardar",
    "cancel": "Cancelar"
  },
  "block_page_tab": {
    "name": "Nombre",
    "priority": "Prioridad",
    "create_block_page": "Añadir página de bloqueo",
    "update_block_page": "Editar página de bloqueo",
    "delete_block_page": "Eliminar página de bloqueo",
    "delete_block_page_modal_message": "¿Seguro que quieres eliminar esta página de bloqueo?",
    "new_block_page_title": "Nueva página de bloqueo",
    "edit_block_page_title": "Editar página de bloqueo",
    "identity_everyone": "Todos",
    "summary_title": "Página de bloqueo",
    "section_details_title": "Detalles",
    "section_details_desc": "Nombra esta página de bloqueo.",
    "section_identity_title": "Identidad",
    "section_identity_desc": "Aplicar a todos, o limitar a grupos o usuarios específicos.",
    "section_title": "Página de bloqueo",
    "section_desc": "Contenido que se muestra a los usuarios cuando Tuvis Browser bloquea una navegación.",
    "heading": "Título",
    "heading_placeholder": "p. ej. Este sitio está bloqueado",
    "message": "Mensaje",
    "message_placeholder": "p. ej. El acceso a este sitio está restringido por la política de tu organización.",
    "contact": "Contacto",
    "contact_placeholder": "admin@example.com o https://…",
    "required": "Obligatorio",
    "save": "Guardar",
    "cancel": "Cancelar"
  },
  "access_requests_page": {
    "title": "Solicitudes de acceso",
    "col_requester": "Solicitante",
    "col_host": "Host",
    "col_note": "Nota",
    "col_created": "Solicitado",
    "col_actions": "Acciones",
    "allow": "Permitir",
    "requester_count_one": "{{count}} persona",
    "requester_count_other": "{{count}} personas",
    "allow_for_requesters_one": "Permitir {{target}} - para este solicitante",
    "allow_for_requesters_other": "Permitir {{target}} - para estos {{count}} solicitantes",
    "allow_for_everyone": "Permitir {{target}} - para todos",
    "allow_in_builder": "Abrir en el editor de políticas…",
    "granted_policy_name": "{{target}} - solicitud aprobada",
    "granted_toast_everyone": "Se permitió {{target}} para todos.",
    "granted_toast_requesters_one": "Se permitió {{target}} para este solicitante.",
    "granted_toast_requesters_other": "Se permitió {{target}} para estos {{count}} solicitantes.",
    "granted_toast_edit": "Editar política",
    "confirm_grant_title": "¿Permitir esta solicitud?",
    "confirm_grant_everyone": "Se creará una política de acceso que permite {{target}} para todos y la solicitud quedará aprobada.",
    "confirm_grant_requesters_one": "Se creará una política de acceso que permite {{target}} para este solicitante y la solicitud quedará aprobada.",
    "confirm_grant_requesters_other": "Se creará una política de acceso que permite {{target}} para estos {{count}} solicitantes y las solicitudes quedarán aprobadas.",
    "confirm_grant_ok": "Permitir",
    "confirm_dismiss_title": "¿Descartar esta solicitud?",
    "confirm_dismiss_body_one": "{{target}} seguirá bloqueado para el solicitante. No se le informará de que la solicitud fue descartada.",
    "confirm_dismiss_body_other": "{{target}} seguirá bloqueado para los {{count}} solicitantes. No se les informará de que la solicitud fue descartada.",
    "confirm_dismiss_ok": "Descartar",
    "log": "Registro",
    "refresh": "Actualizar",
    "dismiss": "Descartar",
    "status_pending": "Pendiente",
    "status_approved": "Aprobado",
    "status_dismissed": "Descartado"
  },
  "minimum_letters": "Mínimo {{minimumLettersToSearch}} letras",
  "archive_teams_settings_page": {
    "title": "Archivar mensajes de Teams",
    "description": "Conecta tu tenant de Microsoft Teams para archivar todos los mensajes de chat. Los mensajes se capturan en tiempo real mediante suscripciones de Microsoft Graph.",
    "connect_button": "Activar archivado",
    "disconnect_button": "Desactivar archivado",
    "connecting": "Conectando...",
    "connection_failed": "No se pudo activar el archivado de Teams",
    "connected_success": "Archivado de Teams activado correctamente",
    "certificate_required": "Primero genera un certificado",
    "download_certificate_failed": "No se pudo descargar el certificado",
    "step1_certificate": "Paso 1: descargar el certificado",
    "step1_description": "Descarga un certificado para la autenticación segura con Microsoft Azure. Súbelo a tu App Registration de Azure en Certificates & Secrets. Asegúrate de que la aplicación tenga el permiso de aplicación Chat.Read.All con consentimiento del administrador.",
    "download_certificate": "Descargar certificado",
    "step2_azure_config": "Paso 2: configuración de Azure",
    "step2_description": "Introduce los datos de tu App Registration de Azure. La aplicación debe tener el permiso Chat.Read.All concedido con consentimiento del administrador.",
    "client_id": "ID de aplicación (cliente)",
    "client_id_placeholder": "Introduce el ID de aplicación (cliente) de Azure",
    "tenant_id": "ID de directorio (tenant)",
    "tenant_id_placeholder": "Introduce el ID de directorio (tenant) de Azure",
    "installed": {
      "title": "El archivado de Teams está activo",
      "description": "Los mensajes de chat de Teams se están archivando en tiempo real.",
      "subscription_expires": "La suscripción se renueva automáticamente (caducidad actual: {{date}})"
    },
    "uninstall_modal": {
      "title": "Desactivar el archivado de Teams",
      "description": "¿Seguro que quieres desactivar el archivado de mensajes de Teams? Se eliminará la suscripción del webhook.",
      "warning": "Los mensajes archivados se conservarán, pero no se capturarán mensajes nuevos.",
      "confirm": "Desactivar archivado",
      "cancel": "Cancelar",
      "success": "Archivado de Teams desactivado correctamente",
      "error": "No se pudo desactivar el archivado de Teams"
    }
  },
  "default_channels": {
    "whatsapp-web": "WhatsApp (aplicación de escritorio Tuvis)",
    "imessage": "iMessage",
    "telegram": "Telegram"
  }
}
